/*!
 * Masonry PACKAGED v4.0.0
 * Cascading grid layout library
 * http://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

!function(t,e){"use strict";"function"==typeof define&&define.amd?define("jquery-bridget/jquery-bridget",["jquery"],function(i){e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("jquery")):t.jQueryBridget=e(t,t.jQuery)}(window,function(t,e){"use strict";function i(i,r,a){function h(t,e,n){var o,r="$()."+i+'("'+e+'")';return t.each(function(t,h){var u=a.data(h,i);if(!u)return void s(i+" not initialized. Cannot call methods, i.e. "+r);var d=u[e];if(!d||"_"==e.charAt(0))return void s(r+" is not a valid method");var c=d.apply(u,n);o=void 0===o?c:o}),void 0!==o?o:t}function u(t,e){t.each(function(t,n){var o=a.data(n,i);o?(o.option(e),o._init()):(o=new r(n,e),a.data(n,i,o))})}a=a||e||t.jQuery,a&&(r.prototype.option||(r.prototype.option=function(t){a.isPlainObject(t)&&(this.options=a.extend(!0,this.options,t))}),a.fn[i]=function(t){if("string"==typeof t){var e=o.call(arguments,1);return h(this,t,e)}return u(this,t),this},n(a))}function n(t){!t||t&&t.bridget||(t.bridget=i)}var o=Array.prototype.slice,r=t.console,s="undefined"==typeof r?function(){}:function(t){r.error(t)};return n(e||t.jQuery),i}),function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}(this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},n=i[t]=i[t]||[];return-1==n.indexOf(e)&&n.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{},n=i[t]=i[t]||[];return n[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=i.indexOf(e);return-1!=n&&i.splice(n,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=0,o=i[n];e=e||[];for(var r=this._onceEvents&&this._onceEvents[t];o;){var s=r&&r[o];s&&(this.off(t,o),delete r[o]),o.apply(this,e),n+=s?0:1,o=i[n]}return this}},t}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("get-size/get-size",[],function(){return e()}):"object"==typeof module&&module.exports?module.exports=e():t.getSize=e()}(window,function(){"use strict";function t(t){var e=parseFloat(t),i=-1==t.indexOf("%")&&!isNaN(e);return i&&e}function e(){}function i(){for(var t={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},e=0;u>e;e++){var i=h[e];t[i]=0}return t}function n(t){var e=getComputedStyle(t);return e||a("Style returned "+e+". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"),e}function o(){if(!d){d=!0;var e=document.createElement("div");e.style.width="200px",e.style.padding="1px 2px 3px 4px",e.style.borderStyle="solid",e.style.borderWidth="1px 2px 3px 4px",e.style.boxSizing="border-box";var i=document.body||document.documentElement;i.appendChild(e);var o=n(e);r.isBoxSizeOuter=s=200==t(o.width),i.removeChild(e)}}function r(e){if(o(),"string"==typeof e&&(e=document.querySelector(e)),e&&"object"==typeof e&&e.nodeType){var r=n(e);if("none"==r.display)return i();var a={};a.width=e.offsetWidth,a.height=e.offsetHeight;for(var d=a.isBorderBox="border-box"==r.boxSizing,c=0;u>c;c++){var l=h[c],f=r[l],m=parseFloat(f);a[l]=isNaN(m)?0:m}var p=a.paddingLeft+a.paddingRight,g=a.paddingTop+a.paddingBottom,y=a.marginLeft+a.marginRight,v=a.marginTop+a.marginBottom,_=a.borderLeftWidth+a.borderRightWidth,E=a.borderTopWidth+a.borderBottomWidth,z=d&&s,b=t(r.width);b!==!1&&(a.width=b+(z?0:p+_));var x=t(r.height);return x!==!1&&(a.height=x+(z?0:g+E)),a.innerWidth=a.width-(p+_),a.innerHeight=a.height-(g+E),a.outerWidth=a.width+y,a.outerHeight=a.height+v,a}}var s,a="undefined"==typeof console?e:function(t){console.error(t)},h=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"],u=h.length,d=!1;return r}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("matches-selector/matches-selector",e):"object"==typeof module&&module.exports?module.exports=e():t.matchesSelector=e()}(window,function(){"use strict";var t=function(){var t=Element.prototype;if(t.matches)return"matches";if(t.matchesSelector)return"matchesSelector";for(var e=["webkit","moz","ms","o"],i=0;i<e.length;i++){var n=e[i],o=n+"MatchesSelector";if(t[o])return o}}();return function(e,i){return e[t](i)}}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("fizzy-ui-utils/utils",["matches-selector/matches-selector"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("desandro-matches-selector")):t.fizzyUIUtils=e(t,t.matchesSelector)}(window,function(t,e){var i={};i.extend=function(t,e){for(var i in e)t[i]=e[i];return t},i.modulo=function(t,e){return(t%e+e)%e},i.makeArray=function(t){var e=[];if(Array.isArray(t))e=t;else if(t&&"number"==typeof t.length)for(var i=0;i<t.length;i++)e.push(t[i]);else e.push(t);return e},i.removeFrom=function(t,e){var i=t.indexOf(e);-1!=i&&t.splice(i,1)},i.getParent=function(t,i){for(;t!=document.body;)if(t=t.parentNode,e(t,i))return t},i.getQueryElement=function(t){return"string"==typeof t?document.querySelector(t):t},i.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},i.filterFindElements=function(t,n){t=i.makeArray(t);var o=[];return t.forEach(function(t){if(t instanceof HTMLElement){if(!n)return void o.push(t);e(t,n)&&o.push(t);for(var i=t.querySelectorAll(n),r=0;r<i.length;r++)o.push(i[r])}}),o},i.debounceMethod=function(t,e,i){var n=t.prototype[e],o=e+"Timeout";t.prototype[e]=function(){var t=this[o];t&&clearTimeout(t);var e=arguments,r=this;this[o]=setTimeout(function(){n.apply(r,e),delete r[o]},i||100)}},i.docReady=function(t){"complete"==document.readyState?t():document.addEventListener("DOMContentLoaded",t)},i.toDashed=function(t){return t.replace(/(.)([A-Z])/g,function(t,e,i){return e+"-"+i}).toLowerCase()};var n=t.console;return i.htmlInit=function(e,o){i.docReady(function(){var r=i.toDashed(o),s="data-"+r,a=document.querySelectorAll("["+s+"]"),h=document.querySelectorAll(".js-"+r),u=i.makeArray(a).concat(i.makeArray(h)),d=s+"-options",c=t.jQuery;u.forEach(function(t){var i,r=t.getAttribute(s)||t.getAttribute(d);try{i=r&&JSON.parse(r)}catch(a){return void(n&&n.error("Error parsing "+s+" on "+t.className+": "+a))}var h=new e(t,i);c&&c.data(t,o,h)})})},i}),function(t,e){"function"==typeof define&&define.amd?define("outlayer/item",["ev-emitter/ev-emitter","get-size/get-size"],function(i,n){return e(t,i,n)}):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter"),require("get-size")):(t.Outlayer={},t.Outlayer.Item=e(t,t.EvEmitter,t.getSize))}(window,function(t,e,i){"use strict";function n(t){for(var e in t)return!1;return e=null,!0}function o(t,e){t&&(this.element=t,this.layout=e,this.position={x:0,y:0},this._create())}function r(t){return t.replace(/([A-Z])/g,function(t){return"-"+t.toLowerCase()})}var s=document.documentElement.style,a="string"==typeof s.transition?"transition":"WebkitTransition",h="string"==typeof s.transform?"transform":"WebkitTransform",u={WebkitTransition:"webkitTransitionEnd",transition:"transitionend"}[a],d=[h,a,a+"Duration",a+"Property"],c=o.prototype=Object.create(e.prototype);c.constructor=o,c._create=function(){this._transn={ingProperties:{},clean:{},onEnd:{}},this.css({position:"absolute"})},c.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},c.getSize=function(){this.size=i(this.element)},c.css=function(t){var e=this.element.style;for(var i in t){var n=d[i]||i;e[n]=t[i]}},c.getPosition=function(){var t=getComputedStyle(this.element),e=this.layout._getOption("originLeft"),i=this.layout._getOption("originTop"),n=t[e?"left":"right"],o=t[i?"top":"bottom"],r=this.layout.size,s=-1!=n.indexOf("%")?parseFloat(n)/100*r.width:parseInt(n,10),a=-1!=o.indexOf("%")?parseFloat(o)/100*r.height:parseInt(o,10);s=isNaN(s)?0:s,a=isNaN(a)?0:a,s-=e?r.paddingLeft:r.paddingRight,a-=i?r.paddingTop:r.paddingBottom,this.position.x=s,this.position.y=a},c.layoutPosition=function(){var t=this.layout.size,e={},i=this.layout._getOption("originLeft"),n=this.layout._getOption("originTop"),o=i?"paddingLeft":"paddingRight",r=i?"left":"right",s=i?"right":"left",a=this.position.x+t[o];e[r]=this.getXValue(a),e[s]="";var h=n?"paddingTop":"paddingBottom",u=n?"top":"bottom",d=n?"bottom":"top",c=this.position.y+t[h];e[u]=this.getYValue(c),e[d]="",this.css(e),this.emitEvent("layout",[this])},c.getXValue=function(t){var e=this.layout._getOption("horizontal");return this.layout.options.percentPosition&&!e?t/this.layout.size.width*100+"%":t+"px"},c.getYValue=function(t){var e=this.layout._getOption("horizontal");return this.layout.options.percentPosition&&e?t/this.layout.size.height*100+"%":t+"px"},c._transitionTo=function(t,e){this.getPosition();var i=this.position.x,n=this.position.y,o=parseInt(t,10),r=parseInt(e,10),s=o===this.position.x&&r===this.position.y;if(this.setPosition(t,e),s&&!this.isTransitioning)return void this.layoutPosition();var a=t-i,h=e-n,u={};u.transform=this.getTranslate(a,h),this.transition({to:u,onTransitionEnd:{transform:this.layoutPosition},isCleaning:!0})},c.getTranslate=function(t,e){var i=this.layout._getOption("originLeft"),n=this.layout._getOption("originTop");return t=i?t:-t,e=n?e:-e,"translate3d("+t+"px, "+e+"px, 0)"},c.goTo=function(t,e){this.setPosition(t,e),this.layoutPosition()},c.moveTo=c._transitionTo,c.setPosition=function(t,e){this.position.x=parseInt(t,10),this.position.y=parseInt(e,10)},c._nonTransition=function(t){this.css(t.to),t.isCleaning&&this._removeStyles(t.to);for(var e in t.onTransitionEnd)t.onTransitionEnd[e].call(this)},c._transition=function(t){if(!parseFloat(this.layout.options.transitionDuration))return void this._nonTransition(t);var e=this._transn;for(var i in t.onTransitionEnd)e.onEnd[i]=t.onTransitionEnd[i];for(i in t.to)e.ingProperties[i]=!0,t.isCleaning&&(e.clean[i]=!0);if(t.from){this.css(t.from);var n=this.element.offsetHeight;n=null}this.enableTransition(t.to),this.css(t.to),this.isTransitioning=!0};var l="opacity,"+r(d.transform||"transform");c.enableTransition=function(){this.isTransitioning||(this.css({transitionProperty:l,transitionDuration:this.layout.options.transitionDuration}),this.element.addEventListener(u,this,!1))},c.transition=o.prototype[a?"_transition":"_nonTransition"],c.onwebkitTransitionEnd=function(t){this.ontransitionend(t)},c.onotransitionend=function(t){this.ontransitionend(t)};var f={"-webkit-transform":"transform"};c.ontransitionend=function(t){if(t.target===this.element){var e=this._transn,i=f[t.propertyName]||t.propertyName;if(delete e.ingProperties[i],n(e.ingProperties)&&this.disableTransition(),i in e.clean&&(this.element.style[t.propertyName]="",delete e.clean[i]),i in e.onEnd){var o=e.onEnd[i];o.call(this),delete e.onEnd[i]}this.emitEvent("transitionEnd",[this])}},c.disableTransition=function(){this.removeTransitionStyles(),this.element.removeEventListener(u,this,!1),this.isTransitioning=!1},c._removeStyles=function(t){var e={};for(var i in t)e[i]="";this.css(e)};var m={transitionProperty:"",transitionDuration:""};return c.removeTransitionStyles=function(){this.css(m)},c.removeElem=function(){this.element.parentNode.removeChild(this.element),this.css({display:""}),this.emitEvent("remove",[this])},c.remove=function(){return a&&parseFloat(this.layout.options.transitionDuration)?(this.once("transitionEnd",function(){this.removeElem()}),void this.hide()):void this.removeElem()},c.reveal=function(){delete this.isHidden,this.css({display:""});var t=this.layout.options,e={},i=this.getHideRevealTransitionEndProperty("visibleStyle");e[i]=this.onRevealTransitionEnd,this.transition({from:t.hiddenStyle,to:t.visibleStyle,isCleaning:!0,onTransitionEnd:e})},c.onRevealTransitionEnd=function(){this.isHidden||this.emitEvent("reveal")},c.getHideRevealTransitionEndProperty=function(t){var e=this.layout.options[t];if(e.opacity)return"opacity";for(var i in e)return i},c.hide=function(){this.isHidden=!0,this.css({display:""});var t=this.layout.options,e={},i=this.getHideRevealTransitionEndProperty("hiddenStyle");e[i]=this.onHideTransitionEnd,this.transition({from:t.visibleStyle,to:t.hiddenStyle,isCleaning:!0,onTransitionEnd:e})},c.onHideTransitionEnd=function(){this.isHidden&&(this.css({display:"none"}),this.emitEvent("hide"))},c.destroy=function(){this.css({position:"",left:"",right:"",top:"",bottom:"",transition:"",transform:""})},o}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("outlayer/outlayer",["ev-emitter/ev-emitter","get-size/get-size","fizzy-ui-utils/utils","./item"],function(i,n,o,r){return e(t,i,n,o,r)}):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter"),require("get-size"),require("fizzy-ui-utils"),require("./item")):t.Outlayer=e(t,t.EvEmitter,t.getSize,t.fizzyUIUtils,t.Outlayer.Item)}(window,function(t,e,i,n,o){"use strict";function r(t,e){var i=n.getQueryElement(t);if(!i)return void(a&&a.error("Bad element for "+this.constructor.namespace+": "+(i||t)));this.element=i,h&&(this.$element=h(this.element)),this.options=n.extend({},this.constructor.defaults),this.option(e);var o=++d;this.element.outlayerGUID=o,c[o]=this,this._create();var r=this._getOption("initLayout");r&&this.layout()}function s(t){function e(){t.apply(this,arguments)}return e.prototype=Object.create(t.prototype),e.prototype.constructor=e,e}var a=t.console,h=t.jQuery,u=function(){},d=0,c={};r.namespace="outlayer",r.Item=o,r.defaults={containerStyle:{position:"relative"},initLayout:!0,originLeft:!0,originTop:!0,resize:!0,resizeContainer:!0,transitionDuration:"0.4s",hiddenStyle:{opacity:0,transform:"scale(0.001)"},visibleStyle:{opacity:1,transform:"scale(1)"}};var l=r.prototype;return n.extend(l,e.prototype),l.option=function(t){n.extend(this.options,t)},l._getOption=function(t){var e=this.constructor.compatOptions[t];return e&&void 0!==this.options[e]?this.options[e]:this.options[t]},r.compatOptions={initLayout:"isInitLayout",horizontal:"isHorizontal",layoutInstant:"isLayoutInstant",originLeft:"isOriginLeft",originTop:"isOriginTop",resize:"isResizeBound",resizeContainer:"isResizingContainer"},l._create=function(){this.reloadItems(),this.stamps=[],this.stamp(this.options.stamp),n.extend(this.element.style,this.options.containerStyle);var t=this._getOption("resize");t&&this.bindResize()},l.reloadItems=function(){this.items=this._itemize(this.element.children)},l._itemize=function(t){for(var e=this._filterFindItemElements(t),i=this.constructor.Item,n=[],o=0;o<e.length;o++){var r=e[o],s=new i(r,this);n.push(s)}return n},l._filterFindItemElements=function(t){return n.filterFindElements(t,this.options.itemSelector)},l.getItemElements=function(){return this.items.map(function(t){return t.element})},l.layout=function(){this._resetLayout(),this._manageStamps();var t=this._getOption("layoutInstant"),e=void 0!==t?t:!this._isLayoutInited;this.layoutItems(this.items,e),this._isLayoutInited=!0},l._init=l.layout,l._resetLayout=function(){this.getSize()},l.getSize=function(){this.size=i(this.element)},l._getMeasurement=function(t,e){var n,o=this.options[t];o?("string"==typeof o?n=this.element.querySelector(o):o instanceof HTMLElement&&(n=o),this[t]=n?i(n)[e]:o):this[t]=0},l.layoutItems=function(t,e){t=this._getItemsForLayout(t),this._layoutItems(t,e),this._postLayout()},l._getItemsForLayout=function(t){return t.filter(function(t){return!t.isIgnored})},l._layoutItems=function(t,e){if(this._emitCompleteOnItems("layout",t),t&&t.length){var i=[];t.forEach(function(t){var n=this._getItemLayoutPosition(t);n.item=t,n.isInstant=e||t.isLayoutInstant,i.push(n)},this),this._processLayoutQueue(i)}},l._getItemLayoutPosition=function(){return{x:0,y:0}},l._processLayoutQueue=function(t){t.forEach(function(t){this._positionItem(t.item,t.x,t.y,t.isInstant)},this)},l._positionItem=function(t,e,i,n){n?t.goTo(e,i):t.moveTo(e,i)},l._postLayout=function(){this.resizeContainer()},l.resizeContainer=function(){var t=this._getOption("resizeContainer");if(t){var e=this._getContainerSize();e&&(this._setContainerMeasure(e.width,!0),this._setContainerMeasure(e.height,!1))}},l._getContainerSize=u,l._setContainerMeasure=function(t,e){if(void 0!==t){var i=this.size;i.isBorderBox&&(t+=e?i.paddingLeft+i.paddingRight+i.borderLeftWidth+i.borderRightWidth:i.paddingBottom+i.paddingTop+i.borderTopWidth+i.borderBottomWidth),t=Math.max(t,0),this.element.style[e?"width":"height"]=t+"px"}},l._emitCompleteOnItems=function(t,e){function i(){o.dispatchEvent(t+"Complete",null,[e])}function n(){s++,s==r&&i()}var o=this,r=e.length;if(!e||!r)return void i();var s=0;e.forEach(function(e){e.once(t,n)})},l.dispatchEvent=function(t,e,i){var n=e?[e].concat(i):i;if(this.emitEvent(t,n),h)if(this.$element=this.$element||h(this.element),e){var o=h.Event(e);o.type=t,this.$element.trigger(o,i)}else this.$element.trigger(t,i)},l.ignore=function(t){var e=this.getItem(t);e&&(e.isIgnored=!0)},l.unignore=function(t){var e=this.getItem(t);e&&delete e.isIgnored},l.stamp=function(t){t=this._find(t),t&&(this.stamps=this.stamps.concat(t),t.forEach(this.ignore,this))},l.unstamp=function(t){t=this._find(t),t&&t.forEach(function(t){n.removeFrom(this.stamps,t),this.unignore(t)},this)},l._find=function(t){return t?("string"==typeof t&&(t=this.element.querySelectorAll(t)),t=n.makeArray(t)):void 0},l._manageStamps=function(){this.stamps&&this.stamps.length&&(this._getBoundingRect(),this.stamps.forEach(this._manageStamp,this))},l._getBoundingRect=function(){var t=this.element.getBoundingClientRect(),e=this.size;this._boundingRect={left:t.left+e.paddingLeft+e.borderLeftWidth,top:t.top+e.paddingTop+e.borderTopWidth,right:t.right-(e.paddingRight+e.borderRightWidth),bottom:t.bottom-(e.paddingBottom+e.borderBottomWidth)}},l._manageStamp=u,l._getElementOffset=function(t){var e=t.getBoundingClientRect(),n=this._boundingRect,o=i(t),r={left:e.left-n.left-o.marginLeft,top:e.top-n.top-o.marginTop,right:n.right-e.right-o.marginRight,bottom:n.bottom-e.bottom-o.marginBottom};return r},l.handleEvent=n.handleEvent,l.bindResize=function(){t.addEventListener("resize",this),this.isResizeBound=!0},l.unbindResize=function(){t.removeEventListener("resize",this),this.isResizeBound=!1},l.onresize=function(){this.resize()},n.debounceMethod(r,"onresize",100),l.resize=function(){this.isResizeBound&&this.needsResizeLayout()&&this.layout()},l.needsResizeLayout=function(){var t=i(this.element),e=this.size&&t;return e&&t.innerWidth!==this.size.innerWidth},l.addItems=function(t){var e=this._itemize(t);return e.length&&(this.items=this.items.concat(e)),e},l.appended=function(t){var e=this.addItems(t);e.length&&(this.layoutItems(e,!0),this.reveal(e))},l.prepended=function(t){var e=this._itemize(t);if(e.length){var i=this.items.slice(0);this.items=e.concat(i),this._resetLayout(),this._manageStamps(),this.layoutItems(e,!0),this.reveal(e),this.layoutItems(i)}},l.reveal=function(t){this._emitCompleteOnItems("reveal",t),t&&t.length&&t.forEach(function(t){t.reveal()})},l.hide=function(t){this._emitCompleteOnItems("hide",t),t&&t.length&&t.forEach(function(t){t.hide()})},l.revealItemElements=function(t){var e=this.getItems(t);this.reveal(e)},l.hideItemElements=function(t){var e=this.getItems(t);this.hide(e)},l.getItem=function(t){for(var e=0;e<this.items.length;e++){var i=this.items[e];if(i.element==t)return i}},l.getItems=function(t){t=n.makeArray(t);var e=[];return t.forEach(function(t){var i=this.getItem(t);i&&e.push(i)},this),e},l.remove=function(t){var e=this.getItems(t);this._emitCompleteOnItems("remove",e),e&&e.length&&e.forEach(function(t){t.remove(),n.removeFrom(this.items,t)},this)},l.destroy=function(){var t=this.element.style;t.height="",t.position="",t.width="",this.items.forEach(function(t){t.destroy()}),this.unbindResize();var e=this.element.outlayerGUID;delete c[e],delete this.element.outlayerGUID,h&&h.removeData(this.element,this.constructor.namespace)},r.data=function(t){t=n.getQueryElement(t);var e=t&&t.outlayerGUID;return e&&c[e]},r.create=function(t,e){var i=s(r);return i.defaults=n.extend({},r.defaults),n.extend(i.defaults,e),i.compatOptions=n.extend({},r.compatOptions),i.namespace=t,i.data=r.data,i.Item=s(o),n.htmlInit(i,t),h&&h.bridget&&h.bridget(t,i),i},r.Item=o,r}),function(t,e){"function"==typeof define&&define.amd?define(["outlayer/outlayer","get-size/get-size"],e):"object"==typeof module&&module.exports?module.exports=e(require("outlayer"),require("get-size")):t.Masonry=e(t.Outlayer,t.getSize)}(window,function(t,e){var i=t.create("masonry");return i.compatOptions.fitWidth="isFitWidth",i.prototype._resetLayout=function(){this.getSize(),this._getMeasurement("columnWidth","outerWidth"),this._getMeasurement("gutter","outerWidth"),this.measureColumns(),this.colYs=[];for(var t=0;t<this.cols;t++)this.colYs.push(0);this.maxY=0},i.prototype.measureColumns=function(){if(this.getContainerWidth(),!this.columnWidth){var t=this.items[0],i=t&&t.element;this.columnWidth=i&&e(i).outerWidth||this.containerWidth}var n=this.columnWidth+=this.gutter,o=this.containerWidth+this.gutter,r=o/n,s=n-o%n,a=s&&1>s?"round":"floor";r=Math[a](r),this.cols=Math.max(r,1)},i.prototype.getContainerWidth=function(){var t=this._getOption("fitWidth"),i=t?this.element.parentNode:this.element,n=e(i);this.containerWidth=n&&n.innerWidth},i.prototype._getItemLayoutPosition=function(t){t.getSize();var e=t.size.outerWidth%this.columnWidth,i=e&&1>e?"round":"ceil",n=Math[i](t.size.outerWidth/this.columnWidth);n=Math.min(n,this.cols);for(var o=this._getColGroup(n),r=Math.min.apply(Math,o),s=o.indexOf(r),a={x:this.columnWidth*s,y:r},h=r+t.size.outerHeight,u=this.cols+1-o.length,d=0;u>d;d++)this.colYs[s+d]=h;return a},i.prototype._getColGroup=function(t){if(2>t)return this.colYs;for(var e=[],i=this.cols+1-t,n=0;i>n;n++){var o=this.colYs.slice(n,n+t);e[n]=Math.max.apply(Math,o)}return e},i.prototype._manageStamp=function(t){var i=e(t),n=this._getElementOffset(t),o=this._getOption("originLeft"),r=o?n.left:n.right,s=r+i.outerWidth,a=Math.floor(r/this.columnWidth);a=Math.max(0,a);var h=Math.floor(s/this.columnWidth);h-=s%this.columnWidth?0:1,h=Math.min(this.cols-1,h);for(var u=this._getOption("originTop"),d=(u?n.top:n.bottom)+i.outerHeight,c=a;h>=c;c++)this.colYs[c]=Math.max(d,this.colYs[c])},i.prototype._getContainerSize=function(){this.maxY=Math.max.apply(Math,this.colYs);var t={height:this.maxY};return this._getOption("fitWidth")&&(t.width=this._getContainerFitWidth()),t},i.prototype._getContainerFitWidth=function(){for(var t=0,e=this.cols;--e&&0===this.colYs[e];)t++;return(this.cols-t)*this.columnWidth-this.gutter},i.prototype.needsResizeLayout=function(){var t=this.containerWidth;return this.getContainerWidth(),t!=this.containerWidth},i});
/*!
 * Masonry PACKAGED v4.0.0
 * Cascading grid layout library
 * http://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

/**
 * Bridget makes jQuery widgets
 * v2.0.0
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  'use strict';
  /* globals define: false, module: false, require: false */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'jquery-bridget/jquery-bridget',[ 'jquery' ], function( jQuery ) {
      factory( window, jQuery );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('jquery')
    );
  } else {
    // browser global
    window.jQueryBridget = factory(
      window,
      window.jQuery
    );
  }

}( window, function factory( window, jQuery ) {
'use strict';

// ----- utils ----- //

var arraySlice = Array.prototype.slice;

// helper function for logging errors
// $.error breaks jQuery chaining
var console = window.console;
var logError = typeof console == 'undefined' ? function() {} :
  function( message ) {
    console.error( message );
  };

// ----- jQueryBridget ----- //

function jQueryBridget( namespace, PluginClass, $ ) {
  $ = $ || jQuery || window.jQuery;
  if ( !$ ) {
    return;
  }

  // add option method -> $().plugin('option', {...})
  if ( !PluginClass.prototype.option ) {
    // option setter
    PluginClass.prototype.option = function( opts ) {
      // bail out if not an object
      if ( !$.isPlainObject( opts ) ){
        return;
      }
      this.options = $.extend( true, this.options, opts );
    };
  }

  // make jQuery plugin
  $.fn[ namespace ] = function( arg0 /*, arg1 */ ) {
    if ( typeof arg0 == 'string' ) {
      // method call $().plugin( 'methodName', { options } )
      // shift arguments by 1
      var args = arraySlice.call( arguments, 1 );
      return methodCall( this, arg0, args );
    }
    // just $().plugin({ options })
    plainCall( this, arg0 );
    return this;
  };

  // $().plugin('methodName')
  function methodCall( $elems, methodName, args ) {
    var returnValue;
    var pluginMethodStr = '$().' + namespace + '("' + methodName + '")';

    $elems.each( function( i, elem ) {
      // get instance
      var instance = $.data( elem, namespace );
      if ( !instance ) {
        logError( namespace + ' not initialized. Cannot call methods, i.e. ' +
          pluginMethodStr );
        return;
      }

      var method = instance[ methodName ];
      if ( !method || methodName.charAt(0) == '_' ) {
        logError( pluginMethodStr + ' is not a valid method' );
        return;
      }

      // apply method, get return value
      var value = method.apply( instance, args );
      // set return value if value is returned, use only first value
      returnValue = returnValue === undefined ? value : returnValue;
    });

    return returnValue !== undefined ? returnValue : $elems;
  }

  function plainCall( $elems, options ) {
    $elems.each( function( i, elem ) {
      var instance = $.data( elem, namespace );
      if ( instance ) {
        // set options & init
        instance.option( options );
        instance._init();
      } else {
        // initialize new instance
        instance = new PluginClass( elem, options );
        $.data( elem, namespace, instance );
      }
    });
  }

  updateJQuery( $ );

}

// ----- updateJQuery ----- //

// set $.bridget for v1 backwards compatibility
function updateJQuery( $ ) {
  if ( !$ || ( $ && $.bridget ) ) {
    return;
  }
  $.bridget = jQueryBridget;
}

updateJQuery( jQuery || window.jQuery );

// -----  ----- //

return jQueryBridget;

}));

/**
 * EvEmitter v1.0.1
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( 'ev-emitter/ev-emitter',factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( this, function() {



function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners array
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || [];
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var i = 0;
  var listener = listeners[i];
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  while ( listener ) {
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
    // get next listener
    i += isOnce ? 0 : 1;
    listener = listeners[i];
  }

  return this;
};

return EvEmitter;

}));

/*!
 * getSize v2.0.2
 * measure size of elements
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */
/*global define: false, module: false, console: false */

( function( window, factory ) {
  'use strict';

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'get-size/get-size',[],function() {
      return factory();
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See http://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * WebKit measures the outer-width on style.width on border-box elems
   * IE & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );

  getSize.isBoxSizeOuter = isBoxSizeOuter = getStyleSize( style.width ) == 200;
  body.removeChild( div );

}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});

/**
 * matchesSelector v2.0.1
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  /*global define: false, module: false */
  'use strict';
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'matches-selector/matches-selector',factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.matchesSelector = factory();
  }

}( window, function factory() {
  'use strict';

  var matchesMethod = ( function() {
    var ElemProto = Element.prototype;
    // check for the standard method name first
    if ( ElemProto.matches ) {
      return 'matches';
    }
    // check un-prefixed
    if ( ElemProto.matchesSelector ) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

    for ( var i=0; i < prefixes.length; i++ ) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if ( ElemProto[ method ] ) {
        return method;
      }
    }
  })();

  return function matchesSelector( elem, selector ) {
    return elem[ matchesMethod ]( selector );
  };

}));

/**
 * Fizzy UI utils v2.0.0
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  /*global define: false, module: false, require: false */
  'use strict';
  // universal module definition

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'fizzy-ui-utils/utils',[
      'matches-selector/matches-selector'
    ], function( matchesSelector ) {
      return factory( window, matchesSelector );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('desandro-matches-selector')
    );
  } else {
    // browser global
    window.fizzyUIUtils = factory(
      window,
      window.matchesSelector
    );
  }

}( window, function factory( window, matchesSelector ) {



var utils = {};

// ----- extend ----- //

// extends objects
utils.extend = function( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
};

// ----- modulo ----- //

utils.modulo = function( num, div ) {
  return ( ( num % div ) + div ) % div;
};

// ----- makeArray ----- //

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
  var ary = [];
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    ary = obj;
  } else if ( obj && typeof obj.length == 'number' ) {
    // convert nodeList to array
    for ( var i=0; i < obj.length; i++ ) {
      ary.push( obj[i] );
    }
  } else {
    // array of single index
    ary.push( obj );
  }
  return ary;
};

// ----- removeFrom ----- //

utils.removeFrom = function( ary, obj ) {
  var index = ary.indexOf( obj );
  if ( index != -1 ) {
    ary.splice( index, 1 );
  }
};

// ----- getParent ----- //

utils.getParent = function( elem, selector ) {
  while ( elem != document.body ) {
    elem = elem.parentNode;
    if ( matchesSelector( elem, selector ) ) {
      return elem;
    }
  }
};

// ----- getQueryElement ----- //

// use element as selector string
utils.getQueryElement = function( elem ) {
  if ( typeof elem == 'string' ) {
    return document.querySelector( elem );
  }
  return elem;
};

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// ----- filterFindElements ----- //

utils.filterFindElements = function( elems, selector ) {
  // make array of elems
  elems = utils.makeArray( elems );
  var ffElems = [];

  elems.forEach( function( elem ) {
    // check that elem is an actual element
    if ( !( elem instanceof HTMLElement ) ) {
      return;
    }
    // add elem if no selector
    if ( !selector ) {
      ffElems.push( elem );
      return;
    }
    // filter & find items if we have a selector
    // filter
    if ( matchesSelector( elem, selector ) ) {
      ffElems.push( elem );
    }
    // find children
    var childElems = elem.querySelectorAll( selector );
    // concat childElems to filterFound array
    for ( var i=0; i < childElems.length; i++ ) {
      ffElems.push( childElems[i] );
    }
  });

  return ffElems;
};

// ----- debounceMethod ----- //

utils.debounceMethod = function( _class, methodName, threshold ) {
  // original method
  var method = _class.prototype[ methodName ];
  var timeoutName = methodName + 'Timeout';

  _class.prototype[ methodName ] = function() {
    var timeout = this[ timeoutName ];
    if ( timeout ) {
      clearTimeout( timeout );
    }
    var args = arguments;

    var _this = this;
    this[ timeoutName ] = setTimeout( function() {
      method.apply( _this, args );
      delete _this[ timeoutName ];
    }, threshold || 100 );
  };
};

// ----- docReady ----- //

utils.docReady = function( callback ) {
  if ( document.readyState == 'complete' ) {
    callback();
  } else {
    document.addEventListener( 'DOMContentLoaded', callback );
  }
};

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
utils.toDashed = function( str ) {
  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
    return $1 + '-' + $2;
  }).toLowerCase();
};

var console = window.console;
/**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */
utils.htmlInit = function( WidgetClass, namespace ) {
  utils.docReady( function() {
    var dashedNamespace = utils.toDashed( namespace );
    var dataAttr = 'data-' + dashedNamespace;
    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
    var elems = utils.makeArray( dataAttrElems )
      .concat( utils.makeArray( jsDashElems ) );
    var dataOptionsAttr = dataAttr + '-options';
    var jQuery = window.jQuery;

    elems.forEach( function( elem ) {
      var attr = elem.getAttribute( dataAttr ) ||
        elem.getAttribute( dataOptionsAttr );
      var options;
      try {
        options = attr && JSON.parse( attr );
      } catch ( error ) {
        // log error, do not initialize
        if ( console ) {
          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
          ': ' + error );
        }
        return;
      }
      // initialize
      var instance = new WidgetClass( elem, options );
      // make available via $().data('layoutname')
      if ( jQuery ) {
        jQuery.data( elem, namespace, instance );
      }
    });

  });
};

// -----  ----- //

return utils;

}));

/**
 * Outlayer Item
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( 'outlayer/item',[
        'ev-emitter/ev-emitter',
        'get-size/get-size'
      ],
      function( EvEmitter, getSize ) {
        return factory( window, EvEmitter, getSize );
      }
    );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory(
      window,
      require('ev-emitter'),
      require('get-size')
    );
  } else {
    // browser global
    window.Outlayer = {};
    window.Outlayer.Item = factory(
      window,
      window.EvEmitter,
      window.getSize
    );
  }

}( window, function factory( window, EvEmitter, getSize ) {
'use strict';

// ----- helpers ----- //

function isEmptyObj( obj ) {
  for ( var prop in obj ) {
    return false;
  }
  prop = null;
  return true;
}

// -------------------------- CSS3 support -------------------------- //


var docElemStyle = document.documentElement.style;

var transitionProperty = typeof docElemStyle.transition == 'string' ?
  'transition' : 'WebkitTransition';
var transformProperty = typeof docElemStyle.transform == 'string' ?
  'transform' : 'WebkitTransform';

var transitionEndEvent = {
  WebkitTransition: 'webkitTransitionEnd',
  transition: 'transitionend'
}[ transitionProperty ];

// cache all vendor properties
var vendorProperties = [
  transformProperty,
  transitionProperty,
  transitionProperty + 'Duration',
  transitionProperty + 'Property'
];

// -------------------------- Item -------------------------- //

function Item( element, layout ) {
  if ( !element ) {
    return;
  }

  this.element = element;
  // parent layout class, i.e. Masonry, Isotope, or Packery
  this.layout = layout;
  this.position = {
    x: 0,
    y: 0
  };

  this._create();
}

// inherit EvEmitter
var proto = Item.prototype = Object.create( EvEmitter.prototype );
proto.constructor = Item;

proto._create = function() {
  // transition objects
  this._transn = {
    ingProperties: {},
    clean: {},
    onEnd: {}
  };

  this.css({
    position: 'absolute'
  });
};

// trigger specified handler for event type
proto.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

proto.getSize = function() {
  this.size = getSize( this.element );
};

/**
 * apply CSS styles to element
 * @param {Object} style
 */
proto.css = function( style ) {
  var elemStyle = this.element.style;

  for ( var prop in style ) {
    // use vendor property if available
    var supportedProp = vendorProperties[ prop ] || prop;
    elemStyle[ supportedProp ] = style[ prop ];
  }
};

 // measure position, and sets it
proto.getPosition = function() {
  var style = getComputedStyle( this.element );
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');
  var xValue = style[ isOriginLeft ? 'left' : 'right' ];
  var yValue = style[ isOriginTop ? 'top' : 'bottom' ];
  // convert percent to pixels
  var layoutSize = this.layout.size;
  var x = xValue.indexOf('%') != -1 ?
    ( parseFloat( xValue ) / 100 ) * layoutSize.width : parseInt( xValue, 10 );
  var y = yValue.indexOf('%') != -1 ?
    ( parseFloat( yValue ) / 100 ) * layoutSize.height : parseInt( yValue, 10 );

  // clean up 'auto' or other non-integer values
  x = isNaN( x ) ? 0 : x;
  y = isNaN( y ) ? 0 : y;
  // remove padding from measurement
  x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
  y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;

  this.position.x = x;
  this.position.y = y;
};

// set settled position, apply padding
proto.layoutPosition = function() {
  var layoutSize = this.layout.size;
  var style = {};
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');

  // x
  var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
  var xProperty = isOriginLeft ? 'left' : 'right';
  var xResetProperty = isOriginLeft ? 'right' : 'left';

  var x = this.position.x + layoutSize[ xPadding ];
  // set in percentage or pixels
  style[ xProperty ] = this.getXValue( x );
  // reset other property
  style[ xResetProperty ] = '';

  // y
  var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
  var yProperty = isOriginTop ? 'top' : 'bottom';
  var yResetProperty = isOriginTop ? 'bottom' : 'top';

  var y = this.position.y + layoutSize[ yPadding ];
  // set in percentage or pixels
  style[ yProperty ] = this.getYValue( y );
  // reset other property
  style[ yResetProperty ] = '';

  this.css( style );
  this.emitEvent( 'layout', [ this ] );
};

proto.getXValue = function( x ) {
  var isHorizontal = this.layout._getOption('horizontal');
  return this.layout.options.percentPosition && !isHorizontal ?
    ( ( x / this.layout.size.width ) * 100 ) + '%' : x + 'px';
};

proto.getYValue = function( y ) {
  var isHorizontal = this.layout._getOption('horizontal');
  return this.layout.options.percentPosition && isHorizontal ?
    ( ( y / this.layout.size.height ) * 100 ) + '%' : y + 'px';
};

proto._transitionTo = function( x, y ) {
  this.getPosition();
  // get current x & y from top/left
  var curX = this.position.x;
  var curY = this.position.y;

  var compareX = parseInt( x, 10 );
  var compareY = parseInt( y, 10 );
  var didNotMove = compareX === this.position.x && compareY === this.position.y;

  // save end position
  this.setPosition( x, y );

  // if did not move and not transitioning, just go to layout
  if ( didNotMove && !this.isTransitioning ) {
    this.layoutPosition();
    return;
  }

  var transX = x - curX;
  var transY = y - curY;
  var transitionStyle = {};
  transitionStyle.transform = this.getTranslate( transX, transY );

  this.transition({
    to: transitionStyle,
    onTransitionEnd: {
      transform: this.layoutPosition
    },
    isCleaning: true
  });
};

proto.getTranslate = function( x, y ) {
  // flip cooridinates if origin on right or bottom
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');
  x = isOriginLeft ? x : -x;
  y = isOriginTop ? y : -y;
  return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
};

// non transition + transform support
proto.goTo = function( x, y ) {
  this.setPosition( x, y );
  this.layoutPosition();
};

proto.moveTo = proto._transitionTo;

proto.setPosition = function( x, y ) {
  this.position.x = parseInt( x, 10 );
  this.position.y = parseInt( y, 10 );
};

// ----- transition ----- //

/**
 * @param {Object} style - CSS
 * @param {Function} onTransitionEnd
 */

// non transition, just trigger callback
proto._nonTransition = function( args ) {
  this.css( args.to );
  if ( args.isCleaning ) {
    this._removeStyles( args.to );
  }
  for ( var prop in args.onTransitionEnd ) {
    args.onTransitionEnd[ prop ].call( this );
  }
};

/**
 * proper transition
 * @param {Object} args - arguments
 *   @param {Object} to - style to transition to
 *   @param {Object} from - style to start transition from
 *   @param {Boolean} isCleaning - removes transition styles after transition
 *   @param {Function} onTransitionEnd - callback
 */
proto._transition = function( args ) {
  // redirect to nonTransition if no transition duration
  if ( !parseFloat( this.layout.options.transitionDuration ) ) {
    this._nonTransition( args );
    return;
  }

  var _transition = this._transn;
  // keep track of onTransitionEnd callback by css property
  for ( var prop in args.onTransitionEnd ) {
    _transition.onEnd[ prop ] = args.onTransitionEnd[ prop ];
  }
  // keep track of properties that are transitioning
  for ( prop in args.to ) {
    _transition.ingProperties[ prop ] = true;
    // keep track of properties to clean up when transition is done
    if ( args.isCleaning ) {
      _transition.clean[ prop ] = true;
    }
  }

  // set from styles
  if ( args.from ) {
    this.css( args.from );
    // force redraw. http://blog.alexmaccaw.com/css-transitions
    var h = this.element.offsetHeight;
    // hack for JSHint to hush about unused var
    h = null;
  }
  // enable transition
  this.enableTransition( args.to );
  // set styles that are transitioning
  this.css( args.to );

  this.isTransitioning = true;

};

// dash before all cap letters, including first for
// WebkitTransform => -webkit-transform
function toDashedAll( str ) {
  return str.replace( /([A-Z])/g, function( $1 ) {
    return '-' + $1.toLowerCase();
  });
}

var transitionProps = 'opacity,' +
  toDashedAll( vendorProperties.transform || 'transform' );

proto.enableTransition = function(/* style */) {
  // HACK changing transitionProperty during a transition
  // will cause transition to jump
  if ( this.isTransitioning ) {
    return;
  }

  // make `transition: foo, bar, baz` from style object
  // HACK un-comment this when enableTransition can work
  // while a transition is happening
  // var transitionValues = [];
  // for ( var prop in style ) {
  //   // dash-ify camelCased properties like WebkitTransition
  //   prop = vendorProperties[ prop ] || prop;
  //   transitionValues.push( toDashedAll( prop ) );
  // }
  // enable transition styles
  this.css({
    transitionProperty: transitionProps,
    transitionDuration: this.layout.options.transitionDuration
  });
  // listen for transition end event
  this.element.addEventListener( transitionEndEvent, this, false );
};

proto.transition = Item.prototype[ transitionProperty ? '_transition' : '_nonTransition' ];

// ----- events ----- //

proto.onwebkitTransitionEnd = function( event ) {
  this.ontransitionend( event );
};

proto.onotransitionend = function( event ) {
  this.ontransitionend( event );
};

// properties that I munge to make my life easier
var dashedVendorProperties = {
  '-webkit-transform': 'transform'
};

proto.ontransitionend = function( event ) {
  // disregard bubbled events from children
  if ( event.target !== this.element ) {
    return;
  }
  var _transition = this._transn;
  // get property name of transitioned property, convert to prefix-free
  var propertyName = dashedVendorProperties[ event.propertyName ] || event.propertyName;

  // remove property that has completed transitioning
  delete _transition.ingProperties[ propertyName ];
  // check if any properties are still transitioning
  if ( isEmptyObj( _transition.ingProperties ) ) {
    // all properties have completed transitioning
    this.disableTransition();
  }
  // clean style
  if ( propertyName in _transition.clean ) {
    // clean up style
    this.element.style[ event.propertyName ] = '';
    delete _transition.clean[ propertyName ];
  }
  // trigger onTransitionEnd callback
  if ( propertyName in _transition.onEnd ) {
    var onTransitionEnd = _transition.onEnd[ propertyName ];
    onTransitionEnd.call( this );
    delete _transition.onEnd[ propertyName ];
  }

  this.emitEvent( 'transitionEnd', [ this ] );
};

proto.disableTransition = function() {
  this.removeTransitionStyles();
  this.element.removeEventListener( transitionEndEvent, this, false );
  this.isTransitioning = false;
};

/**
 * removes style property from element
 * @param {Object} style
**/
proto._removeStyles = function( style ) {
  // clean up transition styles
  var cleanStyle = {};
  for ( var prop in style ) {
    cleanStyle[ prop ] = '';
  }
  this.css( cleanStyle );
};

var cleanTransitionStyle = {
  transitionProperty: '',
  transitionDuration: ''
};

proto.removeTransitionStyles = function() {
  // remove transition
  this.css( cleanTransitionStyle );
};

// ----- show/hide/remove ----- //

// remove element from DOM
proto.removeElem = function() {
  this.element.parentNode.removeChild( this.element );
  // remove display: none
  this.css({ display: '' });
  this.emitEvent( 'remove', [ this ] );
};

proto.remove = function() {
  // just remove element if no transition support or no transition
  if ( !transitionProperty || !parseFloat( this.layout.options.transitionDuration ) ) {
    this.removeElem();
    return;
  }

  // start transition
  this.once( 'transitionEnd', function() {
    this.removeElem();
  });
  this.hide();
};

proto.reveal = function() {
  delete this.isHidden;
  // remove display: none
  this.css({ display: '' });

  var options = this.layout.options;

  var onTransitionEnd = {};
  var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
  onTransitionEnd[ transitionEndProperty ] = this.onRevealTransitionEnd;

  this.transition({
    from: options.hiddenStyle,
    to: options.visibleStyle,
    isCleaning: true,
    onTransitionEnd: onTransitionEnd
  });
};

proto.onRevealTransitionEnd = function() {
  // check if still visible
  // during transition, item may have been hidden
  if ( !this.isHidden ) {
    this.emitEvent('reveal');
  }
};

/**
 * get style property use for hide/reveal transition end
 * @param {String} styleProperty - hiddenStyle/visibleStyle
 * @returns {String}
 */
proto.getHideRevealTransitionEndProperty = function( styleProperty ) {
  var optionStyle = this.layout.options[ styleProperty ];
  // use opacity
  if ( optionStyle.opacity ) {
    return 'opacity';
  }
  // get first property
  for ( var prop in optionStyle ) {
    return prop;
  }
};

proto.hide = function() {
  // set flag
  this.isHidden = true;
  // remove display: none
  this.css({ display: '' });

  var options = this.layout.options;

  var onTransitionEnd = {};
  var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
  onTransitionEnd[ transitionEndProperty ] = this.onHideTransitionEnd;

  this.transition({
    from: options.visibleStyle,
    to: options.hiddenStyle,
    // keep hidden stuff hidden
    isCleaning: true,
    onTransitionEnd: onTransitionEnd
  });
};

proto.onHideTransitionEnd = function() {
  // check if still hidden
  // during transition, item may have been un-hidden
  if ( this.isHidden ) {
    this.css({ display: 'none' });
    this.emitEvent('hide');
  }
};

proto.destroy = function() {
  this.css({
    position: '',
    left: '',
    right: '',
    top: '',
    bottom: '',
    transition: '',
    transform: ''
  });
};

return Item;

}));

/*!
 * Outlayer v2.0.0
 * the brains and guts of a layout library
 * MIT license
 */

( function( window, factory ) {
  'use strict';
  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( 'outlayer/outlayer',[
        'ev-emitter/ev-emitter',
        'get-size/get-size',
        'fizzy-ui-utils/utils',
        './item'
      ],
      function( EvEmitter, getSize, utils, Item ) {
        return factory( window, EvEmitter, getSize, utils, Item);
      }
    );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory(
      window,
      require('ev-emitter'),
      require('get-size'),
      require('fizzy-ui-utils'),
      require('./item')
    );
  } else {
    // browser global
    window.Outlayer = factory(
      window,
      window.EvEmitter,
      window.getSize,
      window.fizzyUIUtils,
      window.Outlayer.Item
    );
  }

}( window, function factory( window, EvEmitter, getSize, utils, Item ) {
'use strict';

// ----- vars ----- //

var console = window.console;
var jQuery = window.jQuery;
var noop = function() {};

// -------------------------- Outlayer -------------------------- //

// globally unique identifiers
var GUID = 0;
// internal store of all Outlayer intances
var instances = {};


/**
 * @param {Element, String} element
 * @param {Object} options
 * @constructor
 */
function Outlayer( element, options ) {
  var queryElement = utils.getQueryElement( element );
  if ( !queryElement ) {
    if ( console ) {
      console.error( 'Bad element for ' + this.constructor.namespace +
        ': ' + ( queryElement || element ) );
    }
    return;
  }
  this.element = queryElement;
  // add jQuery
  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }

  // options
  this.options = utils.extend( {}, this.constructor.defaults );
  this.option( options );

  // add id for Outlayer.getFromElement
  var id = ++GUID;
  this.element.outlayerGUID = id; // expando
  instances[ id ] = this; // associate via id

  // kick it off
  this._create();

  var isInitLayout = this._getOption('initLayout');
  if ( isInitLayout ) {
    this.layout();
  }
}

// settings are for internal use only
Outlayer.namespace = 'outlayer';
Outlayer.Item = Item;

// default options
Outlayer.defaults = {
  containerStyle: {
    position: 'relative'
  },
  initLayout: true,
  originLeft: true,
  originTop: true,
  resize: true,
  resizeContainer: true,
  // item options
  transitionDuration: '0.4s',
  hiddenStyle: {
    opacity: 0,
    transform: 'scale(0.001)'
  },
  visibleStyle: {
    opacity: 1,
    transform: 'scale(1)'
  }
};

var proto = Outlayer.prototype;
// inherit EvEmitter
utils.extend( proto, EvEmitter.prototype );

/**
 * set options
 * @param {Object} opts
 */
proto.option = function( opts ) {
  utils.extend( this.options, opts );
};

/**
 * get backwards compatible option value, check old name
 */
proto._getOption = function( option ) {
  var oldOption = this.constructor.compatOptions[ option ];
  return oldOption && this.options[ oldOption ] !== undefined ?
    this.options[ oldOption ] : this.options[ option ];
};

Outlayer.compatOptions = {
  // currentName: oldName
  initLayout: 'isInitLayout',
  horizontal: 'isHorizontal',
  layoutInstant: 'isLayoutInstant',
  originLeft: 'isOriginLeft',
  originTop: 'isOriginTop',
  resize: 'isResizeBound',
  resizeContainer: 'isResizingContainer'
};

proto._create = function() {
  // get items from children
  this.reloadItems();
  // elements that affect layout, but are not laid out
  this.stamps = [];
  this.stamp( this.options.stamp );
  // set container style
  utils.extend( this.element.style, this.options.containerStyle );

  // bind resize method
  var canBindResize = this._getOption('resize');
  if ( canBindResize ) {
    this.bindResize();
  }
};

// goes through all children again and gets bricks in proper order
proto.reloadItems = function() {
  // collection of item elements
  this.items = this._itemize( this.element.children );
};


/**
 * turn elements into Outlayer.Items to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - collection of new Outlayer Items
 */
proto._itemize = function( elems ) {

  var itemElems = this._filterFindItemElements( elems );
  var Item = this.constructor.Item;

  // create new Outlayer Items for collection
  var items = [];
  for ( var i=0; i < itemElems.length; i++ ) {
    var elem = itemElems[i];
    var item = new Item( elem, this );
    items.push( item );
  }

  return items;
};

/**
 * get item elements to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - item elements
 */
proto._filterFindItemElements = function( elems ) {
  return utils.filterFindElements( elems, this.options.itemSelector );
};

/**
 * getter method for getting item elements
 * @returns {Array} elems - collection of item elements
 */
proto.getItemElements = function() {
  return this.items.map( function( item ) {
    return item.element;
  });
};

// ----- init & layout ----- //

/**
 * lays out all items
 */
proto.layout = function() {
  this._resetLayout();
  this._manageStamps();

  // don't animate first layout
  var layoutInstant = this._getOption('layoutInstant');
  var isInstant = layoutInstant !== undefined ?
    layoutInstant : !this._isLayoutInited;
  this.layoutItems( this.items, isInstant );

  // flag for initalized
  this._isLayoutInited = true;
};

// _init is alias for layout
proto._init = proto.layout;

/**
 * logic before any new layout
 */
proto._resetLayout = function() {
  this.getSize();
};


proto.getSize = function() {
  this.size = getSize( this.element );
};

/**
 * get measurement from option, for columnWidth, rowHeight, gutter
 * if option is String -> get element from selector string, & get size of element
 * if option is Element -> get size of element
 * else use option as a number
 *
 * @param {String} measurement
 * @param {String} size - width or height
 * @private
 */
proto._getMeasurement = function( measurement, size ) {
  var option = this.options[ measurement ];
  var elem;
  if ( !option ) {
    // default to 0
    this[ measurement ] = 0;
  } else {
    // use option as an element
    if ( typeof option == 'string' ) {
      elem = this.element.querySelector( option );
    } else if ( option instanceof HTMLElement ) {
      elem = option;
    }
    // use size of element, if element
    this[ measurement ] = elem ? getSize( elem )[ size ] : option;
  }
};

/**
 * layout a collection of item elements
 * @api public
 */
proto.layoutItems = function( items, isInstant ) {
  items = this._getItemsForLayout( items );

  this._layoutItems( items, isInstant );

  this._postLayout();
};

/**
 * get the items to be laid out
 * you may want to skip over some items
 * @param {Array} items
 * @returns {Array} items
 */
proto._getItemsForLayout = function( items ) {
  return items.filter( function( item ) {
    return !item.isIgnored;
  });
};

/**
 * layout items
 * @param {Array} items
 * @param {Boolean} isInstant
 */
proto._layoutItems = function( items, isInstant ) {
  this._emitCompleteOnItems( 'layout', items );

  if ( !items || !items.length ) {
    // no items, emit event with empty array
    return;
  }

  var queue = [];

  items.forEach( function( item ) {
    // get x/y object from method
    var position = this._getItemLayoutPosition( item );
    // enqueue
    position.item = item;
    position.isInstant = isInstant || item.isLayoutInstant;
    queue.push( position );
  }, this );

  this._processLayoutQueue( queue );
};

/**
 * get item layout position
 * @param {Outlayer.Item} item
 * @returns {Object} x and y position
 */
proto._getItemLayoutPosition = function( /* item */ ) {
  return {
    x: 0,
    y: 0
  };
};

/**
 * iterate over array and position each item
 * Reason being - separating this logic prevents 'layout invalidation'
 * thx @paul_irish
 * @param {Array} queue
 */
proto._processLayoutQueue = function( queue ) {
  queue.forEach( function( obj ) {
    this._positionItem( obj.item, obj.x, obj.y, obj.isInstant );
  }, this );
};

/**
 * Sets position of item in DOM
 * @param {Outlayer.Item} item
 * @param {Number} x - horizontal position
 * @param {Number} y - vertical position
 * @param {Boolean} isInstant - disables transitions
 */
proto._positionItem = function( item, x, y, isInstant ) {
  if ( isInstant ) {
    // if not transition, just set CSS
    item.goTo( x, y );
  } else {
    item.moveTo( x, y );
  }
};

/**
 * Any logic you want to do after each layout,
 * i.e. size the container
 */
proto._postLayout = function() {
  this.resizeContainer();
};

proto.resizeContainer = function() {
  var isResizingContainer = this._getOption('resizeContainer');
  if ( !isResizingContainer ) {
    return;
  }
  var size = this._getContainerSize();
  if ( size ) {
    this._setContainerMeasure( size.width, true );
    this._setContainerMeasure( size.height, false );
  }
};

/**
 * Sets width or height of container if returned
 * @returns {Object} size
 *   @param {Number} width
 *   @param {Number} height
 */
proto._getContainerSize = noop;

/**
 * @param {Number} measure - size of width or height
 * @param {Boolean} isWidth
 */
proto._setContainerMeasure = function( measure, isWidth ) {
  if ( measure === undefined ) {
    return;
  }

  var elemSize = this.size;
  // add padding and border width if border box
  if ( elemSize.isBorderBox ) {
    measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight +
      elemSize.borderLeftWidth + elemSize.borderRightWidth :
      elemSize.paddingBottom + elemSize.paddingTop +
      elemSize.borderTopWidth + elemSize.borderBottomWidth;
  }

  measure = Math.max( measure, 0 );
  this.element.style[ isWidth ? 'width' : 'height' ] = measure + 'px';
};

/**
 * emit eventComplete on a collection of items events
 * @param {String} eventName
 * @param {Array} items - Outlayer.Items
 */
proto._emitCompleteOnItems = function( eventName, items ) {
  var _this = this;
  function onComplete() {
    _this.dispatchEvent( eventName + 'Complete', null, [ items ] );
  }

  var count = items.length;
  if ( !items || !count ) {
    onComplete();
    return;
  }

  var doneCount = 0;
  function tick() {
    doneCount++;
    if ( doneCount == count ) {
      onComplete();
    }
  }

  // bind callback
  items.forEach( function( item ) {
    item.once( eventName, tick );
  });
};

/**
 * emits events via EvEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  // add original event to arguments
  var emitArgs = event ? [ event ].concat( args ) : args;
  this.emitEvent( type, emitArgs );

  if ( jQuery ) {
    // set this.$element
    this.$element = this.$element || jQuery( this.element );
    if ( event ) {
      // create jQuery event
      var $event = jQuery.Event( event );
      $event.type = type;
      this.$element.trigger( $event, args );
    } else {
      // just trigger with type if no event available
      this.$element.trigger( type, args );
    }
  }
};

// -------------------------- ignore & stamps -------------------------- //


/**
 * keep item in collection, but do not lay it out
 * ignored items do not get skipped in layout
 * @param {Element} elem
 */
proto.ignore = function( elem ) {
  var item = this.getItem( elem );
  if ( item ) {
    item.isIgnored = true;
  }
};

/**
 * return item to layout collection
 * @param {Element} elem
 */
proto.unignore = function( elem ) {
  var item = this.getItem( elem );
  if ( item ) {
    delete item.isIgnored;
  }
};

/**
 * adds elements to stamps
 * @param {NodeList, Array, Element, or String} elems
 */
proto.stamp = function( elems ) {
  elems = this._find( elems );
  if ( !elems ) {
    return;
  }

  this.stamps = this.stamps.concat( elems );
  // ignore
  elems.forEach( this.ignore, this );
};

/**
 * removes elements to stamps
 * @param {NodeList, Array, or Element} elems
 */
proto.unstamp = function( elems ) {
  elems = this._find( elems );
  if ( !elems ){
    return;
  }

  elems.forEach( function( elem ) {
    // filter out removed stamp elements
    utils.removeFrom( this.stamps, elem );
    this.unignore( elem );
  }, this );
};

/**
 * finds child elements
 * @param {NodeList, Array, Element, or String} elems
 * @returns {Array} elems
 */
proto._find = function( elems ) {
  if ( !elems ) {
    return;
  }
  // if string, use argument as selector string
  if ( typeof elems == 'string' ) {
    elems = this.element.querySelectorAll( elems );
  }
  elems = utils.makeArray( elems );
  return elems;
};

proto._manageStamps = function() {
  if ( !this.stamps || !this.stamps.length ) {
    return;
  }

  this._getBoundingRect();

  this.stamps.forEach( this._manageStamp, this );
};

// update boundingLeft / Top
proto._getBoundingRect = function() {
  // get bounding rect for container element
  var boundingRect = this.element.getBoundingClientRect();
  var size = this.size;
  this._boundingRect = {
    left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
    top: boundingRect.top + size.paddingTop + size.borderTopWidth,
    right: boundingRect.right - ( size.paddingRight + size.borderRightWidth ),
    bottom: boundingRect.bottom - ( size.paddingBottom + size.borderBottomWidth )
  };
};

/**
 * @param {Element} stamp
**/
proto._manageStamp = noop;

/**
 * get x/y position of element relative to container element
 * @param {Element} elem
 * @returns {Object} offset - has left, top, right, bottom
 */
proto._getElementOffset = function( elem ) {
  var boundingRect = elem.getBoundingClientRect();
  var thisRect = this._boundingRect;
  var size = getSize( elem );
  var offset = {
    left: boundingRect.left - thisRect.left - size.marginLeft,
    top: boundingRect.top - thisRect.top - size.marginTop,
    right: thisRect.right - boundingRect.right - size.marginRight,
    bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
  };
  return offset;
};

// -------------------------- resize -------------------------- //

// enable event handlers for listeners
// i.e. resize -> onresize
proto.handleEvent = utils.handleEvent;

/**
 * Bind layout to window resizing
 */
proto.bindResize = function() {
  window.addEventListener( 'resize', this );
  this.isResizeBound = true;
};

/**
 * Unbind layout to window resizing
 */
proto.unbindResize = function() {
  window.removeEventListener( 'resize', this );
  this.isResizeBound = false;
};

proto.onresize = function() {
  this.resize();
};

utils.debounceMethod( Outlayer, 'onresize', 100 );

proto.resize = function() {
  // don't trigger if size did not change
  // or if resize was unbound. See #9
  if ( !this.isResizeBound || !this.needsResizeLayout() ) {
    return;
  }

  this.layout();
};

/**
 * check if layout is needed post layout
 * @returns Boolean
 */
proto.needsResizeLayout = function() {
  var size = getSize( this.element );
  // check that this.size and size are there
  // IE8 triggers resize on body size change, so they might not be
  var hasSizes = this.size && size;
  return hasSizes && size.innerWidth !== this.size.innerWidth;
};

// -------------------------- methods -------------------------- //

/**
 * add items to Outlayer instance
 * @param {Array or NodeList or Element} elems
 * @returns {Array} items - Outlayer.Items
**/
proto.addItems = function( elems ) {
  var items = this._itemize( elems );
  // add items to collection
  if ( items.length ) {
    this.items = this.items.concat( items );
  }
  return items;
};

/**
 * Layout newly-appended item elements
 * @param {Array or NodeList or Element} elems
 */
proto.appended = function( elems ) {
  var items = this.addItems( elems );
  if ( !items.length ) {
    return;
  }
  // layout and reveal just the new items
  this.layoutItems( items, true );
  this.reveal( items );
};

/**
 * Layout prepended elements
 * @param {Array or NodeList or Element} elems
 */
proto.prepended = function( elems ) {
  var items = this._itemize( elems );
  if ( !items.length ) {
    return;
  }
  // add items to beginning of collection
  var previousItems = this.items.slice(0);
  this.items = items.concat( previousItems );
  // start new layout
  this._resetLayout();
  this._manageStamps();
  // layout new stuff without transition
  this.layoutItems( items, true );
  this.reveal( items );
  // layout previous items
  this.layoutItems( previousItems );
};

/**
 * reveal a collection of items
 * @param {Array of Outlayer.Items} items
 */
proto.reveal = function( items ) {
  this._emitCompleteOnItems( 'reveal', items );
  if ( !items || !items.length ) {
    return;
  }
  items.forEach( function( item ) {
    item.reveal();
  });
};

/**
 * hide a collection of items
 * @param {Array of Outlayer.Items} items
 */
proto.hide = function( items ) {
  this._emitCompleteOnItems( 'hide', items );
  if ( !items || !items.length ) {
    return;
  }
  items.forEach( function( item ) {
    item.hide();
  });
};

/**
 * reveal item elements
 * @param {Array}, {Element}, {NodeList} items
 */
proto.revealItemElements = function( elems ) {
  var items = this.getItems( elems );
  this.reveal( items );
};

/**
 * hide item elements
 * @param {Array}, {Element}, {NodeList} items
 */
proto.hideItemElements = function( elems ) {
  var items = this.getItems( elems );
  this.hide( items );
};

/**
 * get Outlayer.Item, given an Element
 * @param {Element} elem
 * @param {Function} callback
 * @returns {Outlayer.Item} item
 */
proto.getItem = function( elem ) {
  // loop through items to get the one that matches
  for ( var i=0; i < this.items.length; i++ ) {
    var item = this.items[i];
    if ( item.element == elem ) {
      // return item
      return item;
    }
  }
};

/**
 * get collection of Outlayer.Items, given Elements
 * @param {Array} elems
 * @returns {Array} items - Outlayer.Items
 */
proto.getItems = function( elems ) {
  elems = utils.makeArray( elems );
  var items = [];
  elems.forEach( function( elem ) {
    var item = this.getItem( elem );
    if ( item ) {
      items.push( item );
    }
  }, this );

  return items;
};

/**
 * remove element(s) from instance and DOM
 * @param {Array or NodeList or Element} elems
 */
proto.remove = function( elems ) {
  var removeItems = this.getItems( elems );

  this._emitCompleteOnItems( 'remove', removeItems );

  // bail if no items to remove
  if ( !removeItems || !removeItems.length ) {
    return;
  }

  removeItems.forEach( function( item ) {
    item.remove();
    // remove item from collection
    utils.removeFrom( this.items, item );
  }, this );
};

// ----- destroy ----- //

// remove and disable Outlayer instance
proto.destroy = function() {
  // clean up dynamic styles
  var style = this.element.style;
  style.height = '';
  style.position = '';
  style.width = '';
  // destroy items
  this.items.forEach( function( item ) {
    item.destroy();
  });

  this.unbindResize();

  var id = this.element.outlayerGUID;
  delete instances[ id ]; // remove reference to instance by id
  delete this.element.outlayerGUID;
  // remove data for jQuery
  if ( jQuery ) {
    jQuery.removeData( this.element, this.constructor.namespace );
  }

};

// -------------------------- data -------------------------- //

/**
 * get Outlayer instance from element
 * @param {Element} elem
 * @returns {Outlayer}
 */
Outlayer.data = function( elem ) {
  elem = utils.getQueryElement( elem );
  var id = elem && elem.outlayerGUID;
  return id && instances[ id ];
};


// -------------------------- create Outlayer class -------------------------- //

/**
 * create a layout class
 * @param {String} namespace
 */
Outlayer.create = function( namespace, options ) {
  // sub-class Outlayer
  var Layout = subclass( Outlayer );
  // apply new options and compatOptions
  Layout.defaults = utils.extend( {}, Outlayer.defaults );
  utils.extend( Layout.defaults, options );
  Layout.compatOptions = utils.extend( {}, Outlayer.compatOptions  );

  Layout.namespace = namespace;

  Layout.data = Outlayer.data;

  // sub-class Item
  Layout.Item = subclass( Item );

  // -------------------------- declarative -------------------------- //

  utils.htmlInit( Layout, namespace );

  // -------------------------- jQuery bridge -------------------------- //

  // make into jQuery plugin
  if ( jQuery && jQuery.bridget ) {
    jQuery.bridget( namespace, Layout );
  }

  return Layout;
};

function subclass( Parent ) {
  function SubClass() {
    Parent.apply( this, arguments );
  }

  SubClass.prototype = Object.create( Parent.prototype );
  SubClass.prototype.constructor = SubClass;

  return SubClass;
}

// ----- fin ----- //

// back in global
Outlayer.Item = Item;

return Outlayer;

}));

/*!
 * Masonry v4.0.0
 * Cascading grid layout library
 * http://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
        'outlayer/outlayer',
        'get-size/get-size'
      ],
      factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('outlayer'),
      require('get-size')
    );
  } else {
    // browser global
    window.Masonry = factory(
      window.Outlayer,
      window.getSize
    );
  }

}( window, function factory( Outlayer, getSize ) {



// -------------------------- masonryDefinition -------------------------- //

  // create an Outlayer layout class
  var Masonry = Outlayer.create('masonry');
  // isFitWidth -> fitWidth
  Masonry.compatOptions.fitWidth = 'isFitWidth';

  Masonry.prototype._resetLayout = function() {
    this.getSize();
    this._getMeasurement( 'columnWidth', 'outerWidth' );
    this._getMeasurement( 'gutter', 'outerWidth' );
    this.measureColumns();

    // reset column Y
    this.colYs = [];
    for ( var i=0; i < this.cols; i++ ) {
      this.colYs.push( 0 );
    }

    this.maxY = 0;
  };

  Masonry.prototype.measureColumns = function() {
    this.getContainerWidth();
    // if columnWidth is 0, default to outerWidth of first item
    if ( !this.columnWidth ) {
      var firstItem = this.items[0];
      var firstItemElem = firstItem && firstItem.element;
      // columnWidth fall back to item of first element
      this.columnWidth = firstItemElem && getSize( firstItemElem ).outerWidth ||
        // if first elem has no width, default to size of container
        this.containerWidth;
    }

    var columnWidth = this.columnWidth += this.gutter;

    // calculate columns
    var containerWidth = this.containerWidth + this.gutter;
    var cols = containerWidth / columnWidth;
    // fix rounding errors, typically with gutters
    var excess = columnWidth - containerWidth % columnWidth;
    // if overshoot is less than a pixel, round up, otherwise floor it
    var mathMethod = excess && excess < 1 ? 'round' : 'floor';
    cols = Math[ mathMethod ]( cols );
    this.cols = Math.max( cols, 1 );
  };

  Masonry.prototype.getContainerWidth = function() {
    // container is parent if fit width
    var isFitWidth = this._getOption('fitWidth');
    var container = isFitWidth ? this.element.parentNode : this.element;
    // check that this.size and size are there
    // IE8 triggers resize on body size change, so they might not be
    var size = getSize( container );
    this.containerWidth = size && size.innerWidth;
  };

  Masonry.prototype._getItemLayoutPosition = function( item ) {
    item.getSize();
    // how many columns does this brick span
    var remainder = item.size.outerWidth % this.columnWidth;
    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
    // round if off by 1 pixel, otherwise use ceil
    var colSpan = Math[ mathMethod ]( item.size.outerWidth / this.columnWidth );
    colSpan = Math.min( colSpan, this.cols );

    var colGroup = this._getColGroup( colSpan );
    // get the minimum Y value from the columns
    var minimumY = Math.min.apply( Math, colGroup );
    var shortColIndex = colGroup.indexOf( minimumY );

    // position the brick
    var position = {
      x: this.columnWidth * shortColIndex,
      y: minimumY
    };

    // apply setHeight to necessary columns
    var setHeight = minimumY + item.size.outerHeight;
    var setSpan = this.cols + 1 - colGroup.length;
    for ( var i = 0; i < setSpan; i++ ) {
      this.colYs[ shortColIndex + i ] = setHeight;
    }

    return position;
  };

  /**
   * @param {Number} colSpan - number of columns the element spans
   * @returns {Array} colGroup
   */
  Masonry.prototype._getColGroup = function( colSpan ) {
    if ( colSpan < 2 ) {
      // if brick spans only one column, use all the column Ys
      return this.colYs;
    }

    var colGroup = [];
    // how many different places could this brick fit horizontally
    var groupCount = this.cols + 1 - colSpan;
    // for each group potential horizontal position
    for ( var i = 0; i < groupCount; i++ ) {
      // make an array of colY values for that one group
      var groupColYs = this.colYs.slice( i, i + colSpan );
      // and get the max value of the array
      colGroup[i] = Math.max.apply( Math, groupColYs );
    }
    return colGroup;
  };

  Masonry.prototype._manageStamp = function( stamp ) {
    var stampSize = getSize( stamp );
    var offset = this._getElementOffset( stamp );
    // get the columns that this stamp affects
    var isOriginLeft = this._getOption('originLeft');
    var firstX = isOriginLeft ? offset.left : offset.right;
    var lastX = firstX + stampSize.outerWidth;
    var firstCol = Math.floor( firstX / this.columnWidth );
    firstCol = Math.max( 0, firstCol );
    var lastCol = Math.floor( lastX / this.columnWidth );
    // lastCol should not go over if multiple of columnWidth #425
    lastCol -= lastX % this.columnWidth ? 0 : 1;
    lastCol = Math.min( this.cols - 1, lastCol );
    // set colYs to bottom of the stamp

    var isOriginTop = this._getOption('originTop');
    var stampMaxY = ( isOriginTop ? offset.top : offset.bottom ) +
      stampSize.outerHeight;
    for ( var i = firstCol; i <= lastCol; i++ ) {
      this.colYs[i] = Math.max( stampMaxY, this.colYs[i] );
    }
  };

  Masonry.prototype._getContainerSize = function() {
    this.maxY = Math.max.apply( Math, this.colYs );
    var size = {
      height: this.maxY
    };

    if ( this._getOption('fitWidth') ) {
      size.width = this._getContainerFitWidth();
    }

    return size;
  };

  Masonry.prototype._getContainerFitWidth = function() {
    var unusedCols = 0;
    // count unused columns
    var i = this.cols;
    while ( --i ) {
      if ( this.colYs[i] !== 0 ) {
        break;
      }
      unusedCols++;
    }
    // fit container to columns that have been used
    return ( this.cols - unusedCols ) * this.columnWidth - this.gutter;
  };

  Masonry.prototype.needsResizeLayout = function() {
    var previousWidth = this.containerWidth;
    this.getContainerWidth();
    return previousWidth != this.containerWidth;
  };

  return Masonry;

}));


(function () {
  'use strict';
  angular
    .module('frontendApp',
    ['ui.bootstrap',
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'toastr',
      'LocalStorageModule',
       'satellizer',
      'sap.imageloader',
      'angular-inview',
      'ngMap',
      'fox.scrollReveal',
      'angularSmoothscroll',
      'angular-owl-carousel-2',
      'angular-loading-bar',
      'swipe',
      '720kb.socialshare'
      /*,
      'ngColorThief'*/
    ]);

})();

(function () {
  'use strict';
  angular
    .module('frontendApp')
    //establece altura a pantalla completa
    .directive('wright', function () {
      return {
        templateUrl: 'app/scripts/directives/wright/wright.html',
        restrict: 'A',
        replace: true,
        scope: {
          //configuracion basica
          sec: '=',
        },
       // rootScope: $rootScope,

        controller: function wright($scope, $rootScope, toastr, $state, $location, $log,
                                   localStorageService, $window) {
          console.log('hello from directive');

          $scope.sec = $rootScope.secPicked;
          /*switch($rootScope.currentState){
            case 'news-selected':
            case 'area-selected':
              $scope.sec = {
                class: 'inner-view',
                image: '../assets/images/6.jpg',
                title: {
                  es: 'Título de la sección',
                  en: 'Title of the news shown'
                },
                legend: {
                  es: 'La Paz, Bolivia / 02.19',
                  en: 'La Paz, Bolivia / 02.19'
                },
                websectiondata: [
                  {
                    type: 0,
                    order: 0,
                    content: {
                      es: '<h2>Subtitulo de prueba</h2><h3>Subtitulo de prueba</h3><h4>Subtitulo de prueba</h4><h5>Subtitulo de prueba</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p><a>Enlace de prueba</a>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<ul><li><p>Prueba</p></li><li><p>Prueba</p></li></ul>',
                      en: '<h1>Subtitulo de prueba</h1><h2>Subtitulo de prueba</h2><h3>Subtitulo de prueba</h3><h4>Subtitulo de prueba</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p><a>Enlace de prueba</a>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<ul><li><p>Prueba</p></li><li><p>Prueba</p></li></ul>'
                    },
                  },
                  {
                    type: 1,
                    order: 0,
                    image: '../assets/images/2.jpg',
                  },
                  {
                    type: 0,
                    order: 0,
                    content: {
                      es: '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      ''
                    }
                  },
                  {
                    type: 3,
                    order: 0,
                    websectiondataitem: [
                      {
                        image: '../assets/images/1.jpg',
                      },
                      {
                        image: '../assets/images/2.jpg',
                      },
                      {
                        image: '../assets/images/3.jpg',
                      }
                    ]
                  },

                  {
                    type: 2,
                    order: 0,
                    link: '8XRSnYzewes',
                  },
                  {
                    type: 0,
                    order: 0,
                    content: {
                      es: '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      ''
                    }
                  },
                ]
              };
              break;
            case 'profile-selected':
              $scope.sec = {
                class: 'inner-view',
                image: '../assets/images/6.jpg',
                title: {
                  es: 'Título de la sección',
                  en: 'Title of the news shown'
                },
                legend: {
                  es: 'La Paz, Bolivia / 02.19',
                  en: 'La Paz, Bolivia / 02.19'
                },
                websectiondata: [
                  {
                    type: 0,
                    order: 0,
                    content: {
                      es: '<h2>Subtitulo de prueba</h2><h3>Subtitulo de prueba</h3><h4>Subtitulo de prueba</h4><h5>Subtitulo de prueba</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p><a>Enlace de prueba</a>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<ul><li><p>Prueba</p></li><li><p>Prueba</p></li></ul>',
                      en: '<h1>Subtitulo de prueba</h1><h2>Subtitulo de prueba</h2><h3>Subtitulo de prueba</h3><h4>Subtitulo de prueba</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p><a>Enlace de prueba</a>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<ul><li><p>Prueba</p></li><li><p>Prueba</p></li></ul>'
                    },
                  },
                  {
                    type: 5,
                    content:''
                  }
                ]
              };
              break;
            case 'aboutus':{
              $rootScope.temporalElement('Sobre Nosotros', '../assets/images/4.jpg', '', '');
              $scope.sec = {
                class: 'inner-view',
                image: '../assets/images/6.jpg',
                title: {
                  es: 'Título de la sección',
                  en: 'Title of the news shown'
                },
                legend: {
                  es: 'La Paz, Bolivia / 02.19',
                  en: 'La Paz, Bolivia / 02.19'
                },
                websectiondata: [
                  {
                    type: 0,
                    order: 0,
                    content: {
                      es: '<h2>Subtitulo de prueba</h2><h3>Subtitulo de prueba</h3><h4>Subtitulo de prueba</h4><h5>Subtitulo de prueba</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p><a>Enlace de prueba</a>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<ul><li><p>Prueba</p></li><li><p>Prueba</p></li></ul>',
                      en: '<h1>Subtitulo de prueba</h1><h2>Subtitulo de prueba</h2><h3>Subtitulo de prueba</h3><h4>Subtitulo de prueba</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p><a>Enlace de prueba</a>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<ul><li><p>Prueba</p></li><li><p>Prueba</p></li></ul>'
                    },
                  },
                  {
                    type: 1,
                    order: 0,
                    image: '../assets/images/2.jpg',
                  },
                  {
                    type: 0,
                    order: 0,
                    content: {
                      es: '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      ''
                    }
                  },
                  {
                    type: 3,
                    order: 0,
                    websectiondataitem: [
                      {
                        image: '../assets/images/1.jpg',
                      },
                      {
                        image: '../assets/images/2.jpg',
                      },
                      {
                        image: '../assets/images/3.jpg',
                      }
                    ]
                  },

                  {
                    type: 2,
                    order: 0,
                    link: '8XRSnYzewes',
                  },
                  {
                    type: 0,
                    order: 0,
                    content: {
                      es: '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, sunt, voluptatibus! Aspernatur cumque cupiditate esse fugiat similique! Dignissimos perspiciatis, voluptates!</p>' +
                      ''
                    }
                  },
                ]
              };
              break;
            }
          }*/


        }
      }
    })
})();

(function () {
  'use strict';
  angular
    .module('frontendApp')
    //establece altura a pantalla completa
    .directive('wleft', function () {
      return {
        templateUrl: 'app/scripts/directives/wleft/wleft.html',
        restrict: 'A',
        replace: true,
        scope: {
          //configuracion basica
          sec: '='
        },
        controller: function wleft($scope, $rootScope, toastr, $state, $location, $log,
                                   localStorageService, $window) {
          console.log('hello from directive');
          $scope.sec = $rootScope.secPicked;


        }
      }
    })
})();

/*!
 * Masonry v4.0.0
 * Cascading grid layout library
 * http://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
        'outlayer/outlayer',
        'get-size/get-size'
      ],
      factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('outlayer'),
      require('get-size')
    );
  } else {
    // browser global
    window.Masonry = factory(
      window.Outlayer,
      window.getSize
    );
  }

}( window, function factory( Outlayer, getSize ) {

'use strict';

// -------------------------- masonryDefinition -------------------------- //

  // create an Outlayer layout class
  var Masonry = Outlayer.create('masonry');
  // isFitWidth -> fitWidth
  Masonry.compatOptions.fitWidth = 'isFitWidth';

  Masonry.prototype._resetLayout = function() {
    this.getSize();
    this._getMeasurement( 'columnWidth', 'outerWidth' );
    this._getMeasurement( 'gutter', 'outerWidth' );
    this.measureColumns();

    // reset column Y
    this.colYs = [];
    for ( var i=0; i < this.cols; i++ ) {
      this.colYs.push( 0 );
    }

    this.maxY = 0;
  };

  Masonry.prototype.measureColumns = function() {
    this.getContainerWidth();
    // if columnWidth is 0, default to outerWidth of first item
    if ( !this.columnWidth ) {
      var firstItem = this.items[0];
      var firstItemElem = firstItem && firstItem.element;
      // columnWidth fall back to item of first element
      this.columnWidth = firstItemElem && getSize( firstItemElem ).outerWidth ||
        // if first elem has no width, default to size of container
        this.containerWidth;
    }

    var columnWidth = this.columnWidth += this.gutter;

    // calculate columns
    var containerWidth = this.containerWidth + this.gutter;
    var cols = containerWidth / columnWidth;
    // fix rounding errors, typically with gutters
    var excess = columnWidth - containerWidth % columnWidth;
    // if overshoot is less than a pixel, round up, otherwise floor it
    var mathMethod = excess && excess < 1 ? 'round' : 'floor';
    cols = Math[ mathMethod ]( cols );
    this.cols = Math.max( cols, 1 );
  };

  Masonry.prototype.getContainerWidth = function() {
    // container is parent if fit width
    var isFitWidth = this._getOption('fitWidth');
    var container = isFitWidth ? this.element.parentNode : this.element;
    // check that this.size and size are there
    // IE8 triggers resize on body size change, so they might not be
    var size = getSize( container );
    this.containerWidth = size && size.innerWidth;
  };

  Masonry.prototype._getItemLayoutPosition = function( item ) {
    item.getSize();
    // how many columns does this brick span
    var remainder = item.size.outerWidth % this.columnWidth;
    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
    // round if off by 1 pixel, otherwise use ceil
    var colSpan = Math[ mathMethod ]( item.size.outerWidth / this.columnWidth );
    colSpan = Math.min( colSpan, this.cols );

    var colGroup = this._getColGroup( colSpan );
    // get the minimum Y value from the columns
    var minimumY = Math.min.apply( Math, colGroup );
    var shortColIndex = colGroup.indexOf( minimumY );

    // position the brick
    var position = {
      x: this.columnWidth * shortColIndex,
      y: minimumY
    };

    // apply setHeight to necessary columns
    var setHeight = minimumY + item.size.outerHeight;
    var setSpan = this.cols + 1 - colGroup.length;
    for ( var i = 0; i < setSpan; i++ ) {
      this.colYs[ shortColIndex + i ] = setHeight;
    }

    return position;
  };

  /**
   * @param {Number} colSpan - number of columns the element spans
   * @returns {Array} colGroup
   */
  Masonry.prototype._getColGroup = function( colSpan ) {
    if ( colSpan < 2 ) {
      // if brick spans only one column, use all the column Ys
      return this.colYs;
    }

    var colGroup = [];
    // how many different places could this brick fit horizontally
    var groupCount = this.cols + 1 - colSpan;
    // for each group potential horizontal position
    for ( var i = 0; i < groupCount; i++ ) {
      // make an array of colY values for that one group
      var groupColYs = this.colYs.slice( i, i + colSpan );
      // and get the max value of the array
      colGroup[i] = Math.max.apply( Math, groupColYs );
    }
    return colGroup;
  };

  Masonry.prototype._manageStamp = function( stamp ) {
    var stampSize = getSize( stamp );
    var offset = this._getElementOffset( stamp );
    // get the columns that this stamp affects
    var isOriginLeft = this._getOption('originLeft');
    var firstX = isOriginLeft ? offset.left : offset.right;
    var lastX = firstX + stampSize.outerWidth;
    var firstCol = Math.floor( firstX / this.columnWidth );
    firstCol = Math.max( 0, firstCol );
    var lastCol = Math.floor( lastX / this.columnWidth );
    // lastCol should not go over if multiple of columnWidth #425
    lastCol -= lastX % this.columnWidth ? 0 : 1;
    lastCol = Math.min( this.cols - 1, lastCol );
    // set colYs to bottom of the stamp

    var isOriginTop = this._getOption('originTop');
    var stampMaxY = ( isOriginTop ? offset.top : offset.bottom ) +
      stampSize.outerHeight;
    for ( var i = firstCol; i <= lastCol; i++ ) {
      this.colYs[i] = Math.max( stampMaxY, this.colYs[i] );
    }
  };

  Masonry.prototype._getContainerSize = function() {
    this.maxY = Math.max.apply( Math, this.colYs );
    var size = {
      height: this.maxY
    };

    if ( this._getOption('fitWidth') ) {
      size.width = this._getContainerFitWidth();
    }

    return size;
  };

  Masonry.prototype._getContainerFitWidth = function() {
    var unusedCols = 0;
    // count unused columns
    var i = this.cols;
    while ( --i ) {
      if ( this.colYs[i] !== 0 ) {
        break;
      }
      unusedCols++;
    }
    // fit container to columns that have been used
    return ( this.cols - unusedCols ) * this.columnWidth - this.gutter;
  };

  Masonry.prototype.needsResizeLayout = function() {
    var previousWidth = this.containerWidth;
    this.getContainerWidth();
    return previousWidth != this.containerWidth;
  };

  return Masonry;

}));

'use strict';
angular
  .module('frontendApp')
  .factory('ContentService', function ($http, $rootScope, $log) {
    return {

      getdata: function (tabla, params) {
        $log.log('GETDATA PARAMS', tabla, params);
        return $http.post($rootScope.api + '/api/' + tabla + '/getdata', params);
      },

      websearch: function ( params) {
        $log.log('WEBSEARCH PARAMS', params);
        return $http.post($rootScope.api + '/api/websearch', params);
      },

      webcontent: function (state, params) {
        params['state'] = state;
        $log.log('WEBCONTENT PARAMS', params);
        return $http.post($rootScope.api + '/api/webcontent', params);
      },

      sendform: function (params) {
        return $http.post($rootScope.api + '/api/sendform', params);
      }


    };
  });

/**
 * Created by FER-PC-WIN10 on 03/05/2016.
 */
(function () {
  'use strict';
  angular
    .module('frontendApp')
    .directive('renderHtml', function ($compile) {
      return function (scope, element, attrs) {
        scope.$watch(
          function (scope) {
            return scope.$eval(attrs.renderHtml);
          },
          function (value) {
            element.html(value);
            $compile(element.contents())(scope);
          }
        );
      };
    });
})();

/* -----------------------------------------------
 /* Author : Vincent Garreau  - vincentgarreau.com
 /* MIT license: http://opensource.org/licenses/MIT
 /* Demo / Generator : vincentgarreau.com/particles.js
 /* GitHub : github.com/VincentGarreau/particles.js
 /* How to use? : Check the GitHub README
 /* v2.0.0
 /* ----------------------------------------------- */
function hexToRgb(e) {
  var a = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  e = e.replace(a, function (e, a, t, i) {
    return a + a + t + t + i + i
  });
  var t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return t ? {r: parseInt(t[1], 16), g: parseInt(t[2], 16), b: parseInt(t[3], 16)} : null
}
function clamp(e, a, t) {
  return Math.min(Math.max(e, a), t)
}
function isInArray(e, a) {
  return a.indexOf(e) > -1
}
var pJS = function (e, a) {
  var t = document.querySelector("#" + e + " > .particles-js-canvas-el");
  this.pJS = {
    canvas: {el: t, w: t.offsetWidth, h: t.offsetHeight},
    particles: {
      number: {value: 400, density: {enable: !0, value_area: 800}},
      color: {value: "#fff"},
      shape: {
        type: "circle",
        stroke: {width: 0, color: "#ff0000"},
        polygon: {nb_sides: 5},
        image: {src: "", width: 100, height: 100}
      },
      opacity: {value: 1, random: !1, anim: {enable: !1, speed: 2, opacity_min: 0, sync: !1}},
      size: {value: 20, random: !1, anim: {enable: !1, speed: 20, size_min: 0, sync: !1}},
      line_linked: {enable: !0, distance: 100, color: "#fff", opacity: 1, width: 1},
      move: {
        enable: !0,
        speed: 2,
        direction: "none",
        random: !1,
        straight: !1,
        out_mode: "out",
        bounce: !1,
        attract: {enable: !1, rotateX: 3e3, rotateY: 3e3}
      },
      array: []
    },
    interactivity: {
      detect_on: "canvas",
      events: {onhover: {enable: !0, mode: "grab"}, onclick: {enable: !0, mode: "push"}, resize: !0},
      modes: {
        grab: {distance: 100, line_linked: {opacity: 1}},
        bubble: {distance: 200, size: 80, duration: .4},
        repulse: {distance: 200, duration: .4},
        push: {particles_nb: 4},
        remove: {particles_nb: 2}
      },
      mouse: {}
    },
    retina_detect: !1,
    fn: {interact: {}, modes: {}, vendors: {}},
    tmp: {}
  };
  var i = this.pJS;
  a && Object.deepExtend(i, a), i.tmp.obj = {
    size_value: i.particles.size.value,
    size_anim_speed: i.particles.size.anim.speed,
    move_speed: i.particles.move.speed,
    line_linked_distance: i.particles.line_linked.distance,
    line_linked_width: i.particles.line_linked.width,
    mode_grab_distance: i.interactivity.modes.grab.distance,
    mode_bubble_distance: i.interactivity.modes.bubble.distance,
    mode_bubble_size: i.interactivity.modes.bubble.size,
    mode_repulse_distance: i.interactivity.modes.repulse.distance
  }, i.fn.retinaInit = function () {
    i.retina_detect && window.devicePixelRatio > 1 ? (i.canvas.pxratio = window.devicePixelRatio, i.tmp.retina = !0) : (i.canvas.pxratio = 1, i.tmp.retina = !1), i.canvas.w = i.canvas.el.offsetWidth * i.canvas.pxratio, i.canvas.h = i.canvas.el.offsetHeight * i.canvas.pxratio, i.particles.size.value = i.tmp.obj.size_value * i.canvas.pxratio, i.particles.size.anim.speed = i.tmp.obj.size_anim_speed * i.canvas.pxratio, i.particles.move.speed = i.tmp.obj.move_speed * i.canvas.pxratio, i.particles.line_linked.distance = i.tmp.obj.line_linked_distance * i.canvas.pxratio, i.interactivity.modes.grab.distance = i.tmp.obj.mode_grab_distance * i.canvas.pxratio, i.interactivity.modes.bubble.distance = i.tmp.obj.mode_bubble_distance * i.canvas.pxratio, i.particles.line_linked.width = i.tmp.obj.line_linked_width * i.canvas.pxratio, i.interactivity.modes.bubble.size = i.tmp.obj.mode_bubble_size * i.canvas.pxratio, i.interactivity.modes.repulse.distance = i.tmp.obj.mode_repulse_distance * i.canvas.pxratio
  }, i.fn.canvasInit = function () {
    i.canvas.ctx = i.canvas.el.getContext("2d")
  }, i.fn.canvasSize = function () {
    i.canvas.el.width = i.canvas.w, i.canvas.el.height = i.canvas.h, i && i.interactivity.events.resize && window.addEventListener("resize", function () {
      i.canvas.w = i.canvas.el.offsetWidth, i.canvas.h = i.canvas.el.offsetHeight, i.tmp.retina && (i.canvas.w *= i.canvas.pxratio, i.canvas.h *= i.canvas.pxratio), i.canvas.el.width = i.canvas.w, i.canvas.el.height = i.canvas.h, i.particles.move.enable || (i.fn.particlesEmpty(), i.fn.particlesCreate(), i.fn.particlesDraw(), i.fn.vendors.densityAutoParticles()), i.fn.vendors.densityAutoParticles()
    })
  }, i.fn.canvasPaint = function () {
    i.canvas.ctx.fillRect(0, 0, i.canvas.w, i.canvas.h)
  }, i.fn.canvasClear = function () {
    i.canvas.ctx.clearRect(0, 0, i.canvas.w, i.canvas.h)
  }, i.fn.particle = function (e, a, t) {
    if (this.radius = (i.particles.size.random ? Math.random() : 1) * i.particles.size.value, i.particles.size.anim.enable && (this.size_status = !1, this.vs = i.particles.size.anim.speed / 100, i.particles.size.anim.sync || (this.vs = this.vs * Math.random())), this.x = t ? t.x : Math.random() * i.canvas.w, this.y = t ? t.y : Math.random() * i.canvas.h, this.x > i.canvas.w - 2 * this.radius ? this.x = this.x - this.radius : this.x < 2 * this.radius && (this.x = this.x + this.radius), this.y > i.canvas.h - 2 * this.radius ? this.y = this.y - this.radius : this.y < 2 * this.radius && (this.y = this.y + this.radius), i.particles.move.bounce && i.fn.vendors.checkOverlap(this, t), this.color = {}, "object" == typeof e.value)if (e.value instanceof Array) {
      var s = e.value[Math.floor(Math.random() * i.particles.color.value.length)];
      this.color.rgb = hexToRgb(s)
    } else void 0 != e.value.r && void 0 != e.value.g && void 0 != e.value.b && (this.color.rgb = {
      r: e.value.r,
      g: e.value.g,
      b: e.value.b
    }), void 0 != e.value.h && void 0 != e.value.s && void 0 != e.value.l && (this.color.hsl = {
      h: e.value.h,
      s: e.value.s,
      l: e.value.l
    }); else"random" == e.value ? this.color.rgb = {
      r: Math.floor(256 * Math.random()) + 0,
      g: Math.floor(256 * Math.random()) + 0,
      b: Math.floor(256 * Math.random()) + 0
    } : "string" == typeof e.value && (this.color = e, this.color.rgb = hexToRgb(this.color.value));
    this.opacity = (i.particles.opacity.random ? Math.random() : 1) * i.particles.opacity.value, i.particles.opacity.anim.enable && (this.opacity_status = !1, this.vo = i.particles.opacity.anim.speed / 100, i.particles.opacity.anim.sync || (this.vo = this.vo * Math.random()));
    var n = {};
    switch (i.particles.move.direction) {
      case"top":
        n = {x: 0, y: -1};
        break;
      case"top-right":
        n = {x: .5, y: -.5};
        break;
      case"right":
        n = {x: 1, y: -0};
        break;
      case"bottom-right":
        n = {x: .5, y: .5};
        break;
      case"bottom":
        n = {x: 0, y: 1};
        break;
      case"bottom-left":
        n = {x: -.5, y: 1};
        break;
      case"left":
        n = {x: -1, y: 0};
        break;
      case"top-left":
        n = {x: -.5, y: -.5};
        break;
      default:
        n = {x: 0, y: 0}
    }
    i.particles.move.straight ? (this.vx = n.x, this.vy = n.y, i.particles.move.random && (this.vx = this.vx * Math.random(), this.vy = this.vy * Math.random())) : (this.vx = n.x + Math.random() - .5, this.vy = n.y + Math.random() - .5), this.vx_i = this.vx, this.vy_i = this.vy;
    var r = i.particles.shape.type;
    if ("object" == typeof r) {
      if (r instanceof Array) {
        var c = r[Math.floor(Math.random() * r.length)];
        this.shape = c
      }
    } else this.shape = r;
    if ("image" == this.shape) {
      var o = i.particles.shape;
      this.img = {
        src: o.image.src,
        ratio: o.image.width / o.image.height
      }, this.img.ratio || (this.img.ratio = 1), "svg" == i.tmp.img_type && void 0 != i.tmp.source_svg && (i.fn.vendors.createSvgImg(this), i.tmp.pushing && (this.img.loaded = !1))
    }
  }, i.fn.particle.prototype.draw = function () {
    function e() {
      i.canvas.ctx.drawImage(r, a.x - t, a.y - t, 2 * t, 2 * t / a.img.ratio)
    }

    var a = this;
    if (void 0 != a.radius_bubble)var t = a.radius_bubble; else var t = a.radius;
    if (void 0 != a.opacity_bubble)var s = a.opacity_bubble; else var s = a.opacity;
    if (a.color.rgb)var n = "rgba(" + a.color.rgb.r + "," + a.color.rgb.g + "," + a.color.rgb.b + "," + s + ")"; else var n = "hsla(" + a.color.hsl.h + "," + a.color.hsl.s + "%," + a.color.hsl.l + "%," + s + ")";
    switch (i.canvas.ctx.fillStyle = n, i.canvas.ctx.beginPath(), a.shape) {
      case"circle":
        i.canvas.ctx.arc(a.x, a.y, t, 0, 2 * Math.PI, !1);
        break;
      case"edge":
        i.canvas.ctx.rect(a.x - t, a.y - t, 2 * t, 2 * t);
        break;
      case"triangle":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - t, a.y + t / 1.66, 2 * t, 3, 2);
        break;
      case"polygon":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - t / (i.particles.shape.polygon.nb_sides / 3.5), a.y - t / .76, 2.66 * t / (i.particles.shape.polygon.nb_sides / 3), i.particles.shape.polygon.nb_sides, 1);
        break;
      case"star":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - 2 * t / (i.particles.shape.polygon.nb_sides / 4), a.y - t / 1.52, 2 * t * 2.66 / (i.particles.shape.polygon.nb_sides / 3), i.particles.shape.polygon.nb_sides, 2);
        break;
      case"image":
        if ("svg" == i.tmp.img_type)var r = a.img.obj; else var r = i.tmp.img_obj;
        r && e()
    }
    i.canvas.ctx.closePath(), i.particles.shape.stroke.width > 0 && (i.canvas.ctx.strokeStyle = i.particles.shape.stroke.color, i.canvas.ctx.lineWidth = i.particles.shape.stroke.width, i.canvas.ctx.stroke()), i.canvas.ctx.fill()
  }, i.fn.particlesCreate = function () {
    for (var e = 0; e < i.particles.number.value; e++)i.particles.array.push(new i.fn.particle(i.particles.color, i.particles.opacity.value))
  }, i.fn.particlesUpdate = function () {
    for (var e = 0; e < i.particles.array.length; e++) {
      var a = i.particles.array[e];
      if (i.particles.move.enable) {
        var t = i.particles.move.speed / 2;
        a.x += a.vx * t, a.y += a.vy * t
      }
      if (i.particles.opacity.anim.enable && (1 == a.opacity_status ? (a.opacity >= i.particles.opacity.value && (a.opacity_status = !1), a.opacity += a.vo) : (a.opacity <= i.particles.opacity.anim.opacity_min && (a.opacity_status = !0), a.opacity -= a.vo), a.opacity < 0 && (a.opacity = 0)), i.particles.size.anim.enable && (1 == a.size_status ? (a.radius >= i.particles.size.value && (a.size_status = !1), a.radius += a.vs) : (a.radius <= i.particles.size.anim.size_min && (a.size_status = !0), a.radius -= a.vs), a.radius < 0 && (a.radius = 0)), "bounce" == i.particles.move.out_mode)var s = {
        x_left: a.radius,
        x_right: i.canvas.w,
        y_top: a.radius,
        y_bottom: i.canvas.h
      }; else var s = {
        x_left: -a.radius,
        x_right: i.canvas.w + a.radius,
        y_top: -a.radius,
        y_bottom: i.canvas.h + a.radius
      };
      switch (a.x - a.radius > i.canvas.w ? (a.x = s.x_left, a.y = Math.random() * i.canvas.h) : a.x + a.radius < 0 && (a.x = s.x_right, a.y = Math.random() * i.canvas.h), a.y - a.radius > i.canvas.h ? (a.y = s.y_top, a.x = Math.random() * i.canvas.w) : a.y + a.radius < 0 && (a.y = s.y_bottom, a.x = Math.random() * i.canvas.w), i.particles.move.out_mode) {
        case"bounce":
          a.x + a.radius > i.canvas.w ? a.vx = -a.vx : a.x - a.radius < 0 && (a.vx = -a.vx), a.y + a.radius > i.canvas.h ? a.vy = -a.vy : a.y - a.radius < 0 && (a.vy = -a.vy)
      }
      if (isInArray("grab", i.interactivity.events.onhover.mode) && i.fn.modes.grabParticle(a), (isInArray("bubble", i.interactivity.events.onhover.mode) || isInArray("bubble", i.interactivity.events.onclick.mode)) && i.fn.modes.bubbleParticle(a), (isInArray("repulse", i.interactivity.events.onhover.mode) || isInArray("repulse", i.interactivity.events.onclick.mode)) && i.fn.modes.repulseParticle(a), i.particles.line_linked.enable || i.particles.move.attract.enable)for (var n = e + 1; n < i.particles.array.length; n++) {
        var r = i.particles.array[n];
        i.particles.line_linked.enable && i.fn.interact.linkParticles(a, r), i.particles.move.attract.enable && i.fn.interact.attractParticles(a, r), i.particles.move.bounce && i.fn.interact.bounceParticles(a, r)
      }
    }
  }, i.fn.particlesDraw = function () {
    i.canvas.ctx.clearRect(0, 0, i.canvas.w, i.canvas.h), i.fn.particlesUpdate();
    for (var e = 0; e < i.particles.array.length; e++) {
      var a = i.particles.array[e];
      a.draw()
    }
  }, i.fn.particlesEmpty = function () {
    i.particles.array = []
  }, i.fn.particlesRefresh = function () {
    cancelRequestAnimFrame(i.fn.checkAnimFrame), cancelRequestAnimFrame(i.fn.drawAnimFrame), i.tmp.source_svg = void 0, i.tmp.img_obj = void 0, i.tmp.count_svg = 0, i.fn.particlesEmpty(), i.fn.canvasClear(), i.fn.vendors.start()
  }, i.fn.interact.linkParticles = function (e, a) {
    var t = e.x - a.x, s = e.y - a.y, n = Math.sqrt(t * t + s * s);
    if (n <= i.particles.line_linked.distance) {
      var r = i.particles.line_linked.opacity - n / (1 / i.particles.line_linked.opacity) / i.particles.line_linked.distance;
      if (r > 0) {
        var c = i.particles.line_linked.color_rgb_line;
        i.canvas.ctx.strokeStyle = "rgba(" + c.r + "," + c.g + "," + c.b + "," + r + ")", i.canvas.ctx.lineWidth = i.particles.line_linked.width, i.canvas.ctx.beginPath(), i.canvas.ctx.moveTo(e.x, e.y), i.canvas.ctx.lineTo(a.x, a.y), i.canvas.ctx.stroke(), i.canvas.ctx.closePath()
      }
    }
  }, i.fn.interact.attractParticles = function (e, a) {
    var t = e.x - a.x, s = e.y - a.y, n = Math.sqrt(t * t + s * s);
    if (n <= i.particles.line_linked.distance) {
      var r = t / (1e3 * i.particles.move.attract.rotateX), c = s / (1e3 * i.particles.move.attract.rotateY);
      e.vx -= r, e.vy -= c, a.vx += r, a.vy += c
    }
  }, i.fn.interact.bounceParticles = function (e, a) {
    var t = e.x - a.x, i = e.y - a.y, s = Math.sqrt(t * t + i * i), n = e.radius + a.radius;
    n >= s && (e.vx = -e.vx, e.vy = -e.vy, a.vx = -a.vx, a.vy = -a.vy)
  }, i.fn.modes.pushParticles = function (e, a) {
    i.tmp.pushing = !0;
    for (var t = 0; e > t; t++)i.particles.array.push(new i.fn.particle(i.particles.color, i.particles.opacity.value, {
      x: a ? a.pos_x : Math.random() * i.canvas.w,
      y: a ? a.pos_y : Math.random() * i.canvas.h
    })), t == e - 1 && (i.particles.move.enable || i.fn.particlesDraw(), i.tmp.pushing = !1)
  }, i.fn.modes.removeParticles = function (e) {
    i.particles.array.splice(0, e), i.particles.move.enable || i.fn.particlesDraw()
  }, i.fn.modes.bubbleParticle = function (e) {
    function a() {
      e.opacity_bubble = e.opacity, e.radius_bubble = e.radius
    }

    function t(a, t, s, n, c) {
      if (a != t)if (i.tmp.bubble_duration_end) {
        if (void 0 != s) {
          var o = n - p * (n - a) / i.interactivity.modes.bubble.duration, l = a - o;
          d = a + l, "size" == c && (e.radius_bubble = d), "opacity" == c && (e.opacity_bubble = d)
        }
      } else if (r <= i.interactivity.modes.bubble.distance) {
        if (void 0 != s)var v = s; else var v = n;
        if (v != a) {
          var d = n - p * (n - a) / i.interactivity.modes.bubble.duration;
          "size" == c && (e.radius_bubble = d), "opacity" == c && (e.opacity_bubble = d)
        }
      } else"size" == c && (e.radius_bubble = void 0), "opacity" == c && (e.opacity_bubble = void 0)
    }

    if (i.interactivity.events.onhover.enable && isInArray("bubble", i.interactivity.events.onhover.mode)) {
      var s = e.x - i.interactivity.mouse.pos_x, n = e.y - i.interactivity.mouse.pos_y, r = Math.sqrt(s * s + n * n), c = 1 - r / i.interactivity.modes.bubble.distance;
      if (r <= i.interactivity.modes.bubble.distance) {
        if (c >= 0 && "mousemove" == i.interactivity.status) {
          if (i.interactivity.modes.bubble.size != i.particles.size.value)if (i.interactivity.modes.bubble.size > i.particles.size.value) {
            var o = e.radius + i.interactivity.modes.bubble.size * c;
            o >= 0 && (e.radius_bubble = o)
          } else {
            var l = e.radius - i.interactivity.modes.bubble.size, o = e.radius - l * c;
            o > 0 ? e.radius_bubble = o : e.radius_bubble = 0
          }
          if (i.interactivity.modes.bubble.opacity != i.particles.opacity.value)if (i.interactivity.modes.bubble.opacity > i.particles.opacity.value) {
            var v = i.interactivity.modes.bubble.opacity * c;
            v > e.opacity && v <= i.interactivity.modes.bubble.opacity && (e.opacity_bubble = v)
          } else {
            var v = e.opacity - (i.particles.opacity.value - i.interactivity.modes.bubble.opacity) * c;
            v < e.opacity && v >= i.interactivity.modes.bubble.opacity && (e.opacity_bubble = v)
          }
        }
      } else a();
      "mouseleave" == i.interactivity.status && a()
    } else if (i.interactivity.events.onclick.enable && isInArray("bubble", i.interactivity.events.onclick.mode)) {
      if (i.tmp.bubble_clicking) {
        var s = e.x - i.interactivity.mouse.click_pos_x, n = e.y - i.interactivity.mouse.click_pos_y, r = Math.sqrt(s * s + n * n), p = ((new Date).getTime() - i.interactivity.mouse.click_time) / 1e3;
        p > i.interactivity.modes.bubble.duration && (i.tmp.bubble_duration_end = !0), p > 2 * i.interactivity.modes.bubble.duration && (i.tmp.bubble_clicking = !1, i.tmp.bubble_duration_end = !1)
      }
      i.tmp.bubble_clicking && (t(i.interactivity.modes.bubble.size, i.particles.size.value, e.radius_bubble, e.radius, "size"), t(i.interactivity.modes.bubble.opacity, i.particles.opacity.value, e.opacity_bubble, e.opacity, "opacity"))
    }
  }, i.fn.modes.repulseParticle = function (e) {
    function a() {
      var a = Math.atan2(d, p);
      if (e.vx = u * Math.cos(a), e.vy = u * Math.sin(a), "bounce" == i.particles.move.out_mode) {
        var t = {x: e.x + e.vx, y: e.y + e.vy};
        t.x + e.radius > i.canvas.w ? e.vx = -e.vx : t.x - e.radius < 0 && (e.vx = -e.vx), t.y + e.radius > i.canvas.h ? e.vy = -e.vy : t.y - e.radius < 0 && (e.vy = -e.vy)
      }
    }

    if (i.interactivity.events.onhover.enable && isInArray("repulse", i.interactivity.events.onhover.mode) && "mousemove" == i.interactivity.status) {
      var t = e.x - i.interactivity.mouse.pos_x, s = e.y - i.interactivity.mouse.pos_y, n = Math.sqrt(t * t + s * s), r = {
        x: t / n,
        y: s / n
      }, c = i.interactivity.modes.repulse.distance, o = 100, l = clamp(1 / c * (-1 * Math.pow(n / c, 2) + 1) * c * o, 0, 50), v = {
        x: e.x + r.x * l,
        y: e.y + r.y * l
      };
      "bounce" == i.particles.move.out_mode ? (v.x - e.radius > 0 && v.x + e.radius < i.canvas.w && (e.x = v.x), v.y - e.radius > 0 && v.y + e.radius < i.canvas.h && (e.y = v.y)) : (e.x = v.x, e.y = v.y)
    } else if (i.interactivity.events.onclick.enable && isInArray("repulse", i.interactivity.events.onclick.mode))if (i.tmp.repulse_finish || (i.tmp.repulse_count++, i.tmp.repulse_count == i.particles.array.length && (i.tmp.repulse_finish = !0)), i.tmp.repulse_clicking) {
      var c = Math.pow(i.interactivity.modes.repulse.distance / 6, 3), p = i.interactivity.mouse.click_pos_x - e.x, d = i.interactivity.mouse.click_pos_y - e.y, m = p * p + d * d, u = -c / m * 1;
      c >= m && a()
    } else 0 == i.tmp.repulse_clicking && (e.vx = e.vx_i, e.vy = e.vy_i)
  }, i.fn.modes.grabParticle = function (e) {
    if (i.interactivity.events.onhover.enable && "mousemove" == i.interactivity.status) {
      var a = e.x - i.interactivity.mouse.pos_x, t = e.y - i.interactivity.mouse.pos_y, s = Math.sqrt(a * a + t * t);
      if (s <= i.interactivity.modes.grab.distance) {
        var n = i.interactivity.modes.grab.line_linked.opacity - s / (1 / i.interactivity.modes.grab.line_linked.opacity) / i.interactivity.modes.grab.distance;
        if (n > 0) {
          var r = i.particles.line_linked.color_rgb_line;
          i.canvas.ctx.strokeStyle = "rgba(" + r.r + "," + r.g + "," + r.b + "," + n + ")", i.canvas.ctx.lineWidth = i.particles.line_linked.width, i.canvas.ctx.beginPath(), i.canvas.ctx.moveTo(e.x, e.y), i.canvas.ctx.lineTo(i.interactivity.mouse.pos_x, i.interactivity.mouse.pos_y), i.canvas.ctx.stroke(), i.canvas.ctx.closePath()
        }
      }
    }
  }, i.fn.vendors.eventsListeners = function () {
    "window" == i.interactivity.detect_on ? i.interactivity.el = window : i.interactivity.el = i.canvas.el, (i.interactivity.events.onhover.enable || i.interactivity.events.onclick.enable) && (i.interactivity.el.addEventListener("mousemove", function (e) {
      if (i.interactivity.el == window)var a = e.clientX, t = e.clientY; else var a = e.offsetX || e.clientX, t = e.offsetY || e.clientY;
      i.interactivity.mouse.pos_x = a, i.interactivity.mouse.pos_y = t, i.tmp.retina && (i.interactivity.mouse.pos_x *= i.canvas.pxratio, i.interactivity.mouse.pos_y *= i.canvas.pxratio), i.interactivity.status = "mousemove"
    }), i.interactivity.el.addEventListener("mouseleave", function (e) {
      i.interactivity.mouse.pos_x = null, i.interactivity.mouse.pos_y = null, i.interactivity.status = "mouseleave"
    })), i.interactivity.events.onclick.enable && i.interactivity.el.addEventListener("click", function () {
      if (i.interactivity.mouse.click_pos_x = i.interactivity.mouse.pos_x, i.interactivity.mouse.click_pos_y = i.interactivity.mouse.pos_y, i.interactivity.mouse.click_time = (new Date).getTime(), i.interactivity.events.onclick.enable)switch (i.interactivity.events.onclick.mode) {
        case"push":
          i.particles.move.enable ? i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb, i.interactivity.mouse) : 1 == i.interactivity.modes.push.particles_nb ? i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb, i.interactivity.mouse) : i.interactivity.modes.push.particles_nb > 1 && i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb);
          break;
        case"remove":
          i.fn.modes.removeParticles(i.interactivity.modes.remove.particles_nb);
          break;
        case"bubble":
          i.tmp.bubble_clicking = !0;
          break;
        case"repulse":
          i.tmp.repulse_clicking = !0, i.tmp.repulse_count = 0, i.tmp.repulse_finish = !1, setTimeout(function () {
            i.tmp.repulse_clicking = !1
          }, 1e3 * i.interactivity.modes.repulse.duration)
      }
    })
  }, i.fn.vendors.densityAutoParticles = function () {
    if (i.particles.number.density.enable) {
      var e = i.canvas.el.width * i.canvas.el.height / 1e3;
      i.tmp.retina && (e /= 2 * i.canvas.pxratio);
      var a = e * i.particles.number.value / i.particles.number.density.value_area, t = i.particles.array.length - a;
      0 > t ? i.fn.modes.pushParticles(Math.abs(t)) : i.fn.modes.removeParticles(t)
    }
  }, i.fn.vendors.checkOverlap = function (e, a) {
    for (var t = 0; t < i.particles.array.length; t++) {
      var s = i.particles.array[t], n = e.x - s.x, r = e.y - s.y, c = Math.sqrt(n * n + r * r);
      c <= e.radius + s.radius && (e.x = a ? a.x : Math.random() * i.canvas.w, e.y = a ? a.y : Math.random() * i.canvas.h, i.fn.vendors.checkOverlap(e))
    }
  }, i.fn.vendors.createSvgImg = function (e) {
    var a = i.tmp.source_svg, t = /#([0-9A-F]{3,6})/gi, s = a.replace(t, function (a, t, i, s) {
      if (e.color.rgb)var n = "rgba(" + e.color.rgb.r + "," + e.color.rgb.g + "," + e.color.rgb.b + "," + e.opacity + ")"; else var n = "hsla(" + e.color.hsl.h + "," + e.color.hsl.s + "%," + e.color.hsl.l + "%," + e.opacity + ")";
      return n
    }), n = new Blob([s], {type: "image/svg+xml;charset=utf-8"}), r = window.URL || window.webkitURL || window, c = r.createObjectURL(n), o = new Image;
    o.addEventListener("load", function () {
      e.img.obj = o, e.img.loaded = !0, r.revokeObjectURL(c), i.tmp.count_svg++
    }), o.src = c
  }, i.fn.vendors.destroypJS = function () {
    cancelAnimationFrame(i.fn.drawAnimFrame), t.remove(), pJSDom = null
  }, i.fn.vendors.drawShape = function (e, a, t, i, s, n) {
    var r = s * n, c = s / n, o = 180 * (c - 2) / c, l = Math.PI - Math.PI * o / 180;
    e.save(), e.beginPath(), e.translate(a, t), e.moveTo(0, 0);
    for (var v = 0; r > v; v++)e.lineTo(i, 0), e.translate(i, 0), e.rotate(l);
    e.fill(), e.restore()
  }, i.fn.vendors.exportImg = function () {
    window.open(i.canvas.el.toDataURL("image/png"), "_blank")
  }, i.fn.vendors.loadImg = function (e) {
    if (i.tmp.img_error = void 0, "" != i.particles.shape.image.src)if ("svg" == e) {
      var a = new XMLHttpRequest;
      a.open("GET", i.particles.shape.image.src), a.onreadystatechange = function (e) {
        4 == a.readyState && (200 == a.status ? (i.tmp.source_svg = e.currentTarget.response, i.fn.vendors.checkBeforeDraw()) : (console.log("Error pJS - Image not found"), i.tmp.img_error = !0))
      }, a.send()
    } else {
      var t = new Image;
      t.addEventListener("load", function () {
        i.tmp.img_obj = t, i.fn.vendors.checkBeforeDraw()
      }), t.src = i.particles.shape.image.src
    } else console.log("Error pJS - No image.src"), i.tmp.img_error = !0
  }, i.fn.vendors.draw = function () {
    "image" == i.particles.shape.type ? "svg" == i.tmp.img_type ? i.tmp.count_svg >= i.particles.number.value ? (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame)) : i.tmp.img_error || (i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw)) : void 0 != i.tmp.img_obj ? (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame)) : i.tmp.img_error || (i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw)) : (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame))
  }, i.fn.vendors.checkBeforeDraw = function () {
    "image" == i.particles.shape.type ? "svg" == i.tmp.img_type && void 0 == i.tmp.source_svg ? i.tmp.checkAnimFrame = requestAnimFrame(check) : (cancelRequestAnimFrame(i.tmp.checkAnimFrame), i.tmp.img_error || (i.fn.vendors.init(), i.fn.vendors.draw())) : (i.fn.vendors.init(), i.fn.vendors.draw())
  }, i.fn.vendors.init = function () {
    i.fn.retinaInit(), i.fn.canvasInit(), i.fn.canvasSize(), i.fn.canvasPaint(), i.fn.particlesCreate(), i.fn.vendors.densityAutoParticles(), i.particles.line_linked.color_rgb_line = hexToRgb(i.particles.line_linked.color)
  }, i.fn.vendors.start = function () {
    isInArray("image", i.particles.shape.type) ? (i.tmp.img_type = i.particles.shape.image.src.substr(i.particles.shape.image.src.length - 3), i.fn.vendors.loadImg(i.tmp.img_type)) : i.fn.vendors.checkBeforeDraw()
  }, i.fn.vendors.eventsListeners(), i.fn.vendors.start()
};
Object.deepExtend = function (e, a) {
  for (var t in a)a[t] && a[t].constructor && a[t].constructor === Object ? (e[t] = e[t] || {}, arguments.callee(e[t], a[t])) : e[t] = a[t];
  return e
}, window.requestAnimFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (e) {
      window.setTimeout(e, 1e3 / 60)
    }
}(), window.cancelRequestAnimFrame = function () {
  return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame || window.oCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame || clearTimeout
}(), window.pJSDom = [], window.particlesJS = function (e, a) {
  "string" != typeof e && (a = e, e = "particles-js"), e || (e = "particles-js");
  var t = document.getElementById(e), i = "particles-js-canvas-el", s = t.getElementsByClassName(i);
  if (s.length)for (; s.length > 0;)t.removeChild(s[0]);
  var n = document.createElement("canvas");
  n.className = i, n.style.width = "100%", n.style.height = "100%";
  var r = document.getElementById(e).appendChild(n);
  null != r && pJSDom.push(new pJS(e, a))
}, window.particlesJS.load = function (e, a, t) {
  var i = new XMLHttpRequest;
  i.open("GET", a), i.onreadystatechange = function (a) {
    if (4 == i.readyState)if (200 == i.status) {
      var s = JSON.parse(a.currentTarget.response);
      window.particlesJS(e, s), t && t()
    } else console.log("Error pJS - XMLHttpRequest status: " + i.status), console.log("Error pJS - File config not found")
  }, i.send()
};
/**
 * Created by DELL on 18/7/2018.
 */

(function () {
  'use strict';
  angular
    .module('frontendApp')
    //establece altura a pantalla completa
    .directive('loader', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()});
            //console.log('exit')
          }).resize();
        }
      };
    })
    .directive('windowheight', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()});
            //console.log('exit')
          }).resize();
        }
      };
    })
    .directive('windowheight2', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()});
         //   element.css({maxHeight: $(window).height()});
          //  element.css({overflowY: 'scroll'});
            element.css({overflowX: 'visible'});
            element.css({overflowY: 'visible'});
            /*if($(window).width() >= 1024){
              element.css({overflowY: 'scroll'});
            }
            else{
              element.css({overflowY: 'visible'});
            }*/
            //console.log('exit')
          }).resize();
        }
      };
    })
    .directive('windowhalf', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
          /*  var size = ($(window).width()/2)/300;
            var total = Math.round(size);*/
            var mobile = ($(window).width() >= 1024) ? 2 : 1;
            var totalwidth = (parseInt($(window).width() / mobile) / 300);
            var size = (Math.floor(totalwidth)) * 300;

            element.css({width: size});
            //console.log('exit')
          }).resize();
        }
      };
    })
    .directive('windowsearch', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
          /*  var size = ($(window).width()/2)/300;
            var total = Math.round(size);*/
            var mobile = ($(window).width() >= 1024) ? 1 : 1;
            var totalwidth = (parseInt($(window).width() / mobile) / 300);
            var size = (Math.floor(totalwidth)) * 300;

            element.css({width: size});
            //console.log('exit')
          }).resize();
        }
      };
    })
    //carga video
    .directive('myYoutube', function ($sce) {
      return {
        restrict: 'A',
        scope: {code: '='},
        replace: true,
        template: '<div style="width:100%;"><iframe style="overflow:hidden;height:100%;width:100%" width="100%" height="100%" src="{{url}}" frameborder="0" allowfullscreen></iframe></div>',
        link: function (scope) {
          //console.log('here');
          scope.$watch('code', function (newVal) {
            if (newVal) {
              scope.url = $sce.trustAsResourceUrl("https://www.youtube.com/embed/" + newVal);
            }
          });
        }
      };
    })
    //Iguala altura entre elementos
    //targetclass = nombre de la clase para igualar alturas de elementos
    .directive('equalheight', function ($timeout) {
      return {
        restrict: 'A',
        scope: {
          targetclass: '@',
          full: '=',
        },
        link: function (scope, element) {
          $(window).resize(function () {
            console.log('targetclass',scope.targetclass);
            $timeout(function () {
              var x = document.getElementsByClassName(scope.targetclass);
              var temp = 0;
              for (var i = 0; i < x.length; i++) {
                if (temp < x[i].offsetHeight) {
                  temp = x[i].offsetHeight;
                }
              }
              element.css({minHeight: temp});
            }, 1000);
          }).resize();
        }
      };
    }).directive('magazine', function ($timeout) {
      return {
        restrict: 'A',
        scope: {
          targetclass: '@',
        },
        link: function (scope, element) {
          $(window).resize(function () {
            console.log('targetclass',scope.targetclass);
            $timeout(function () {
              var x = document.getElementsByClassName(scope.targetclass);
              element.css({minHeight: x[0].offsetWidth*1.25});
            }, 1000);
          }).resize();
        }
      };
    })
    //Iguala altura entre elementos
    //targetclass = nombre de la clase para igualar alturas de elementos
    .directive('squareheight', function ($timeout) {
      return {
        restrict: 'A',
        scope: {
          targetclass: '@'
        },
        link: function (scope, element) {
          $(window).resize(function () {
            console.log('targetclass', scope.targetclass)
            $timeout(function () {
              var x = document.getElementsByClassName(scope.targetclass);
              var temp = 0;
              for (var i = 0; i < x.length; i++) {
                if (temp < x[i].offsetWidth) {
                  temp = x[i].offsetWidth;
                }
              }

              //console.log('maximo altura detectada', temp);
              element.css({minHeight: temp});
              element.css({maxHeight: temp});
              element.css({height: temp});
            }, 1000);
          }).resize();
        }
      };
    })
    //establece una altura personalizada partiendo del alto de pantalla o deua medida especifica
    .directive('customheight', function () {
      return {
        restrict: 'A',
        scope: {
          minus: '=',
          plus: '=',
          equal: '=',
          autoscroll: '=',
          lockscroll:'='
        },
        link: function (scope, element) {
          $(window).resize(function () {
            var customHeight = $(window).height();
            if (scope.equal) {
              customHeight = scope.equal;
            }
            if (scope.minus) {
              customHeight -= scope.minus;
            }
            if (scope.plus) {
              customHeight += scope.plus;
            }
            if (scope.autoscroll == true) {
              element.css({maxHeight: customHeight});
              element.css({overflowY: 'scroll'});
            }
            element.css({minHeight: customHeight});
            if(scope.lockscroll==true){
              element.css({maxHeight: customHeight});
              element.css({overflow: 'hidden'});
            }
          }).resize();
        }
      };
    })
    //scroll control
    .directive('scroll', function () {
      return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
          elem.on('scroll', function (e) {
            console.log('detecta')
          });
        }
      };
    })
})();

'use strict';
angular
  .module('frontendApp')
  .controller('HomeController',function ($state, $log, $rootScope, $scope,$timeout,toastr,
                                         ContentService) {
    var vm = this;
    $log.debug('HomeController');


 /*   vm.preload = function(){
      vm.alias = $state.params.alias;
      ContentService.getdata('websection', {
        filters: {
          name: {
            value: vm.alias,
            operator: 'like'
          }
        }
      })
        .success(function (res) {
          console.log('salida res', res);
          if (res.status) {

          }

        });
    };

    vm.preload();
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      vm.preload();
    });*/


  })

;

'use strict';
angular
  .module('frontendApp')
  .controller('AppController', function ($state, $log, $rootScope, $scope, $timeout, toastr,
                                         ContentService, $stateParams) {
    var vm = this;
    $log.debug('AppController');

    /*************** UI TEXT AND TRANSLATIONS **************/
    $rootScope.wct = {};
    $rootScope.uiText = {
      //PÁGINA DE INICIO
      home: {
        cta: {
          es: 'Áreas de especialidad',
          en: 'Areas of expertise',
          fr: 'Domaines de spécialisation',
          pt: 'Áreas De Atuação'
        },
      },
      //FORMULARIO DE CONTACTO
      contact: {
        title: {
          es: 'Escríbenos',
          en: 'Write us',
          fr: 'Écrivez-nous',
          pt: 'Escreva-nos'},
        placeholder1: {
          es: 'Nombre',
          en: 'Name',
          fr: 'Nom',
          pt: 'Nome'
        },
        placeholder2: {
          es: 'Email',
          en: 'Email',
          fr: 'Email',
          pt: 'Email'
        },
        placeholder3: {
          es: 'Mensaje',
          en: 'Message',
          fr: 'Message',
          pt: 'Mensagem'
        },
        messageSuccess: {
          es: 'Mensaje enviado, muchas gracias',
          en: 'Message sent, thank you very much',
          fr: 'Message envoyé, merci beaucoup',
          pt: 'Mensagem enviada, muito obrigado'
        },
        messageError: {
          es: 'Fallo al enviar el mensaje, intente nuevamente',
          en: 'Failed to send message, try again',
          fr: 'Échec de l\'envoi du message, réessayez',
          pt: 'Falha no envio da mensagem, tente novamente'
        },
      },
      //FILTRO EN PROFESIONALES
      proffesional:{
        cat:{
          es: 'Ciudad',
          en: 'City',
          fr: 'Ville',
          pt: 'Cidade'
        }
      },
      //FILTRO EN NOTICIAS
      news:{
        cat:{
          es: 'Categoría',
          en: 'Category',
          fr: 'Catégorie',
          pt: 'Categoría'
        }
      },
      //BOTÓN EN CONTACTOS
      cities:{
        mapsButton: {
          es:'Abrir en Google Maps',
          en:'Open in Google Maps',
          fr:'Ouvrir dans Google Maps',
          pt:'Abrir no Google Maps'
        }
      }
    };

    $rootScope.temporalElement = function (name, image, tag, legend) {
      $rootScope.tempPicked = {
        name: name,
        image: image,
        tag: tag,
        legend: legend,
        //extra: (extra)? true: false
      };
      $rootScope.setSessionParam('tempPicked', $rootScope.tempPicked );
      console.log('tempPicked', $rootScope.tempPicked);
    };

    /*************** APP MENU **************/
    $rootScope.menu = false;
    $rootScope.menuBack = '';
    $rootScope.showMenu = function (value) {
      $rootScope.menu = (value) ? value : !$rootScope.menu;
      $rootScope.menuBack = $rootScope.wc.webroute[0].image;
      console.log('$rootScope.wc',$rootScope.wc);
      angular.forEach($rootScope.wc.webroute, function (i) {
        console.log('test',i);
        if(i.state == $rootScope.currentState){
          console.log('match');
          $rootScope.menuBack = i.image;
        }
      });
    };
    $rootScope.menuImage=function (state) {
      console.log('menuImage');
      $rootScope.menuBack = state.image;
    };
    /**** LOADER ****/
    $rootScope.$watch('showLoader', function () {
      if ($rootScope.showLoader === true) {
        document.body.style.overflow = 'hidden';
      }
      else {
        $timeout(function () {
          document.body.style.overflow = 'initial';
        }, 2500);
      }
    }, true);
    /********* AREAS **********/
    $rootScope.getPickedArea = function () {
      var id = $stateParams.id;
      angular.forEach($rootScope.wct.webroute, function (i) {
        if(i.id == id){
          $rootScope.areaPicked = i;
          console.log('match', $rootScope.areaPicked );
        }
      });
    };

    $rootScope.searchInData = function (value) {
      $rootScope.searched = [];
      console.log('EXECUTE SEARCH', value);
      angular.forEach($rootScope.wc.websection, function (i) {
        var title = i.title[$rootScope.language].toLowerCase();
        var content = i.title[$rootScope.language].toLowerCase();
        var context = "";//i.context.title[$rootScope.language].toLowerCase();
        if(title.search(value.toLowerCase()) >= 0 || content.search(value.toLowerCase()) >= 0 || context.search(value.toLowerCase()) >= 0 ){
          $rootScope.searched.push(i);
        }
      });
      console.log('BUSCADO',$rootScope.searched);
    };
    $rootScope.childRoute = function (i) {
      var exit = '';
      switch (i.webroute_id) {
        case 2:
           exit = 'area-selected';
          break;
        case 4:
           exit = 'profile-selected';
          break;
        case 6:
          exit = 'news-selected';
          break;
        case 8:
          exit = 'aboutus';
          break;
      }
      return exit;
    };


    /********  MODALS AND WEB FORMS ********/
    $rootScope.ctaTab = 1;
    $rootScope.ctaNav = function (value) {
      switch (value){
        case'next':
          $rootScope.ctaTab++;
          break;
        case 'prev':
          $rootScope.ctaTab--;
          break;
      }
    }
    $rootScope.modals = {
      currentModal: ''
    };
    $rootScope.modalTab = 1;
    $rootScope.showModal = function (modal, value) {
      $log.log(modal);
      if(modal === 'modalmenu'){
        $rootScope.showMenu();
      }
      $rootScope.currentModal = modal;
      $rootScope.modals.currentModal = 'app/views/modals/' + modal + '.html';
      $rootScope.modalTab = 1;
      $rootScope.formData = {};
      $rootScope.searched = [];
      $rootScope.ctaTab = 1;
      $rootScope.validateRequest();
      $("html, body")
        .animate({scrollTop: 0 }, 1000);

    };
    $rootScope.formDataHome = {};
    $rootScope.closeModal = function () {
      $rootScope.modals.currentModal = '';
      $rootScope.modalTab = 1;
    };
    $rootScope.$watch('modals', function () {
      if($rootScope.showLoader===false){
        if ($rootScope.modals.currentModal != '') {
          document.body.style.overflow = 'hidden';
        }
        else {
          document.body.style.overflow = 'initial';
        }
      }

    }, true);
    $rootScope.navModals = function (value) {
      switch (value) {
        case 'prev':
          if ($rootScope.modalTab > 1) {
            $rootScope.modalTab--;
          }
          break;
        case 'next':
          $rootScope.modalTab++;
          $timeout(function () {
            if ($rootScope.currentModal != 'modalpresskit') {
              $rootScope.closeModal();
            }
          }, 5000);
          break;
        default:
          $rootScope.modalTab = value;
          break;
      }
    };
    $rootScope.$watch('modals', function () {
     // $log.log('actualiza modals', $rootScope.modals)
    }, true);
    //recaptcha
    function onloadCallback() {
      /*grecaptcha.ready(function () {
        grecaptcha.execute('6LfvLrgUAAAAAKwr9FHjRABHKfH6oLyQ6bzMldo0', {action: 'contact'})
          .then(function (token) {
            //$log.log('CAPTCHA', token);
            $rootScope.gc = token;
          });
      });*/
    }
    $rootScope.validateRequest = function () {
      onloadCallback();
    };
    $rootScope.sendForm = function (id, data, flash) {
      $log.log('ingresa', id, data);
      if (id && data) {
        $log.log('ingresa 0');

        var params = {
          mailingcategory_id: id,
          gc: $rootScope.gc,
          fields: data
        };
        $log.log('params', params);
        ContentService.sendform(params)
          .success(function (res) {
            $log.log('sendform res', res);
            if (res.status) {
              $rootScope.navModals('next');
              $log.log('sendform', res)
            }
            else {
              toastr.warning('Please try again', 'Connection error');
            }
          });
      }
      else {
        $log.log('ingresa 1');
        $rootScope.navModals('next');
      }
      if (flash) {
        toastr.success($rootScope.sT('Mensaje enviado', 'Message sent'), 'Success');
      }

    };



    /********** SEARCH FUNCTIONS ***********/
    $rootScope.searchContent = function (filters){
      $rootScope.searched = [];
     // filters.gc = $rootScope.gc;
      filters.lan = $rootScope.language;
      console.log('SEARCHED', filters);
      ContentService.websearch(filters)
        .success(function (res) {
          $log.log('SEARCH RESPONSE',res);
          $rootScope.searched = res.result;
        });
    };

    $rootScope.$watch('formData', function () {
      //$log.log('actualiza modals', $rootScope.modals);
      $rootScope.blockForm = false;
      if (!$rootScope.blockForm.search || $rootScope.blockForm.search === 'es' || $rootScope.blockForm.search === 'en') {
        $rootScope.blockForm = true;
      }
    }, true);


    /******** OTHER CONFIGURATIONS *********/
    $rootScope.MapsStyle = [
      {
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#212121"
          }
        ]
      },
      {
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#212121"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "administrative.country",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#bdbdbd"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#181818"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#1b1b1b"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#2c2c2c"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#8a8a8a"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#373737"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#3c3c3c"
          }
        ]
      },
      {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#4e4e4e"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "featureType": "transit",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#000000"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#3d3d3d"
          }
        ]
      }
    ];
    $rootScope.homeOwlConf = {
      items: 1,
      nav: true,
      // startPosition:parseInt(index),
      loop: true,
      autoplay: true,
      autoplaySpeed:10000,
      autoplayTimeout: 10000,
      //smartSpeed:7000,
      autoplayHoverPause: false,
      /*animateIn: 'flipInY',
       animateOut: 'flipOutY', */
      /*animateIn: 'fadeInLeft',
       animateOut: 'fadeOutRight',*/
      animateIn: 'fadeInRight',
      animateOut: 'fadeOutLeft',
    };
    $rootScope.defaultOwlConf = {
      items: 1,
      nav: false,
      // startPosition:parseInt(index),
      loop: true,
      autoplay: true,
      autoplaySpeed:10000,
      autoplayTimeout: 10000,
      //smartSpeed:7000,
      autoplayHoverPause: false,
      /*animateIn: 'flipInY',
      animateOut: 'flipOutY', */
      /*animateIn: 'fadeInLeft',
      animateOut: 'fadeOutRight',*/
      animateIn: 'fadeInRight',
      animateOut: 'fadeOutLeft',
    };
    $rootScope.copyToShare = function () {
      $log.log('copy');
      var copyText = document.getElementById("myInput");
      copyText.select();
      document.execCommand("copy");
      var a = copyText.value;
      var split = a.slice(0, 30);
      $log.log(a, split);
      toastr.success(split + '..', 'Enlace copiado');
    };
    $rootScope.momths = [
      {value: '1', label: {es: 'Enero', en: 'January'}},
      {value: '2', label: {es: 'Febrero', en: 'Febrary'}},
      {value: '3', label: {es: 'Marzo', en: 'March'}},
      {value: '4', label: {es: 'Abril', en: 'April'}},
      {value: '5', label: {es: 'Mayo', en: 'May'}},
      {value: '6', label: {es: 'Junio', en: 'June'}},
      {value: '7', label: {es: 'Julio', en: 'July'}},
      {value: '8', label: {es: 'Agosto', en: 'August'}},
      {value: '9', label: {es: 'Septiembre', en: 'September'}},
      {value: '10', label: {es: 'Octubre', en: 'October'}},
      {value: '11', label: {es: 'Noviembre', en: 'November'}},
      {value: '12', label: {es: 'Diciembre', en: 'December'}},
    ];
    $rootScope.years = [
      {value: '2019', label: {es: '2019', en: '2019'}},
      {value: '2020', label: {es: '2020', en: '2020'}},
      {value: '2021', label: {es: '2021', en: '2021'}},
    ];

    /********** Maps Settings *************/
    $rootScope.mapConf = {
      bolivia: {lat:-16.0920796,lon:-72.5869263},
      center: {lat:-16.0920796,lon:-63.588653},
      zoom: 10,
      currentCity: {}
    };
    $rootScope.getGPS = function (lat, lon) {
      var exit = [lat, lon];
      return exit;
    };
    $rootScope.openInMaps = function (lat, lon) {
      // If it's an iPhone..
      if (
        (navigator.platform.indexOf("iPhone") !== -1) ||
        (navigator.platform.indexOf("iPod") !== -1) ||
        (navigator.platform.indexOf("iPad") !== -1)
      )
        window.open("maps://maps.google.com/maps?daddr="+lat+","+lon+"&amp;ll=");
      else
        window.open("http://maps.google.com/maps?daddr="+lat+","+lon+"&amp;ll=");
    }

    /******** SECTIONS RENDER DATA *********/




  });

(function() {
  'use strict';

  angular
      .module('frontendApp')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1516719002839;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontendApp')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, ContentService,
                    ImageLoader,
                    $anchorScroll, $location,
                    localStorageService, $timeout, $window, $stateParams) {

    //REST API ROUTE
    //$rootScope.api = 'http://localhost:8000';
    //$rootScope.api = 'http://sm.aknatechnologies.com/restapi/public';
    $rootScope.api = 'https://sanmiguelabogados.com.bo/restapi/public';
    //$rootScope.api = '';
    //SESSION VARS MANIPULATION
    $rootScope.getSessionParam = function (key) {
      return localStorageService.get(key);
    };
    //$log.log('MARK STATE PARAMS', $stateParams.lan);
    $rootScope.setSessionParam = function (key, val) {
      return localStorageService.set(key, val);
    };
    // SETTING SPANISH AS DEFAULT LANGUAGE
    $rootScope.lanList=['es', 'en', 'fr', 'pt'];

   /* if ($stateParams.lan == 'es' || $stateParams.lan == 'en') {
      $rootScope.language = $stateParams.lan;
    }
    else {
      $rootScope.language = 'es';
    }*/
    $rootScope.language = $stateParams.lan;
    //VERIFY CURRENT LANGUAGE
    $timeout(function () {
      /*if ($stateParams.lan == 'es' || $stateParams.lan == 'en') {
        $rootScope.changeLanguage($stateParams.lan, $rootScope.currentState);
      }
      else {
        $rootScope.language = 'es';
        //$state.go('home', {lan: 'es'}, {reload: true});
      }*/
      $rootScope.language = $stateParams.lan;
    }, 1000);
    //TRANSALATE
    $rootScope.transl = function (target) {
      if (target) {
        return target[$rootScope.language];
      }
      else {
        return '';
      }
    };
    $rootScope.sT = function (value1, value2) {
      if ($rootScope.language == 'es') {
        return value1;
      }
      else {
        return value2;
      }
    };
    //CHANGE OF ROUTE SETTING A NEW LANGUAGE
    $rootScope.changeLanguage = function (value, state) {
      $rootScope.language = value;
      //$rootScope.wc = {};
      $rootScope.setSessionParam('language', value);
      $state.go(state, {lan: value}, true);
      delete $rootScope.wc;
    };
    //MAIL TO FUNCTION
    $rootScope.sendMail = function (emailId, subject, message) {
      $window.open("mailto:" + emailId + "?subject=" + subject + "&body=" + message, "_self");
    };
    $rootScope.encodeName = function (value) {
      return encodeURI(value);
    };
    $rootScope.stateGo = function (state, params, reload) {
      if(!params ){
        params = {};
      }
      if(!params.language){
        params.lan=$rootScope.language;
      }
      $state.go(state, params, reload);
      $rootScope.closeModal();
      $rootScope.showLoader = true;
      // $rootScope.scroller(sec);
    };
    $rootScope.scroller = function (sec) {
      $timeout(function () {
        //$log.log('SCROLLER TO', sec);
        $("html, body")
          .animate({scrollTop: 0}, 500);
      }, 100);
    };
    $rootScope.fixLanguage = function () {
      if ($stateParams.lan == 'es' || $stateParams.lan == 'en') {
        $rootScope.language = $stateParams.lan;
      }
      else {
        $rootScope.language = 'es';
        $state.go('home', {lan: 'es'});
      }
    };


    $rootScope.wc = {};
    $rootScope.showLoader = true;
    document.body.style.overflow = 'hidden';

    $rootScope.cf = {
      title:''
    };
    $rootScope.setCf = function (value) {
      $rootScope.cf = value;
    };
    //AUTO EXECUTE ON ROUTE CHANGE OR LOAD
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      //$log.log('$stateChangeSuccess', $stateParams);
      $rootScope.scroller();
      $state.current = toState;
      $rootScope.$state = $state;
      $rootScope.menu = false;
      $rootScope.currentState = $state.current.name;
      $rootScope.context = $stateParams.context;

      $rootScope.wc = null;
      $rootScope.currentURL = $window.location.href;

      $rootScope.closeModal();
      //$rootScope.fixLanguage();
      //GET RESTAPI CONTENTS

      ContentService.webcontent($rootScope.currentState, $stateParams)
        .success(function (res) {
          if (res.status) {
            $rootScope.wc = res.result;
            $log.log('webcontent', $rootScope.wc);
            switch ($rootScope.currentState) {
              case 'home':
                var images = $rootScope.getImageArray($rootScope.wc.webhomecarousell, 'image' );
                $rootScope.preLoader(images);
                break;
              case 'areas':
              case 'professionals':
              case 'news':
                //var images2 = $rootScope.getImageArray($rootScope.wc.websection, 'image' );
                //$rootScope.preLoader(images2);
                $rootScope.showLoader = false;
                break;
              case 'area-selected':
              case 'profile-selected':
              case 'news-selected':
                /*angular.forEach( $rootScope.wc.websection, function (i) {
                  if(i.id == $stateParams.id){
                    $rootScope.secPicked = i;
                    console.log('$rootScope.secPicked ', $rootScope.secPicked );
                  }
                });*/
                $rootScope.secPicked = $rootScope.wc.picked;
                //$rootScope.preLoader([ $rootScope.api + $rootScope.secPicked.image2 ]);
                $rootScope.showLoader = false;
                break;
              case 'aboutus':
                //$rootScope.secPicked = $rootScope.wc.websection[0];
                $rootScope.secPicked = $rootScope.wc.picked;
                //$rootScope.preLoader([ $rootScope.api + $rootScope.secPicked.image2 ]);
                $rootScope.showLoader = false;
                break;
              case 'contact':
                //$rootScope.preLoader( $rootScope.getImageArray($rootScope.wc.location, 'image' ));
                $rootScope.showLoader = false;
                break;
              case 'contact-selected':
                angular.forEach( $rootScope.wc.location, function (i) {
                  if(i.id == $stateParams.id){
                    $rootScope.pickedCity = i;
                    console.log('$rootScope.pickedCity ', $rootScope.pickedCity );
                  }
                });
                /*$timeout(function () {
                  $rootScope.showLoader = false;
                }, 1000);*/
                $rootScope.showLoader = false;
                break;
            }
           // $log.log('WC FINAL', $rootScope.wc);
          }
        });
    });

    $rootScope.getImageArray = function (source, target) {
      var imageArray = [];
      angular.forEach(source, function (value, key) {
        if (value[target]) {
          imageArray.push($rootScope.api + value[target]);
        }
      });
      return imageArray;
    };

    $rootScope.preLoader = function (imageArray) {
      ImageLoader.loadImages(imageArray).then(function (loadedStrings) {
        $rootScope.imageStringsList = loadedStrings;
        $log.log($rootScope.imageStringsList);
        $rootScope.showLoader = false;
      });
    };

    $rootScope.fixNameUrl = function (link) {
      return encodeURI(link);
    };

    $rootScope.renderTag = function (tags) {
      var t = tags.split(';');
      var exit = '';
      angular.forEach(t,function (i) {
        exit +=  i.replace(' ','')+' ';
      });
      return exit;
    };

    $rootScope.shuffle = function (obj1, obj2) {
      var exit = [];
      var index = obj2.length;
      var rnd = Math.floor(Math.random() * index);
      console.log('Random',rnd, index);
      angular.forEach(obj1, function (v, k) {
        exit.push(v);
        if (k == 2 || k == 1) {
          obj2[rnd].webcontext.title ={
            es:'Publicidad',
            en:'Advertising'
          };
          obj2[rnd].adv = true;
          exit.push(obj2[rnd]);
        }
      });
      $log.log('salida', exit)
      return exit;
    };

    $rootScope.openInNewTab = function(url) {
      var win = $window.open(url, '_blank');
      win.focus();
    };

    $rootScope.shortyear = function (year) {
      var exit = ''+year;
      return exit.slice(2,4);
    };

    $rootScope.magNumber=function (item) {
      var year = $rootScope.shortyear(item.year);
      var month = ((item.month<10)?'0':'')+item.month;
      var exit = month+'.'+year;
      return exit;
    };

    $rootScope.magNumberLoc=function (item) {
      var location = (item.location)?item.location+' / ':'';
      var year = (item.year)?item.year:'';
      var month = ((item.month<10)?'0':'')+item.month;
      var exit = location + month+'.'+year;
      return exit;
    };



  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/home');
    $stateProvider
      /*.state('home', {
        url: '/:lan',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/main.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })*/
      .state('home', {
        url: '/:lan',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/main.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('areas', {
        url: '/:lan/areas',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/areas.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('area-selected', {
        url: '/:lan/area-selected/:id',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/area-selected.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('profile-selected', {
        url: '/:lan/profile-selected/:id',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/profile-selected.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('professionals', {
        url: '/:lan/professionals',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/professionals.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('aboutus', {
        url: '/:lan/aboutus',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/aboutus.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('news', {
        url: '/:lan/news',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/news.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('news-selected', {
        url: '/:lan/news-selected/:id',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/news-selected.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('contact', {
        url: '/:lan/contact',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/contact.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('contact-selected', {
        url: '/:lan/contact-selected/:id',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/contact-selected.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      /*.state('home-custom', {
        url: '/:lan/magazine/:collection/:context',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/main.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('article', {
        url: '/:lan/article/:alias',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/main.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('social', {
        url: '/:lan/social/:context',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/main.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('social-article', {
        url: '/:lan/social-article/:alias',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/main.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('contact', {
        url: '/:lan/contact',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/contact.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('aboutus', {
        url: '/:lan/aboutus/:context',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/pages/main.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })*/

    $urlRouterProvider.otherwise('/es');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('frontendApp')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $locationProvider, $authProvider, localStorageServiceProvider) {
    /*// Set the default quality
    $colorThiefProvider.setDefaultQuality(50);

    // Set the default palette color count
    $colorThiefProvider.setDefaultColorCount(5);

    // Set wether to return arrays (ColorThief's default) or
    // objects like {r: 242, g: 124, b: 91} (false by default).
    $colorThiefProvider.setReturnObjects(true);*/

    // Login
    $authProvider.loginUrl = 'http://localhost:8000/api/authenticate';
    localStorageServiceProvider
      .setPrefix('adminApp')
      .setStorageType('sessionStorage')
      .setNotify(true, true);

    // Enable log
    $logProvider.debugEnabled(true);
    $locationProvider.html5Mode(true).hashPrefix('#');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
    new WOW().init();
  }

})();

angular.module("frontendApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"container\"><div><acme-navbar creation-date=\"main.creationDate\"></acme-navbar></div><div class=\"jumbotron text-center\"><h1>\'Allo, \'Allo!</h1><p class=\"lead\"><img src=\"assets/images/yeoman.png\" alt=\"I\'m Yeoman\"><br>Always a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=\"main.classAnimation\"><button type=\"button\" class=\"btn btn-lg btn-success\" ng-click=\"main.showToastr()\">Splendid Toastr</button></p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></div><div class=\"row\"><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=\"thumbnail\"><img class=\"pull-right\" ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=\"caption\"><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href=\"{{awesomeThing.url}}\">{{ awesomeThing.url }}</a></p></div></div></div></div></div>");
$templateCache.put("app/views/header.html","<div class=\"menu-header\"><div class=\"header\"><div class=\"navbar navbar-default\" role=\"navigation\"><svg data-ng-click=\"$root.stateGo(\'home\')\" class=\"brand\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 483.1 147\" style=\"enable-background:new 0 0 483.1 147;\" xml:space=\"preserve\"><style type=\"text/css\">\n	.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#C22E0C;}\n  .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#1D1D1B;}\n  .st2{fill:#1D1D1B;}\n  .st3{fill:#C22E0C;}\n</style><g id=\"Layer_1\"></g><g id=\"Layer_2\"><g><g><polygon class=\"st0\" points=\"241.6,31.5 266,59.4 241.6,73.5\"></polygon><polygon class=\"st1\" points=\"217.1,59.4 241.6,31.5 241.6,73.5\"></polygon></g><g><path class=\"st2\" d=\"M48.1,99.7c-0.9,0-1.7-0.1-2.5-0.3c-0.8-0.2-1.4-0.5-1.9-0.8L43,99.3h-0.9L42,93.9h0.9 c0.2,0.5,0.4,1,0.8,1.6c0.3,0.6,0.7,1.1,1.1,1.5c0.4,0.5,0.9,0.8,1.4,1.1c0.5,0.3,1.1,0.4,1.8,0.4c0.9,0,1.6-0.2,2.1-0.7 c0.5-0.5,0.7-1,0.7-1.8c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-1.1-0.7-1.9-1c-0.6-0.2-1.1-0.4-1.6-0.5c-0.5-0.2-0.9-0.3-1.3-0.5 c-1-0.4-1.7-1-2.2-1.7c-0.5-0.7-0.7-1.6-0.7-2.5c0-0.6,0.1-1.1,0.4-1.7c0.2-0.5,0.6-1,1.1-1.4c0.4-0.4,1-0.7,1.7-1 c0.7-0.3,1.5-0.4,2.3-0.4c0.8,0,1.5,0.1,2.2,0.3c0.7,0.2,1.2,0.5,1.6,0.7l0.6-0.6h0.9l0.1,5.1h-0.9c-0.2-0.5-0.4-1.1-0.7-1.7 c-0.3-0.6-0.6-1-0.9-1.4c-0.3-0.4-0.7-0.7-1.1-1c-0.4-0.2-0.9-0.4-1.5-0.4c-0.7,0-1.3,0.2-1.8,0.6c-0.5,0.4-0.7,1-0.7,1.6 c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,1,0.7,1.9,1c0.5,0.2,1,0.3,1.5,0.5c0.5,0.2,1,0.3,1.4,0.5c1,0.4,1.7,0.9,2.2,1.6 c0.5,0.7,0.8,1.5,0.8,2.6c0,0.6-0.1,1.3-0.4,1.9c-0.3,0.6-0.7,1.1-1.2,1.5c-0.5,0.4-1.2,0.8-1.9,1C49.9,99.6,49.1,99.7,48.1,99.7 z\"></path><path class=\"st2\" d=\"M71.6,99.3h-7.8v-0.8c0.4,0,0.8-0.1,1.3-0.2c0.5-0.1,0.7-0.2,0.7-0.4c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2-0.1-0.3 l-1.2-3.1h-5c-0.1,0.3-0.2,0.6-0.4,1c-0.1,0.4-0.3,0.7-0.4,1c-0.1,0.4-0.2,0.7-0.2,0.8c0,0.2,0,0.3,0,0.4c0,0.2,0.2,0.4,0.5,0.6 s0.9,0.3,1.6,0.3v0.8h-5.9v-0.8c0.2,0,0.5-0.1,0.8-0.1c0.3-0.1,0.5-0.1,0.7-0.2c0.3-0.2,0.5-0.4,0.7-0.6c0.2-0.2,0.4-0.5,0.5-0.9 c0.8-2,1.6-3.9,2.4-5.9c0.8-2,1.7-4.1,2.6-6.5h2c1.3,3.4,2.4,6,3.1,8c0.8,2,1.4,3.6,1.9,4.9c0.1,0.2,0.2,0.4,0.3,0.6 c0.1,0.2,0.3,0.3,0.6,0.5c0.2,0.1,0.4,0.2,0.7,0.3c0.2,0.1,0.5,0.1,0.7,0.1V99.3z M64,93.3l-2.1-5.4l-2.1,5.4H64z\"></path><path class=\"st2\" d=\"M88.7,85.3c-0.2,0-0.5,0.1-0.8,0.1c-0.4,0.1-0.7,0.2-1,0.4c-0.3,0.2-0.4,0.5-0.5,1c-0.1,0.5-0.2,1.1-0.2,2 v10.6h-1.8l-9-11.5v7c0,0.9,0.1,1.5,0.2,2c0.1,0.4,0.3,0.8,0.5,1c0.2,0.2,0.5,0.3,0.9,0.4c0.4,0.1,0.7,0.2,1,0.2v0.8h-6.2v-0.8 c0.3,0,0.6-0.1,0.9-0.2c0.3-0.1,0.6-0.2,0.9-0.4c0.3-0.2,0.4-0.5,0.5-0.9c0.1-0.4,0.1-1.1,0.1-2.1v-7c0-0.3-0.1-0.7-0.2-1 c-0.1-0.3-0.3-0.6-0.5-0.8c-0.2-0.2-0.5-0.4-0.8-0.6c-0.3-0.1-0.7-0.2-1-0.3v-0.8h5.4l7.9,10v-5.6c0-0.9-0.1-1.6-0.2-2 c-0.1-0.4-0.3-0.8-0.5-1c-0.2-0.2-0.5-0.3-0.9-0.4c-0.4-0.1-0.7-0.2-0.9-0.2v-0.8h6.2V85.3z\"></path><path class=\"st2\" d=\"M115.5,99.3h-7.8v-0.8c0.2,0,0.5-0.1,0.8-0.1c0.3,0,0.6-0.1,0.7-0.2c0.2-0.1,0.4-0.2,0.5-0.4 c0.1-0.2,0.2-0.4,0.2-0.7V86l-5,13h-1.3c-0.1-0.2-0.2-0.7-0.5-1.4c-0.2-0.7-0.4-1.2-0.6-1.6L99,85.8v9c0,0.9,0.1,1.5,0.2,2 c0.1,0.4,0.3,0.8,0.5,1c0.2,0.1,0.5,0.3,0.9,0.4c0.4,0.1,0.7,0.2,0.9,0.2v0.8h-6.2v-0.8c0.2,0,0.4-0.1,0.8-0.1 c0.4-0.1,0.7-0.2,0.9-0.4c0.3-0.2,0.5-0.5,0.5-1c0.1-0.5,0.1-1.1,0.1-2v-7.4c0-0.4-0.1-0.8-0.2-1.1c-0.1-0.3-0.3-0.5-0.5-0.7 c-0.3-0.2-0.5-0.4-0.8-0.4c-0.3-0.1-0.6-0.1-0.9-0.1v-0.8h6.6l3.5,9.8l3-7.9c0.1-0.3,0.2-0.6,0.3-1c0.1-0.4,0.1-0.7,0.2-0.8h6.4 v0.8c-0.2,0-0.4,0-0.7,0.1c-0.2,0-0.5,0.1-0.7,0.2c-0.3,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.1,0.4-0.1,0.6v10.5c0,0.3,0,0.5,0.1,0.6 c0.1,0.2,0.3,0.3,0.5,0.4c0.1,0.1,0.4,0.1,0.7,0.2c0.3,0.1,0.5,0.1,0.7,0.1V99.3z\"></path><path class=\"st2\" d=\"M125.3,99.3h-8v-0.8c0.2,0,0.5,0,0.8-0.1c0.4,0,0.6-0.1,0.7-0.1c0.2-0.1,0.4-0.2,0.5-0.4 c0.1-0.2,0.1-0.4,0.1-0.7l0-10.5c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.1-0.7-0.2 c-0.3-0.1-0.6-0.1-0.8-0.2v-0.8h8v0.8c-0.2,0-0.5,0.1-0.8,0.1c-0.3,0-0.6,0.1-0.8,0.2c-0.3,0.1-0.4,0.2-0.5,0.4 c-0.1,0.2-0.1,0.4-0.1,0.7v10.5c0,0.3,0,0.5,0.1,0.6c0.1,0.2,0.3,0.3,0.5,0.4c0.1,0.1,0.4,0.1,0.7,0.2c0.3,0.1,0.6,0.1,0.8,0.1 V99.3z\"></path><path class=\"st2\" d=\"M143.1,93.3c-0.2,0-0.4,0-0.6,0.1c-0.2,0-0.4,0.1-0.6,0.2c-0.3,0.1-0.5,0.2-0.5,0.4s-0.1,0.4-0.1,0.7v1.7 c0,0.3,0,0.6,0,0.8c0,0.2,0,0.5,0,0.8c-0.7,0.4-1.7,0.8-3,1.2c-1.3,0.4-2.5,0.6-3.6,0.6c-1,0-2-0.2-2.9-0.5 c-0.9-0.3-1.7-0.8-2.4-1.5c-0.7-0.6-1.2-1.5-1.6-2.4c-0.4-1-0.6-2.1-0.6-3.3c0-1.2,0.2-2.2,0.6-3.2c0.4-1,0.9-1.8,1.6-2.5 c0.7-0.7,1.5-1.2,2.5-1.6c1-0.4,2.1-0.6,3.3-0.6c0.8,0,1.6,0.1,2.3,0.3c0.7,0.2,1.3,0.4,1.7,0.7l0.6-0.6h0.9l0.1,5.4h-0.9 c-0.5-1.6-1.1-2.8-1.8-3.6c-0.7-0.8-1.6-1.2-2.7-1.2c-1.3,0-2.3,0.6-3,1.8c-0.7,1.2-1.1,2.8-1.1,4.8c0,2.2,0.3,3.9,1,5.1 c0.7,1.2,1.7,1.9,2.9,1.9c0.6,0,1.1-0.1,1.6-0.3c0.5-0.2,0.8-0.4,1.1-0.6v-3c0-0.3,0-0.5-0.1-0.6c-0.1-0.2-0.3-0.3-0.5-0.4 c-0.2-0.1-0.5-0.2-0.8-0.2c-0.3-0.1-0.6-0.1-0.8-0.1v-0.8h7.5V93.3z\"></path><path class=\"st2\" d=\"M160.8,85.3c-0.2,0-0.5,0.1-0.8,0.1c-0.4,0.1-0.7,0.2-0.9,0.4c-0.3,0.2-0.4,0.5-0.5,0.9 c-0.1,0.5-0.2,1.1-0.2,2v5.5c0,1.6-0.5,2.9-1.6,3.9c-1.1,1-2.5,1.5-4.2,1.5c-2,0-3.6-0.5-4.8-1.4c-1.1-1-1.7-2.3-1.7-4v-7.6 c0-0.2,0-0.5-0.1-0.6c-0.1-0.2-0.3-0.3-0.5-0.5c-0.2-0.1-0.4-0.2-0.6-0.2c-0.3-0.1-0.5-0.1-0.6-0.1v-0.8h7.5v0.8 c-0.2,0-0.4,0-0.7,0.1c-0.2,0-0.5,0.1-0.7,0.2c-0.3,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.1,0.4-0.1,0.7v7.5c0,1.5,0.3,2.5,0.9,3.2 c0.6,0.7,1.5,1,2.7,1c1.2,0,2.1-0.4,2.8-1.1c0.7-0.7,1-1.8,1-3.3v-5c0-0.9-0.1-1.6-0.2-2c-0.1-0.4-0.3-0.8-0.5-1 c-0.2-0.2-0.5-0.3-0.9-0.4c-0.4-0.1-0.7-0.2-0.9-0.2v-0.8h6.2V85.3z\"></path><path class=\"st2\" d=\"M174.7,88.2h-0.8c-0.2-0.6-0.5-1.1-1-1.7c-0.5-0.6-1-0.9-1.4-1c-0.2,0-0.5-0.1-0.8-0.1c-0.4,0-0.7,0-0.9,0 h-2.1v5.7h1.5c0.4,0,0.7,0,1-0.1c0.3-0.1,0.6-0.3,0.8-0.5c0.2-0.2,0.3-0.4,0.5-0.8c0.2-0.4,0.3-0.8,0.3-1.1h0.8l0,6.2h-0.8 c0-0.3-0.1-0.7-0.3-1.1c-0.2-0.4-0.3-0.7-0.5-0.9c-0.2-0.3-0.5-0.4-0.8-0.5c-0.3-0.1-0.7-0.1-1.1-0.1h-1.5v4.3 c0,0.4,0,0.8,0.1,1.1c0.1,0.3,0.2,0.5,0.4,0.6c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0,0.7,0.1,1.2,0.1c0.2,0,0.5,0,0.9,0 c0.3,0,0.6,0,0.9-0.1c0.3,0,0.5-0.1,0.8-0.2c0.2-0.1,0.4-0.2,0.6-0.3c0.3-0.3,0.7-0.9,1.1-1.6c0.4-0.7,0.7-1.2,0.8-1.6h0.7 l-0.3,4.6H162v-0.8c0.2,0,0.4,0,0.8-0.1c0.3,0,0.6-0.1,0.7-0.1c0.3-0.1,0.4-0.3,0.5-0.4c0.1-0.2,0.1-0.4,0.1-0.7V86.7 c0-0.3,0-0.5-0.1-0.6c-0.1-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.2-0.7-0.2c-0.3-0.1-0.6-0.1-0.7-0.1v-0.8h12.8V88.2z\"></path><path class=\"st2\" d=\"M190.9,94.5l-0.3,4.8h-13.3v-0.8c0.2,0,0.5-0.1,0.8-0.1c0.3,0,0.5-0.1,0.6-0.1c0.2-0.1,0.4-0.2,0.5-0.4 c0.1-0.2,0.1-0.4,0.1-0.7V86.7c0-0.3,0-0.5-0.1-0.6s-0.3-0.3-0.5-0.4c-0.2-0.1-0.5-0.2-0.8-0.2c-0.3-0.1-0.5-0.1-0.7-0.1v-0.8 h7.9v0.8c-0.2,0-0.5,0.1-0.8,0.1c-0.3,0-0.5,0.1-0.8,0.2c-0.3,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.1,0.4-0.1,0.7v9.8 c0,0.5,0,0.8,0.1,1.1c0.1,0.3,0.2,0.5,0.4,0.6c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0,0.7,0.1,1.3,0.1c0.5,0,1.1,0,1.6-0.1 c0.5-0.1,0.9-0.2,1.1-0.4c0.3-0.4,0.7-0.9,1.1-1.5c0.4-0.6,0.7-1.2,0.9-1.8H190.9z\"></path><path class=\"st3\" d=\"M213.3,99.3h-7.8v-0.8c0.4,0,0.8-0.1,1.3-0.2c0.5-0.1,0.7-0.2,0.7-0.4c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.2-0.1-0.3l-1.2-3.1h-5c-0.1,0.3-0.2,0.6-0.4,1c-0.1,0.4-0.3,0.7-0.4,1c-0.1,0.4-0.2,0.7-0.2,0.8c0,0.2,0,0.3,0,0.4 c0,0.2,0.2,0.4,0.5,0.6c0.3,0.2,0.9,0.3,1.6,0.3v0.8h-5.9v-0.8c0.2,0,0.5-0.1,0.8-0.1c0.3-0.1,0.5-0.1,0.7-0.2 c0.3-0.2,0.5-0.4,0.7-0.6c0.2-0.2,0.4-0.5,0.5-0.9c0.8-2,1.6-3.9,2.4-5.9c0.8-2,1.7-4.1,2.6-6.5h2c1.3,3.4,2.4,6,3.1,8 c0.8,2,1.4,3.6,1.9,4.9c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.2,0.3,0.3,0.6,0.5c0.2,0.1,0.4,0.2,0.7,0.3c0.2,0.1,0.5,0.1,0.7,0.1V99.3z M205.8,93.3l-2.1-5.4l-2.1,5.4H205.8z\"></path><path class=\"st3\" d=\"M226.6,92.5c0.4,0.3,0.8,0.7,1.1,1.2c0.3,0.5,0.4,1,0.4,1.6c0,0.8-0.2,1.4-0.5,1.9c-0.3,0.5-0.7,0.9-1.3,1.2 c-0.6,0.3-1.3,0.5-2.1,0.7c-0.8,0.1-1.7,0.2-2.8,0.2h-7.5v-0.8c0.2,0,0.5-0.1,0.8-0.1c0.3,0,0.5-0.1,0.7-0.1 c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.1-0.4,0.1-0.7l0-10.5c0-0.3,0-0.5-0.1-0.6c-0.1-0.2-0.3-0.3-0.5-0.4 c-0.2-0.1-0.5-0.2-0.7-0.2c-0.3-0.1-0.5-0.1-0.7-0.1v-0.8h7.8c2,0,3.4,0.3,4.3,0.8c0.9,0.6,1.3,1.4,1.3,2.5 c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.4-0.5,0.7-0.8,1c-0.3,0.3-0.7,0.5-1.2,0.7s-1,0.3-1.5,0.5v0.2c0.5,0.1,1.1,0.2,1.6,0.4 C225.7,91.9,226.2,92.2,226.6,92.5z M223.3,88c0-0.8-0.2-1.5-0.7-1.9c-0.5-0.5-1.1-0.7-2-0.7c-0.1,0-0.3,0-0.5,0 c-0.2,0-0.4,0-0.5,0v5.5h0.5c1.1,0,1.9-0.3,2.4-0.8C223.1,89.6,223.3,88.9,223.3,88z M224,95.1c0-1-0.3-1.8-0.9-2.4 c-0.6-0.6-1.5-0.8-2.6-0.8c-0.1,0-0.3,0-0.5,0c-0.2,0-0.4,0-0.5,0v5.4c0.1,0.3,0.2,0.5,0.6,0.7s0.7,0.3,1.2,0.3 c0.8,0,1.5-0.3,2-0.8C223.8,96.9,224,96.2,224,95.1z\"></path><path class=\"st3\" d=\"M243.3,86.1c0.7,0.7,1.3,1.5,1.7,2.4c0.4,0.9,0.6,2,0.6,3.2c0,1.1-0.2,2.1-0.5,3.1c-0.4,1-0.9,1.8-1.5,2.5 c-0.7,0.7-1.5,1.3-2.5,1.7c-0.9,0.4-2.1,0.6-3.4,0.6c-1,0-2-0.2-3-0.5c-0.9-0.4-1.8-0.9-2.5-1.5c-0.7-0.7-1.3-1.5-1.7-2.4 c-0.4-0.9-0.6-2-0.6-3.2c0-1.2,0.2-2.3,0.6-3.3c0.4-1,1-1.8,1.7-2.5c0.7-0.7,1.5-1.2,2.5-1.6c1-0.4,2-0.6,3.1-0.6 c1.1,0,2.1,0.2,3,0.5C241.8,84.9,242.6,85.4,243.3,86.1z M240.7,96.7c0.3-0.6,0.5-1.4,0.7-2.2c0.1-0.8,0.2-1.7,0.2-2.7 c0-0.9-0.1-1.7-0.2-2.5c-0.1-0.8-0.3-1.5-0.6-2.2c-0.3-0.6-0.7-1.1-1.2-1.5c-0.5-0.4-1.1-0.6-1.8-0.6c-1.2,0-2.2,0.6-2.8,1.8 s-1,2.9-1,5.1c0,0.9,0.1,1.8,0.2,2.6c0.1,0.8,0.4,1.5,0.7,2.2c0.3,0.6,0.7,1.1,1.2,1.4c0.5,0.3,1,0.5,1.7,0.5 c0.7,0,1.2-0.2,1.7-0.5C240,97.8,240.4,97.3,240.7,96.7z\"></path><path class=\"st3\" d=\"M263.5,93.3c-0.2,0-0.4,0-0.6,0.1c-0.2,0-0.4,0.1-0.6,0.2c-0.3,0.1-0.5,0.2-0.5,0.4 c-0.1,0.2-0.1,0.4-0.1,0.7v1.7c0,0.3,0,0.6,0,0.8c0,0.2,0,0.5,0,0.8c-0.7,0.4-1.7,0.8-3,1.2c-1.3,0.4-2.5,0.6-3.6,0.6 c-1,0-2-0.2-2.9-0.5c-0.9-0.3-1.7-0.8-2.4-1.5c-0.7-0.6-1.2-1.5-1.6-2.4c-0.4-1-0.6-2.1-0.6-3.3c0-1.2,0.2-2.2,0.6-3.2 c0.4-1,0.9-1.8,1.6-2.5c0.7-0.7,1.5-1.2,2.5-1.6c1-0.4,2.1-0.6,3.3-0.6c0.8,0,1.6,0.1,2.3,0.3c0.7,0.2,1.3,0.4,1.7,0.7l0.6-0.6 h0.9l0.1,5.4h-0.9c-0.5-1.6-1.1-2.8-1.8-3.6c-0.7-0.8-1.6-1.2-2.7-1.2c-1.3,0-2.3,0.6-3,1.8c-0.7,1.2-1.1,2.8-1.1,4.8 c0,2.2,0.3,3.9,1,5.1c0.7,1.2,1.7,1.9,2.9,1.9c0.6,0,1.1-0.1,1.6-0.3c0.5-0.2,0.8-0.4,1.1-0.6v-3c0-0.3,0-0.5-0.1-0.6 c-0.1-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.5-0.2-0.8-0.2c-0.3-0.1-0.6-0.1-0.8-0.1v-0.8h7.5V93.3z\"></path><path class=\"st3\" d=\"M280.3,99.3h-7.8v-0.8c0.4,0,0.8-0.1,1.3-0.2c0.5-0.1,0.7-0.2,0.7-0.4c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.2-0.1-0.3l-1.2-3.1h-5c-0.1,0.3-0.2,0.6-0.4,1c-0.1,0.4-0.3,0.7-0.4,1c-0.1,0.4-0.2,0.7-0.2,0.8c0,0.2,0,0.3,0,0.4 c0,0.2,0.2,0.4,0.5,0.6c0.3,0.2,0.9,0.3,1.6,0.3v0.8h-5.9v-0.8c0.2,0,0.5-0.1,0.8-0.1c0.3-0.1,0.5-0.1,0.7-0.2 c0.3-0.2,0.5-0.4,0.7-0.6c0.2-0.2,0.4-0.5,0.5-0.9c0.8-2,1.6-3.9,2.4-5.9c0.8-2,1.7-4.1,2.6-6.5h2c1.3,3.4,2.4,6,3.1,8 c0.8,2,1.4,3.6,1.9,4.9c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.2,0.3,0.3,0.6,0.5c0.2,0.1,0.4,0.2,0.7,0.3c0.2,0.1,0.5,0.1,0.7,0.1V99.3z M272.7,93.3l-2.1-5.4l-2.1,5.4H272.7z\"></path><path class=\"st3\" d=\"M293.8,86c0.9,0.6,1.6,1.4,2.1,2.4c0.5,1,0.8,2.2,0.8,3.6c0,1.3-0.2,2.3-0.7,3.3c-0.5,0.9-1.1,1.7-1.9,2.3 c-0.8,0.6-1.7,1-2.8,1.3c-1,0.3-2.1,0.4-3.2,0.4h-7.3v-0.8c0.2,0,0.5,0,0.8-0.1c0.3,0,0.5-0.1,0.6-0.1c0.2-0.1,0.4-0.2,0.5-0.4 c0.1-0.2,0.1-0.4,0.1-0.6V86.7c0-0.2,0-0.5-0.1-0.6s-0.3-0.3-0.5-0.5c-0.3-0.1-0.5-0.2-0.8-0.2c-0.3,0-0.5-0.1-0.7-0.1v-0.8h7.7 c0.8,0,1.7,0.1,2.6,0.3C292,85,292.9,85.4,293.8,86z M291.7,96.6c0.3-0.6,0.6-1.2,0.7-2c0.2-0.8,0.2-1.7,0.2-2.7 c0-1-0.1-1.9-0.3-2.7c-0.2-0.8-0.5-1.5-0.9-2.1c-0.4-0.6-0.9-1-1.5-1.3c-0.6-0.3-1.2-0.5-2-0.5c-0.2,0-0.5,0-0.8,0 c-0.3,0-0.5,0-0.7,0v11.3c0,0.3,0,0.5,0.1,0.7s0.2,0.4,0.3,0.5c0.2,0.1,0.3,0.3,0.6,0.3c0.2,0.1,0.5,0.1,0.9,0.1 c0.8,0,1.4-0.1,2-0.4S291.4,97.2,291.7,96.6z\"></path><path class=\"st3\" d=\"M311.9,86.1c0.7,0.7,1.3,1.5,1.7,2.4c0.4,0.9,0.6,2,0.6,3.2c0,1.1-0.2,2.1-0.5,3.1c-0.4,1-0.9,1.8-1.5,2.5 c-0.7,0.7-1.5,1.3-2.5,1.7c-0.9,0.4-2.1,0.6-3.4,0.6c-1,0-2-0.2-3-0.5c-0.9-0.4-1.8-0.9-2.5-1.5c-0.7-0.7-1.3-1.5-1.7-2.4 s-0.6-2-0.6-3.2c0-1.2,0.2-2.3,0.6-3.3c0.4-1,1-1.8,1.7-2.5c0.7-0.7,1.5-1.2,2.5-1.6c1-0.4,2-0.6,3.1-0.6c1.1,0,2.1,0.2,3,0.5 C310.4,84.9,311.2,85.4,311.9,86.1z M309.3,96.7c0.3-0.6,0.5-1.4,0.7-2.2c0.1-0.8,0.2-1.7,0.2-2.7c0-0.9-0.1-1.7-0.2-2.5 c-0.1-0.8-0.3-1.5-0.6-2.2c-0.3-0.6-0.7-1.1-1.2-1.5c-0.5-0.4-1.1-0.6-1.8-0.6c-1.2,0-2.2,0.6-2.8,1.8c-0.6,1.2-1,2.9-1,5.1 c0,0.9,0.1,1.8,0.2,2.6c0.1,0.8,0.4,1.5,0.7,2.2c0.3,0.6,0.7,1.1,1.2,1.4c0.5,0.3,1,0.5,1.7,0.5c0.7,0,1.2-0.2,1.7-0.5 C308.6,97.8,309,97.3,309.3,96.7z\"></path><path class=\"st3\" d=\"M322,99.7c-0.9,0-1.7-0.1-2.5-0.3c-0.8-0.2-1.4-0.5-1.9-0.8l-0.7,0.7h-0.9l-0.1-5.4h0.9 c0.2,0.5,0.4,1,0.8,1.6c0.3,0.6,0.7,1.1,1.1,1.5c0.4,0.5,0.9,0.8,1.4,1.1c0.5,0.3,1.1,0.4,1.8,0.4c0.9,0,1.6-0.2,2.1-0.7 c0.5-0.5,0.7-1,0.7-1.8c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-1.1-0.7-1.9-1c-0.6-0.2-1.1-0.4-1.6-0.5c-0.5-0.2-0.9-0.3-1.3-0.5 c-1-0.4-1.7-1-2.2-1.7c-0.5-0.7-0.7-1.6-0.7-2.5c0-0.6,0.1-1.1,0.4-1.7c0.2-0.5,0.6-1,1.1-1.4c0.4-0.4,1-0.7,1.7-1 c0.7-0.3,1.5-0.4,2.3-0.4c0.8,0,1.5,0.1,2.2,0.3c0.7,0.2,1.2,0.5,1.6,0.7l0.6-0.6h0.9l0.1,5.1h-0.9c-0.2-0.5-0.4-1.1-0.7-1.7 c-0.3-0.6-0.6-1-0.9-1.4c-0.3-0.4-0.7-0.7-1.1-1c-0.4-0.2-0.9-0.4-1.5-0.4c-0.7,0-1.3,0.2-1.8,0.6c-0.5,0.4-0.7,1-0.7,1.6 c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,1,0.7,1.9,1c0.5,0.2,1,0.3,1.5,0.5c0.5,0.2,1,0.3,1.4,0.5c1,0.4,1.7,0.9,2.2,1.6 c0.5,0.7,0.8,1.5,0.8,2.6c0,0.6-0.1,1.3-0.4,1.9c-0.3,0.6-0.7,1.1-1.2,1.5c-0.5,0.4-1.2,0.8-1.9,1C323.8,99.6,323,99.7,322,99.7z\"></path><path class=\"st2\" d=\"M341.6,99.7c-0.9,0-1.7-0.1-2.5-0.3c-0.8-0.2-1.4-0.5-1.9-0.8l-0.7,0.7h-0.9l-0.1-5.4h0.9 c0.2,0.5,0.4,1,0.8,1.6c0.3,0.6,0.7,1.1,1.1,1.5c0.4,0.5,0.9,0.8,1.4,1.1c0.5,0.3,1.1,0.4,1.8,0.4c0.9,0,1.6-0.2,2.1-0.7 c0.5-0.5,0.7-1,0.7-1.8c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-1.1-0.7-1.9-1c-0.6-0.2-1.1-0.4-1.6-0.5c-0.5-0.2-0.9-0.3-1.3-0.5 c-1-0.4-1.7-1-2.2-1.7c-0.5-0.7-0.7-1.6-0.7-2.5c0-0.6,0.1-1.1,0.4-1.7c0.2-0.5,0.6-1,1.1-1.4c0.4-0.4,1-0.7,1.7-1 c0.7-0.3,1.5-0.4,2.3-0.4c0.8,0,1.5,0.1,2.2,0.3c0.7,0.2,1.2,0.5,1.6,0.7l0.6-0.6h0.9l0.1,5.1h-0.9c-0.2-0.5-0.4-1.1-0.7-1.7 c-0.3-0.6-0.6-1-0.9-1.4c-0.3-0.4-0.7-0.7-1.1-1c-0.4-0.2-0.9-0.4-1.5-0.4c-0.7,0-1.3,0.2-1.8,0.6c-0.5,0.4-0.7,1-0.7,1.6 c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,1,0.7,1.9,1c0.5,0.2,1,0.3,1.5,0.5c0.5,0.2,1,0.3,1.4,0.5c1,0.4,1.7,0.9,2.2,1.6 c0.5,0.7,0.8,1.5,0.8,2.6c0,0.6-0.1,1.3-0.4,1.9c-0.3,0.6-0.7,1.1-1.2,1.5c-0.5,0.4-1.2,0.8-1.9,1 C343.4,99.6,342.6,99.7,341.6,99.7z\"></path><path class=\"st2\" d=\"M362.8,86.1c0.7,0.7,1.3,1.5,1.7,2.4c0.4,0.9,0.6,2,0.6,3.2c0,1.1-0.2,2.1-0.5,3.1c-0.4,1-0.9,1.8-1.5,2.5 c-0.7,0.7-1.5,1.3-2.5,1.7c-0.9,0.4-2.1,0.6-3.4,0.6c-1,0-2-0.2-3-0.5c-0.9-0.4-1.8-0.9-2.5-1.5c-0.7-0.7-1.3-1.5-1.7-2.4 c-0.4-0.9-0.6-2-0.6-3.2c0-1.2,0.2-2.3,0.6-3.3c0.4-1,1-1.8,1.7-2.5c0.7-0.7,1.5-1.2,2.5-1.6c1-0.4,2-0.6,3.1-0.6 c1.1,0,2.1,0.2,3,0.5C361.3,84.9,362.1,85.4,362.8,86.1z M360.2,96.7c0.3-0.6,0.5-1.4,0.7-2.2c0.1-0.8,0.2-1.7,0.2-2.7 c0-0.9-0.1-1.7-0.2-2.5c-0.1-0.8-0.3-1.5-0.6-2.2c-0.3-0.6-0.7-1.1-1.2-1.5c-0.5-0.4-1.1-0.6-1.8-0.6c-1.2,0-2.2,0.6-2.8,1.8 c-0.6,1.2-1,2.9-1,5.1c0,0.9,0.1,1.8,0.2,2.6c0.1,0.8,0.4,1.5,0.7,2.2c0.3,0.6,0.7,1.1,1.2,1.5c0.5,0.3,1,0.5,1.7,0.5 c0.7,0,1.2-0.2,1.7-0.5C359.5,97.8,359.9,97.3,360.2,96.7z\"></path><path class=\"st2\" d=\"M374.5,99.7c-1.1,0-2-0.2-3-0.5c-0.9-0.4-1.7-0.9-2.4-1.5c-0.7-0.7-1.2-1.5-1.6-2.4c-0.4-1-0.6-2-0.6-3.2 c0-1.2,0.2-2.2,0.6-3.2c0.4-1,0.9-1.8,1.6-2.6c0.7-0.7,1.5-1.3,2.5-1.6c1-0.4,2-0.6,3.1-0.6c0.8,0,1.5,0.1,2.2,0.3 c0.7,0.2,1.2,0.4,1.7,0.7l0.6-0.6h0.9l0.1,5.4h-0.9c-0.5-1.7-1.1-2.9-1.8-3.6c-0.7-0.8-1.6-1.2-2.6-1.2c-1.3,0-2.2,0.6-2.9,1.7 c-0.7,1.2-1,2.8-1,4.9c0,1.2,0.1,2.2,0.3,3c0.2,0.8,0.5,1.5,0.9,2c0.4,0.5,0.9,0.9,1.4,1.2c0.5,0.2,1.1,0.4,1.8,0.4 c0.9,0,1.8-0.3,2.5-0.8c0.7-0.5,1.4-1.3,2-2.4l0.9,0.5c-0.3,0.6-0.6,1.2-1,1.6c-0.4,0.5-0.8,0.9-1.3,1.2 c-0.5,0.4-1.1,0.7-1.8,0.9C376.1,99.6,375.4,99.7,374.5,99.7z\"></path><path class=\"st2\" d=\"M386.9,97.5c0,0.6-0.2,1-0.6,1.4c-0.4,0.4-0.9,0.6-1.4,0.6c-0.5,0-1-0.2-1.4-0.6c-0.4-0.4-0.6-0.9-0.6-1.4 c0-0.6,0.2-1,0.6-1.4c0.4-0.4,0.9-0.6,1.4-0.6c0.5,0,1,0.2,1.4,0.6C386.7,96.5,386.9,97,386.9,97.5z\"></path><path class=\"st2\" d=\"M402.7,99.7c-1.1,0-2-0.2-3-0.5c-0.9-0.4-1.7-0.9-2.4-1.5c-0.7-0.7-1.2-1.5-1.6-2.4c-0.4-1-0.6-2-0.6-3.2 c0-1.2,0.2-2.2,0.6-3.2s0.9-1.8,1.6-2.6c0.7-0.7,1.5-1.3,2.5-1.6c1-0.4,2-0.6,3.1-0.6c0.8,0,1.5,0.1,2.2,0.3 c0.7,0.2,1.2,0.4,1.7,0.7l0.6-0.6h0.9l0.1,5.4h-0.9c-0.5-1.7-1.1-2.9-1.8-3.6c-0.7-0.8-1.6-1.2-2.6-1.2c-1.3,0-2.2,0.6-2.9,1.7 c-0.7,1.2-1,2.8-1,4.9c0,1.2,0.1,2.2,0.3,3c0.2,0.8,0.5,1.5,0.9,2c0.4,0.5,0.9,0.9,1.4,1.2c0.5,0.2,1.1,0.4,1.8,0.4 c0.9,0,1.8-0.3,2.5-0.8c0.7-0.5,1.4-1.3,2-2.4l0.9,0.5c-0.3,0.6-0.6,1.2-1,1.6c-0.4,0.5-0.8,0.9-1.3,1.2 c-0.5,0.4-1.1,0.7-1.8,0.9C404.3,99.6,403.6,99.7,402.7,99.7z\"></path><path class=\"st2\" d=\"M418.3,99.3l-8,0v-0.8c0.2,0,0.5,0,0.8-0.1c0.4,0,0.6-0.1,0.7-0.1c0.2-0.1,0.4-0.2,0.5-0.4 c0.1-0.2,0.1-0.4,0.1-0.7V86.7c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.1-0.7-0.2c-0.3-0.1-0.6-0.1-0.8-0.2 v-0.8h8v0.8c-0.2,0-0.5,0.1-0.8,0.1c-0.3,0-0.6,0.1-0.8,0.2c-0.3,0.1-0.4,0.2-0.5,0.4s-0.1,0.4-0.1,0.7v10.5c0,0.3,0,0.5,0.1,0.6 c0.1,0.2,0.3,0.3,0.5,0.4c0.1,0.1,0.4,0.1,0.7,0.2c0.3,0.1,0.6,0.1,0.8,0.1V99.3z\"></path><path class=\"st2\" d=\"M435.7,85.3c-0.2,0-0.4,0.1-0.6,0.1c-0.2,0.1-0.4,0.2-0.6,0.3c-0.3,0.2-0.5,0.4-0.7,0.6 c-0.2,0.2-0.3,0.5-0.5,0.8c-0.2,0.5-0.5,1.2-0.9,2.1c-0.4,0.9-0.8,2-1.3,3.2c-0.4,1.1-0.9,2.2-1.4,3.5c-0.5,1.3-1,2.5-1.4,3.6h-2 c-0.9-2.4-1.9-4.8-2.9-7.3c-1-2.5-1.7-4.2-2.1-5.1c-0.2-0.3-0.3-0.6-0.5-0.8c-0.1-0.2-0.4-0.4-0.7-0.5c-0.2-0.1-0.4-0.2-0.6-0.3 c-0.2-0.1-0.4-0.1-0.7-0.1v-0.8h7.8v0.8c-0.7,0.1-1.2,0.2-1.5,0.3c-0.3,0.1-0.4,0.2-0.4,0.4c0,0.1,0,0.2,0,0.2s0.1,0.2,0.1,0.4 c0.2,0.6,0.6,1.6,1.2,3c0.6,1.4,1.4,3.5,2.5,6.4c0.7-1.7,1.3-3.2,1.7-4.4c0.5-1.2,0.9-2.3,1.2-3.2c0.2-0.4,0.3-0.9,0.4-1.2 s0.2-0.7,0.2-0.9c0-0.2-0.2-0.4-0.5-0.6c-0.3-0.2-0.9-0.3-1.7-0.3v-0.8h5.8V85.3z\"></path><path class=\"st2\" d=\"M441.1,97.5c0,0.6-0.2,1-0.6,1.4c-0.4,0.4-0.9,0.6-1.4,0.6c-0.5,0-1-0.2-1.4-0.6c-0.4-0.4-0.6-0.9-0.6-1.4 c0-0.6,0.2-1,0.6-1.4c0.4-0.4,0.9-0.6,1.4-0.6c0.5,0,1,0.2,1.4,0.6C440.9,96.5,441.1,97,441.1,97.5z\"></path></g><rect x=\"42.1\" y=\"103.7\" class=\"st0\" width=\"398.9\" height=\"1.3\"></rect></g></g></svg><div class=\"navbar-header\"><a class=\"btn-burger\" data-ng-click=\"$root.showModal(\'modalmenu\');\"><svg width=\"50px\" height=\"28px\" viewbox=\"0 0 50 28\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"Symbols\" class=\"hidden-xs hidden-sm\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"menu\" fill=\"#FFFFFF\"><rect id=\"Rectangle-3\" x=\"30\" y=\"0\" width=\"20\" height=\"4\"></rect><rect id=\"Rectangle-3-Copy-2\" x=\"20\" y=\"24\" width=\"30\" height=\"4\"></rect><rect id=\"Rectangle-3-Copy\" x=\"0\" y=\"12\" width=\"50\" height=\"4\"></rect></g></g><g id=\"Symbols\" class=\"hidden-md hidden-lg\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"menu\" fill=\"#000000\"><rect id=\"Rectangle-3\" x=\"30\" y=\"0\" width=\"20\" height=\"4\"></rect><rect id=\"Rectangle-3-Copy-2\" x=\"20\" y=\"24\" width=\"30\" height=\"4\"></rect><rect id=\"Rectangle-3-Copy\" x=\"0\" y=\"12\" width=\"50\" height=\"4\"></rect></g></g></svg></a></div><ul class=\"nav navbar-nav lan-link\"><li><div class=\"btn-group btn-group-lan {{$root.language}}\" dropdown=\"\" is-open=\"$root.isopen\"><button id=\"single-button\" type=\"button\" class=\"btn btn-primary\" dropdown-toggle=\"\"><span class=\"caret\"></span></button><ul class=\"dropdown-menu {{$root.gustuTheme}}\" dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\" data-ng-repeat=\"a in $root.wc.webconfig\" data-ng-if=\"a.config != $root.language && a.value == \'1\'\"><a href=\"#\" class=\"{{a.config}}\" data-ng-click=\"$root.changeLanguage(a.config,$root.currentState)\"></a></li></ul></div></li><li><a href=\"\" class=\"btn-search\" data-ng-click=\"$root.showModal(\'modalsearch\')\"><svg width=\"30px\" height=\"30px\" viewbox=\"0 0 30 30\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"Symbols\" class=\"hidden-xs hidden-sm\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Serch\" fill-rule=\"nonzero\" fill=\"#FFFFFF\"><path d=\"M12.5,22 C17.7467051,22 22,17.7467051 22,12.5 C22,7.25329488 17.7467051,3 12.5,3 C7.25329488,3 3,7.25329488 3,12.5 C3,17.7467051 7.25329488,22 12.5,22 Z M12.5,25 C5.59644063,25 0,19.4035594 0,12.5 C0,5.59644063 5.59644063,0 12.5,0 C19.4035594,0 25,5.59644063 25,12.5 C25,19.4035594 19.4035594,25 12.5,25 Z\" id=\"Oval\"></path><polygon id=\"Line\" points=\"18.3786797 20.5 27.5710678 29.6923882 29.6923882 27.5710678 20.5 18.3786797\"></polygon></g></g><g id=\"Symbols\" class=\"hidden-md hidden-lg\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Serch\" fill-rule=\"nonzero\" fill=\"#000000\"><path d=\"M12.5,22 C17.7467051,22 22,17.7467051 22,12.5 C22,7.25329488 17.7467051,3 12.5,3 C7.25329488,3 3,7.25329488 3,12.5 C3,17.7467051 7.25329488,22 12.5,22 Z M12.5,25 C5.59644063,25 0,19.4035594 0,12.5 C0,5.59644063 5.59644063,0 12.5,0 C19.4035594,0 25,5.59644063 25,12.5 C25,19.4035594 19.4035594,25 12.5,25 Z\" id=\"Oval\"></path><polygon id=\"Line\" points=\"18.3786797 20.5 27.5710678 29.6923882 29.6923882 27.5710678 20.5 18.3786797\"></polygon></g></g></svg></a></li></ul><ul class=\"nav navbar-nav social-link test\" data-ng-if=\"$root.wc.websocial\"><li data-ng-if=\"$root.wc.websocial[0].url!=\'\'\"><a target=\"_blank\" href=\"https://api.whatsapp.com/send?phone=591{{$root.wc.websocial[0].url}}\" class=\"social-icon\"><i class=\"fab fa-whatsapp\"></i></a></li><li data-ng-if=\"$root.wc.websocial[1].url!=\'\'\"><a href=\"{{$root.wc.websocial[1].url}}\" target=\"_blank\" class=\"social-icon\"><i class=\"fab fa-facebook-f\"></i></a></li><li data-ng-if=\"$root.wc.websocial[2].url!=\'\'\"><a href=\"{{$root.wc.websocial[2].url}}\" target=\"_blank\" class=\"social-icon\"><i class=\"fab fa-twitter\"></i></a></li><li data-ng-if=\"$root.wc.websocial[3].url!=\'\'\"><a href=\"{{$root.wc.websocial[3].url}}\" target=\"_blank\" class=\"social-icon\"><i class=\"fab fa-linkedin-in\"></i></a></li></ul></div></div></div>");
$templateCache.put("app/views/loader.html","<div class=\"loader-wrapper\"><p class=\"message\" data-ng-if=\"$root.showLoader\"><span class=\"loading\" aria-hidden=\"true\"></span></p><div class=\"load\" data-ng-if=\"$root.showLoader\"><div class=\"white-panel\"></div><svg version=\"1.1\" class=\"brand\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 483.1 147\" style=\"enable-background:new 0 0 483.1 147;\" xml:space=\"preserve\"><style type=\"text/css\">\n	.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#C22E0C;}\n  .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#1D1D1B;}\n  .st2{fill:#1D1D1B;}\n  .st3{fill:#C22E0C;}\n</style><g id=\"Layer_1\"></g><g id=\"Layer_2\"><g><g><polygon class=\"st0\" points=\"241.6,31.5 266,59.4 241.6,73.5\"></polygon><polygon class=\"st1\" points=\"217.1,59.4 241.6,31.5 241.6,73.5\"></polygon></g><g><path class=\"st2\" d=\"M48.1,99.7c-0.9,0-1.7-0.1-2.5-0.3c-0.8-0.2-1.4-0.5-1.9-0.8L43,99.3h-0.9L42,93.9h0.9 c0.2,0.5,0.4,1,0.8,1.6c0.3,0.6,0.7,1.1,1.1,1.5c0.4,0.5,0.9,0.8,1.4,1.1c0.5,0.3,1.1,0.4,1.8,0.4c0.9,0,1.6-0.2,2.1-0.7 c0.5-0.5,0.7-1,0.7-1.8c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-1.1-0.7-1.9-1c-0.6-0.2-1.1-0.4-1.6-0.5c-0.5-0.2-0.9-0.3-1.3-0.5 c-1-0.4-1.7-1-2.2-1.7c-0.5-0.7-0.7-1.6-0.7-2.5c0-0.6,0.1-1.1,0.4-1.7c0.2-0.5,0.6-1,1.1-1.4c0.4-0.4,1-0.7,1.7-1 c0.7-0.3,1.5-0.4,2.3-0.4c0.8,0,1.5,0.1,2.2,0.3c0.7,0.2,1.2,0.5,1.6,0.7l0.6-0.6h0.9l0.1,5.1h-0.9c-0.2-0.5-0.4-1.1-0.7-1.7 c-0.3-0.6-0.6-1-0.9-1.4c-0.3-0.4-0.7-0.7-1.1-1c-0.4-0.2-0.9-0.4-1.5-0.4c-0.7,0-1.3,0.2-1.8,0.6c-0.5,0.4-0.7,1-0.7,1.6 c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,1,0.7,1.9,1c0.5,0.2,1,0.3,1.5,0.5c0.5,0.2,1,0.3,1.4,0.5c1,0.4,1.7,0.9,2.2,1.6 c0.5,0.7,0.8,1.5,0.8,2.6c0,0.6-0.1,1.3-0.4,1.9c-0.3,0.6-0.7,1.1-1.2,1.5c-0.5,0.4-1.2,0.8-1.9,1C49.9,99.6,49.1,99.7,48.1,99.7 z\"></path><path class=\"st2\" d=\"M71.6,99.3h-7.8v-0.8c0.4,0,0.8-0.1,1.3-0.2c0.5-0.1,0.7-0.2,0.7-0.4c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2-0.1-0.3 l-1.2-3.1h-5c-0.1,0.3-0.2,0.6-0.4,1c-0.1,0.4-0.3,0.7-0.4,1c-0.1,0.4-0.2,0.7-0.2,0.8c0,0.2,0,0.3,0,0.4c0,0.2,0.2,0.4,0.5,0.6 s0.9,0.3,1.6,0.3v0.8h-5.9v-0.8c0.2,0,0.5-0.1,0.8-0.1c0.3-0.1,0.5-0.1,0.7-0.2c0.3-0.2,0.5-0.4,0.7-0.6c0.2-0.2,0.4-0.5,0.5-0.9 c0.8-2,1.6-3.9,2.4-5.9c0.8-2,1.7-4.1,2.6-6.5h2c1.3,3.4,2.4,6,3.1,8c0.8,2,1.4,3.6,1.9,4.9c0.1,0.2,0.2,0.4,0.3,0.6 c0.1,0.2,0.3,0.3,0.6,0.5c0.2,0.1,0.4,0.2,0.7,0.3c0.2,0.1,0.5,0.1,0.7,0.1V99.3z M64,93.3l-2.1-5.4l-2.1,5.4H64z\"></path><path class=\"st2\" d=\"M88.7,85.3c-0.2,0-0.5,0.1-0.8,0.1c-0.4,0.1-0.7,0.2-1,0.4c-0.3,0.2-0.4,0.5-0.5,1c-0.1,0.5-0.2,1.1-0.2,2 v10.6h-1.8l-9-11.5v7c0,0.9,0.1,1.5,0.2,2c0.1,0.4,0.3,0.8,0.5,1c0.2,0.2,0.5,0.3,0.9,0.4c0.4,0.1,0.7,0.2,1,0.2v0.8h-6.2v-0.8 c0.3,0,0.6-0.1,0.9-0.2c0.3-0.1,0.6-0.2,0.9-0.4c0.3-0.2,0.4-0.5,0.5-0.9c0.1-0.4,0.1-1.1,0.1-2.1v-7c0-0.3-0.1-0.7-0.2-1 c-0.1-0.3-0.3-0.6-0.5-0.8c-0.2-0.2-0.5-0.4-0.8-0.6c-0.3-0.1-0.7-0.2-1-0.3v-0.8h5.4l7.9,10v-5.6c0-0.9-0.1-1.6-0.2-2 c-0.1-0.4-0.3-0.8-0.5-1c-0.2-0.2-0.5-0.3-0.9-0.4c-0.4-0.1-0.7-0.2-0.9-0.2v-0.8h6.2V85.3z\"></path><path class=\"st2\" d=\"M115.5,99.3h-7.8v-0.8c0.2,0,0.5-0.1,0.8-0.1c0.3,0,0.6-0.1,0.7-0.2c0.2-0.1,0.4-0.2,0.5-0.4 c0.1-0.2,0.2-0.4,0.2-0.7V86l-5,13h-1.3c-0.1-0.2-0.2-0.7-0.5-1.4c-0.2-0.7-0.4-1.2-0.6-1.6L99,85.8v9c0,0.9,0.1,1.5,0.2,2 c0.1,0.4,0.3,0.8,0.5,1c0.2,0.1,0.5,0.3,0.9,0.4c0.4,0.1,0.7,0.2,0.9,0.2v0.8h-6.2v-0.8c0.2,0,0.4-0.1,0.8-0.1 c0.4-0.1,0.7-0.2,0.9-0.4c0.3-0.2,0.5-0.5,0.5-1c0.1-0.5,0.1-1.1,0.1-2v-7.4c0-0.4-0.1-0.8-0.2-1.1c-0.1-0.3-0.3-0.5-0.5-0.7 c-0.3-0.2-0.5-0.4-0.8-0.4c-0.3-0.1-0.6-0.1-0.9-0.1v-0.8h6.6l3.5,9.8l3-7.9c0.1-0.3,0.2-0.6,0.3-1c0.1-0.4,0.1-0.7,0.2-0.8h6.4 v0.8c-0.2,0-0.4,0-0.7,0.1c-0.2,0-0.5,0.1-0.7,0.2c-0.3,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.1,0.4-0.1,0.6v10.5c0,0.3,0,0.5,0.1,0.6 c0.1,0.2,0.3,0.3,0.5,0.4c0.1,0.1,0.4,0.1,0.7,0.2c0.3,0.1,0.5,0.1,0.7,0.1V99.3z\"></path><path class=\"st2\" d=\"M125.3,99.3h-8v-0.8c0.2,0,0.5,0,0.8-0.1c0.4,0,0.6-0.1,0.7-0.1c0.2-0.1,0.4-0.2,0.5-0.4 c0.1-0.2,0.1-0.4,0.1-0.7l0-10.5c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.1-0.7-0.2 c-0.3-0.1-0.6-0.1-0.8-0.2v-0.8h8v0.8c-0.2,0-0.5,0.1-0.8,0.1c-0.3,0-0.6,0.1-0.8,0.2c-0.3,0.1-0.4,0.2-0.5,0.4 c-0.1,0.2-0.1,0.4-0.1,0.7v10.5c0,0.3,0,0.5,0.1,0.6c0.1,0.2,0.3,0.3,0.5,0.4c0.1,0.1,0.4,0.1,0.7,0.2c0.3,0.1,0.6,0.1,0.8,0.1 V99.3z\"></path><path class=\"st2\" d=\"M143.1,93.3c-0.2,0-0.4,0-0.6,0.1c-0.2,0-0.4,0.1-0.6,0.2c-0.3,0.1-0.5,0.2-0.5,0.4s-0.1,0.4-0.1,0.7v1.7 c0,0.3,0,0.6,0,0.8c0,0.2,0,0.5,0,0.8c-0.7,0.4-1.7,0.8-3,1.2c-1.3,0.4-2.5,0.6-3.6,0.6c-1,0-2-0.2-2.9-0.5 c-0.9-0.3-1.7-0.8-2.4-1.5c-0.7-0.6-1.2-1.5-1.6-2.4c-0.4-1-0.6-2.1-0.6-3.3c0-1.2,0.2-2.2,0.6-3.2c0.4-1,0.9-1.8,1.6-2.5 c0.7-0.7,1.5-1.2,2.5-1.6c1-0.4,2.1-0.6,3.3-0.6c0.8,0,1.6,0.1,2.3,0.3c0.7,0.2,1.3,0.4,1.7,0.7l0.6-0.6h0.9l0.1,5.4h-0.9 c-0.5-1.6-1.1-2.8-1.8-3.6c-0.7-0.8-1.6-1.2-2.7-1.2c-1.3,0-2.3,0.6-3,1.8c-0.7,1.2-1.1,2.8-1.1,4.8c0,2.2,0.3,3.9,1,5.1 c0.7,1.2,1.7,1.9,2.9,1.9c0.6,0,1.1-0.1,1.6-0.3c0.5-0.2,0.8-0.4,1.1-0.6v-3c0-0.3,0-0.5-0.1-0.6c-0.1-0.2-0.3-0.3-0.5-0.4 c-0.2-0.1-0.5-0.2-0.8-0.2c-0.3-0.1-0.6-0.1-0.8-0.1v-0.8h7.5V93.3z\"></path><path class=\"st2\" d=\"M160.8,85.3c-0.2,0-0.5,0.1-0.8,0.1c-0.4,0.1-0.7,0.2-0.9,0.4c-0.3,0.2-0.4,0.5-0.5,0.9 c-0.1,0.5-0.2,1.1-0.2,2v5.5c0,1.6-0.5,2.9-1.6,3.9c-1.1,1-2.5,1.5-4.2,1.5c-2,0-3.6-0.5-4.8-1.4c-1.1-1-1.7-2.3-1.7-4v-7.6 c0-0.2,0-0.5-0.1-0.6c-0.1-0.2-0.3-0.3-0.5-0.5c-0.2-0.1-0.4-0.2-0.6-0.2c-0.3-0.1-0.5-0.1-0.6-0.1v-0.8h7.5v0.8 c-0.2,0-0.4,0-0.7,0.1c-0.2,0-0.5,0.1-0.7,0.2c-0.3,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.1,0.4-0.1,0.7v7.5c0,1.5,0.3,2.5,0.9,3.2 c0.6,0.7,1.5,1,2.7,1c1.2,0,2.1-0.4,2.8-1.1c0.7-0.7,1-1.8,1-3.3v-5c0-0.9-0.1-1.6-0.2-2c-0.1-0.4-0.3-0.8-0.5-1 c-0.2-0.2-0.5-0.3-0.9-0.4c-0.4-0.1-0.7-0.2-0.9-0.2v-0.8h6.2V85.3z\"></path><path class=\"st2\" d=\"M174.7,88.2h-0.8c-0.2-0.6-0.5-1.1-1-1.7c-0.5-0.6-1-0.9-1.4-1c-0.2,0-0.5-0.1-0.8-0.1c-0.4,0-0.7,0-0.9,0 h-2.1v5.7h1.5c0.4,0,0.7,0,1-0.1c0.3-0.1,0.6-0.3,0.8-0.5c0.2-0.2,0.3-0.4,0.5-0.8c0.2-0.4,0.3-0.8,0.3-1.1h0.8l0,6.2h-0.8 c0-0.3-0.1-0.7-0.3-1.1c-0.2-0.4-0.3-0.7-0.5-0.9c-0.2-0.3-0.5-0.4-0.8-0.5c-0.3-0.1-0.7-0.1-1.1-0.1h-1.5v4.3 c0,0.4,0,0.8,0.1,1.1c0.1,0.3,0.2,0.5,0.4,0.6c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0,0.7,0.1,1.2,0.1c0.2,0,0.5,0,0.9,0 c0.3,0,0.6,0,0.9-0.1c0.3,0,0.5-0.1,0.8-0.2c0.2-0.1,0.4-0.2,0.6-0.3c0.3-0.3,0.7-0.9,1.1-1.6c0.4-0.7,0.7-1.2,0.8-1.6h0.7 l-0.3,4.6H162v-0.8c0.2,0,0.4,0,0.8-0.1c0.3,0,0.6-0.1,0.7-0.1c0.3-0.1,0.4-0.3,0.5-0.4c0.1-0.2,0.1-0.4,0.1-0.7V86.7 c0-0.3,0-0.5-0.1-0.6c-0.1-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.2-0.7-0.2c-0.3-0.1-0.6-0.1-0.7-0.1v-0.8h12.8V88.2z\"></path><path class=\"st2\" d=\"M190.9,94.5l-0.3,4.8h-13.3v-0.8c0.2,0,0.5-0.1,0.8-0.1c0.3,0,0.5-0.1,0.6-0.1c0.2-0.1,0.4-0.2,0.5-0.4 c0.1-0.2,0.1-0.4,0.1-0.7V86.7c0-0.3,0-0.5-0.1-0.6s-0.3-0.3-0.5-0.4c-0.2-0.1-0.5-0.2-0.8-0.2c-0.3-0.1-0.5-0.1-0.7-0.1v-0.8 h7.9v0.8c-0.2,0-0.5,0.1-0.8,0.1c-0.3,0-0.5,0.1-0.8,0.2c-0.3,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.1,0.4-0.1,0.7v9.8 c0,0.5,0,0.8,0.1,1.1c0.1,0.3,0.2,0.5,0.4,0.6c0.2,0.1,0.4,0.2,0.7,0.3c0.3,0,0.7,0.1,1.3,0.1c0.5,0,1.1,0,1.6-0.1 c0.5-0.1,0.9-0.2,1.1-0.4c0.3-0.4,0.7-0.9,1.1-1.5c0.4-0.6,0.7-1.2,0.9-1.8H190.9z\"></path><path class=\"st3\" d=\"M213.3,99.3h-7.8v-0.8c0.4,0,0.8-0.1,1.3-0.2c0.5-0.1,0.7-0.2,0.7-0.4c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.2-0.1-0.3l-1.2-3.1h-5c-0.1,0.3-0.2,0.6-0.4,1c-0.1,0.4-0.3,0.7-0.4,1c-0.1,0.4-0.2,0.7-0.2,0.8c0,0.2,0,0.3,0,0.4 c0,0.2,0.2,0.4,0.5,0.6c0.3,0.2,0.9,0.3,1.6,0.3v0.8h-5.9v-0.8c0.2,0,0.5-0.1,0.8-0.1c0.3-0.1,0.5-0.1,0.7-0.2 c0.3-0.2,0.5-0.4,0.7-0.6c0.2-0.2,0.4-0.5,0.5-0.9c0.8-2,1.6-3.9,2.4-5.9c0.8-2,1.7-4.1,2.6-6.5h2c1.3,3.4,2.4,6,3.1,8 c0.8,2,1.4,3.6,1.9,4.9c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.2,0.3,0.3,0.6,0.5c0.2,0.1,0.4,0.2,0.7,0.3c0.2,0.1,0.5,0.1,0.7,0.1V99.3z M205.8,93.3l-2.1-5.4l-2.1,5.4H205.8z\"></path><path class=\"st3\" d=\"M226.6,92.5c0.4,0.3,0.8,0.7,1.1,1.2c0.3,0.5,0.4,1,0.4,1.6c0,0.8-0.2,1.4-0.5,1.9c-0.3,0.5-0.7,0.9-1.3,1.2 c-0.6,0.3-1.3,0.5-2.1,0.7c-0.8,0.1-1.7,0.2-2.8,0.2h-7.5v-0.8c0.2,0,0.5-0.1,0.8-0.1c0.3,0,0.5-0.1,0.7-0.1 c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.1-0.4,0.1-0.7l0-10.5c0-0.3,0-0.5-0.1-0.6c-0.1-0.2-0.3-0.3-0.5-0.4 c-0.2-0.1-0.5-0.2-0.7-0.2c-0.3-0.1-0.5-0.1-0.7-0.1v-0.8h7.8c2,0,3.4,0.3,4.3,0.8c0.9,0.6,1.3,1.4,1.3,2.5 c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.4-0.5,0.7-0.8,1c-0.3,0.3-0.7,0.5-1.2,0.7s-1,0.3-1.5,0.5v0.2c0.5,0.1,1.1,0.2,1.6,0.4 C225.7,91.9,226.2,92.2,226.6,92.5z M223.3,88c0-0.8-0.2-1.5-0.7-1.9c-0.5-0.5-1.1-0.7-2-0.7c-0.1,0-0.3,0-0.5,0 c-0.2,0-0.4,0-0.5,0v5.5h0.5c1.1,0,1.9-0.3,2.4-0.8C223.1,89.6,223.3,88.9,223.3,88z M224,95.1c0-1-0.3-1.8-0.9-2.4 c-0.6-0.6-1.5-0.8-2.6-0.8c-0.1,0-0.3,0-0.5,0c-0.2,0-0.4,0-0.5,0v5.4c0.1,0.3,0.2,0.5,0.6,0.7s0.7,0.3,1.2,0.3 c0.8,0,1.5-0.3,2-0.8C223.8,96.9,224,96.2,224,95.1z\"></path><path class=\"st3\" d=\"M243.3,86.1c0.7,0.7,1.3,1.5,1.7,2.4c0.4,0.9,0.6,2,0.6,3.2c0,1.1-0.2,2.1-0.5,3.1c-0.4,1-0.9,1.8-1.5,2.5 c-0.7,0.7-1.5,1.3-2.5,1.7c-0.9,0.4-2.1,0.6-3.4,0.6c-1,0-2-0.2-3-0.5c-0.9-0.4-1.8-0.9-2.5-1.5c-0.7-0.7-1.3-1.5-1.7-2.4 c-0.4-0.9-0.6-2-0.6-3.2c0-1.2,0.2-2.3,0.6-3.3c0.4-1,1-1.8,1.7-2.5c0.7-0.7,1.5-1.2,2.5-1.6c1-0.4,2-0.6,3.1-0.6 c1.1,0,2.1,0.2,3,0.5C241.8,84.9,242.6,85.4,243.3,86.1z M240.7,96.7c0.3-0.6,0.5-1.4,0.7-2.2c0.1-0.8,0.2-1.7,0.2-2.7 c0-0.9-0.1-1.7-0.2-2.5c-0.1-0.8-0.3-1.5-0.6-2.2c-0.3-0.6-0.7-1.1-1.2-1.5c-0.5-0.4-1.1-0.6-1.8-0.6c-1.2,0-2.2,0.6-2.8,1.8 s-1,2.9-1,5.1c0,0.9,0.1,1.8,0.2,2.6c0.1,0.8,0.4,1.5,0.7,2.2c0.3,0.6,0.7,1.1,1.2,1.4c0.5,0.3,1,0.5,1.7,0.5 c0.7,0,1.2-0.2,1.7-0.5C240,97.8,240.4,97.3,240.7,96.7z\"></path><path class=\"st3\" d=\"M263.5,93.3c-0.2,0-0.4,0-0.6,0.1c-0.2,0-0.4,0.1-0.6,0.2c-0.3,0.1-0.5,0.2-0.5,0.4 c-0.1,0.2-0.1,0.4-0.1,0.7v1.7c0,0.3,0,0.6,0,0.8c0,0.2,0,0.5,0,0.8c-0.7,0.4-1.7,0.8-3,1.2c-1.3,0.4-2.5,0.6-3.6,0.6 c-1,0-2-0.2-2.9-0.5c-0.9-0.3-1.7-0.8-2.4-1.5c-0.7-0.6-1.2-1.5-1.6-2.4c-0.4-1-0.6-2.1-0.6-3.3c0-1.2,0.2-2.2,0.6-3.2 c0.4-1,0.9-1.8,1.6-2.5c0.7-0.7,1.5-1.2,2.5-1.6c1-0.4,2.1-0.6,3.3-0.6c0.8,0,1.6,0.1,2.3,0.3c0.7,0.2,1.3,0.4,1.7,0.7l0.6-0.6 h0.9l0.1,5.4h-0.9c-0.5-1.6-1.1-2.8-1.8-3.6c-0.7-0.8-1.6-1.2-2.7-1.2c-1.3,0-2.3,0.6-3,1.8c-0.7,1.2-1.1,2.8-1.1,4.8 c0,2.2,0.3,3.9,1,5.1c0.7,1.2,1.7,1.9,2.9,1.9c0.6,0,1.1-0.1,1.6-0.3c0.5-0.2,0.8-0.4,1.1-0.6v-3c0-0.3,0-0.5-0.1-0.6 c-0.1-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.5-0.2-0.8-0.2c-0.3-0.1-0.6-0.1-0.8-0.1v-0.8h7.5V93.3z\"></path><path class=\"st3\" d=\"M280.3,99.3h-7.8v-0.8c0.4,0,0.8-0.1,1.3-0.2c0.5-0.1,0.7-0.2,0.7-0.4c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.2-0.1-0.3l-1.2-3.1h-5c-0.1,0.3-0.2,0.6-0.4,1c-0.1,0.4-0.3,0.7-0.4,1c-0.1,0.4-0.2,0.7-0.2,0.8c0,0.2,0,0.3,0,0.4 c0,0.2,0.2,0.4,0.5,0.6c0.3,0.2,0.9,0.3,1.6,0.3v0.8h-5.9v-0.8c0.2,0,0.5-0.1,0.8-0.1c0.3-0.1,0.5-0.1,0.7-0.2 c0.3-0.2,0.5-0.4,0.7-0.6c0.2-0.2,0.4-0.5,0.5-0.9c0.8-2,1.6-3.9,2.4-5.9c0.8-2,1.7-4.1,2.6-6.5h2c1.3,3.4,2.4,6,3.1,8 c0.8,2,1.4,3.6,1.9,4.9c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.2,0.3,0.3,0.6,0.5c0.2,0.1,0.4,0.2,0.7,0.3c0.2,0.1,0.5,0.1,0.7,0.1V99.3z M272.7,93.3l-2.1-5.4l-2.1,5.4H272.7z\"></path><path class=\"st3\" d=\"M293.8,86c0.9,0.6,1.6,1.4,2.1,2.4c0.5,1,0.8,2.2,0.8,3.6c0,1.3-0.2,2.3-0.7,3.3c-0.5,0.9-1.1,1.7-1.9,2.3 c-0.8,0.6-1.7,1-2.8,1.3c-1,0.3-2.1,0.4-3.2,0.4h-7.3v-0.8c0.2,0,0.5,0,0.8-0.1c0.3,0,0.5-0.1,0.6-0.1c0.2-0.1,0.4-0.2,0.5-0.4 c0.1-0.2,0.1-0.4,0.1-0.6V86.7c0-0.2,0-0.5-0.1-0.6s-0.3-0.3-0.5-0.5c-0.3-0.1-0.5-0.2-0.8-0.2c-0.3,0-0.5-0.1-0.7-0.1v-0.8h7.7 c0.8,0,1.7,0.1,2.6,0.3C292,85,292.9,85.4,293.8,86z M291.7,96.6c0.3-0.6,0.6-1.2,0.7-2c0.2-0.8,0.2-1.7,0.2-2.7 c0-1-0.1-1.9-0.3-2.7c-0.2-0.8-0.5-1.5-0.9-2.1c-0.4-0.6-0.9-1-1.5-1.3c-0.6-0.3-1.2-0.5-2-0.5c-0.2,0-0.5,0-0.8,0 c-0.3,0-0.5,0-0.7,0v11.3c0,0.3,0,0.5,0.1,0.7s0.2,0.4,0.3,0.5c0.2,0.1,0.3,0.3,0.6,0.3c0.2,0.1,0.5,0.1,0.9,0.1 c0.8,0,1.4-0.1,2-0.4S291.4,97.2,291.7,96.6z\"></path><path class=\"st3\" d=\"M311.9,86.1c0.7,0.7,1.3,1.5,1.7,2.4c0.4,0.9,0.6,2,0.6,3.2c0,1.1-0.2,2.1-0.5,3.1c-0.4,1-0.9,1.8-1.5,2.5 c-0.7,0.7-1.5,1.3-2.5,1.7c-0.9,0.4-2.1,0.6-3.4,0.6c-1,0-2-0.2-3-0.5c-0.9-0.4-1.8-0.9-2.5-1.5c-0.7-0.7-1.3-1.5-1.7-2.4 s-0.6-2-0.6-3.2c0-1.2,0.2-2.3,0.6-3.3c0.4-1,1-1.8,1.7-2.5c0.7-0.7,1.5-1.2,2.5-1.6c1-0.4,2-0.6,3.1-0.6c1.1,0,2.1,0.2,3,0.5 C310.4,84.9,311.2,85.4,311.9,86.1z M309.3,96.7c0.3-0.6,0.5-1.4,0.7-2.2c0.1-0.8,0.2-1.7,0.2-2.7c0-0.9-0.1-1.7-0.2-2.5 c-0.1-0.8-0.3-1.5-0.6-2.2c-0.3-0.6-0.7-1.1-1.2-1.5c-0.5-0.4-1.1-0.6-1.8-0.6c-1.2,0-2.2,0.6-2.8,1.8c-0.6,1.2-1,2.9-1,5.1 c0,0.9,0.1,1.8,0.2,2.6c0.1,0.8,0.4,1.5,0.7,2.2c0.3,0.6,0.7,1.1,1.2,1.4c0.5,0.3,1,0.5,1.7,0.5c0.7,0,1.2-0.2,1.7-0.5 C308.6,97.8,309,97.3,309.3,96.7z\"></path><path class=\"st3\" d=\"M322,99.7c-0.9,0-1.7-0.1-2.5-0.3c-0.8-0.2-1.4-0.5-1.9-0.8l-0.7,0.7h-0.9l-0.1-5.4h0.9 c0.2,0.5,0.4,1,0.8,1.6c0.3,0.6,0.7,1.1,1.1,1.5c0.4,0.5,0.9,0.8,1.4,1.1c0.5,0.3,1.1,0.4,1.8,0.4c0.9,0,1.6-0.2,2.1-0.7 c0.5-0.5,0.7-1,0.7-1.8c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-1.1-0.7-1.9-1c-0.6-0.2-1.1-0.4-1.6-0.5c-0.5-0.2-0.9-0.3-1.3-0.5 c-1-0.4-1.7-1-2.2-1.7c-0.5-0.7-0.7-1.6-0.7-2.5c0-0.6,0.1-1.1,0.4-1.7c0.2-0.5,0.6-1,1.1-1.4c0.4-0.4,1-0.7,1.7-1 c0.7-0.3,1.5-0.4,2.3-0.4c0.8,0,1.5,0.1,2.2,0.3c0.7,0.2,1.2,0.5,1.6,0.7l0.6-0.6h0.9l0.1,5.1h-0.9c-0.2-0.5-0.4-1.1-0.7-1.7 c-0.3-0.6-0.6-1-0.9-1.4c-0.3-0.4-0.7-0.7-1.1-1c-0.4-0.2-0.9-0.4-1.5-0.4c-0.7,0-1.3,0.2-1.8,0.6c-0.5,0.4-0.7,1-0.7,1.6 c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,1,0.7,1.9,1c0.5,0.2,1,0.3,1.5,0.5c0.5,0.2,1,0.3,1.4,0.5c1,0.4,1.7,0.9,2.2,1.6 c0.5,0.7,0.8,1.5,0.8,2.6c0,0.6-0.1,1.3-0.4,1.9c-0.3,0.6-0.7,1.1-1.2,1.5c-0.5,0.4-1.2,0.8-1.9,1C323.8,99.6,323,99.7,322,99.7z\"></path><path class=\"st2\" d=\"M341.6,99.7c-0.9,0-1.7-0.1-2.5-0.3c-0.8-0.2-1.4-0.5-1.9-0.8l-0.7,0.7h-0.9l-0.1-5.4h0.9 c0.2,0.5,0.4,1,0.8,1.6c0.3,0.6,0.7,1.1,1.1,1.5c0.4,0.5,0.9,0.8,1.4,1.1c0.5,0.3,1.1,0.4,1.8,0.4c0.9,0,1.6-0.2,2.1-0.7 c0.5-0.5,0.7-1,0.7-1.8c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-1.1-0.7-1.9-1c-0.6-0.2-1.1-0.4-1.6-0.5c-0.5-0.2-0.9-0.3-1.3-0.5 c-1-0.4-1.7-1-2.2-1.7c-0.5-0.7-0.7-1.6-0.7-2.5c0-0.6,0.1-1.1,0.4-1.7c0.2-0.5,0.6-1,1.1-1.4c0.4-0.4,1-0.7,1.7-1 c0.7-0.3,1.5-0.4,2.3-0.4c0.8,0,1.5,0.1,2.2,0.3c0.7,0.2,1.2,0.5,1.6,0.7l0.6-0.6h0.9l0.1,5.1h-0.9c-0.2-0.5-0.4-1.1-0.7-1.7 c-0.3-0.6-0.6-1-0.9-1.4c-0.3-0.4-0.7-0.7-1.1-1c-0.4-0.2-0.9-0.4-1.5-0.4c-0.7,0-1.3,0.2-1.8,0.6c-0.5,0.4-0.7,1-0.7,1.6 c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,1,0.7,1.9,1c0.5,0.2,1,0.3,1.5,0.5c0.5,0.2,1,0.3,1.4,0.5c1,0.4,1.7,0.9,2.2,1.6 c0.5,0.7,0.8,1.5,0.8,2.6c0,0.6-0.1,1.3-0.4,1.9c-0.3,0.6-0.7,1.1-1.2,1.5c-0.5,0.4-1.2,0.8-1.9,1 C343.4,99.6,342.6,99.7,341.6,99.7z\"></path><path class=\"st2\" d=\"M362.8,86.1c0.7,0.7,1.3,1.5,1.7,2.4c0.4,0.9,0.6,2,0.6,3.2c0,1.1-0.2,2.1-0.5,3.1c-0.4,1-0.9,1.8-1.5,2.5 c-0.7,0.7-1.5,1.3-2.5,1.7c-0.9,0.4-2.1,0.6-3.4,0.6c-1,0-2-0.2-3-0.5c-0.9-0.4-1.8-0.9-2.5-1.5c-0.7-0.7-1.3-1.5-1.7-2.4 c-0.4-0.9-0.6-2-0.6-3.2c0-1.2,0.2-2.3,0.6-3.3c0.4-1,1-1.8,1.7-2.5c0.7-0.7,1.5-1.2,2.5-1.6c1-0.4,2-0.6,3.1-0.6 c1.1,0,2.1,0.2,3,0.5C361.3,84.9,362.1,85.4,362.8,86.1z M360.2,96.7c0.3-0.6,0.5-1.4,0.7-2.2c0.1-0.8,0.2-1.7,0.2-2.7 c0-0.9-0.1-1.7-0.2-2.5c-0.1-0.8-0.3-1.5-0.6-2.2c-0.3-0.6-0.7-1.1-1.2-1.5c-0.5-0.4-1.1-0.6-1.8-0.6c-1.2,0-2.2,0.6-2.8,1.8 c-0.6,1.2-1,2.9-1,5.1c0,0.9,0.1,1.8,0.2,2.6c0.1,0.8,0.4,1.5,0.7,2.2c0.3,0.6,0.7,1.1,1.2,1.5c0.5,0.3,1,0.5,1.7,0.5 c0.7,0,1.2-0.2,1.7-0.5C359.5,97.8,359.9,97.3,360.2,96.7z\"></path><path class=\"st2\" d=\"M374.5,99.7c-1.1,0-2-0.2-3-0.5c-0.9-0.4-1.7-0.9-2.4-1.5c-0.7-0.7-1.2-1.5-1.6-2.4c-0.4-1-0.6-2-0.6-3.2 c0-1.2,0.2-2.2,0.6-3.2c0.4-1,0.9-1.8,1.6-2.6c0.7-0.7,1.5-1.3,2.5-1.6c1-0.4,2-0.6,3.1-0.6c0.8,0,1.5,0.1,2.2,0.3 c0.7,0.2,1.2,0.4,1.7,0.7l0.6-0.6h0.9l0.1,5.4h-0.9c-0.5-1.7-1.1-2.9-1.8-3.6c-0.7-0.8-1.6-1.2-2.6-1.2c-1.3,0-2.2,0.6-2.9,1.7 c-0.7,1.2-1,2.8-1,4.9c0,1.2,0.1,2.2,0.3,3c0.2,0.8,0.5,1.5,0.9,2c0.4,0.5,0.9,0.9,1.4,1.2c0.5,0.2,1.1,0.4,1.8,0.4 c0.9,0,1.8-0.3,2.5-0.8c0.7-0.5,1.4-1.3,2-2.4l0.9,0.5c-0.3,0.6-0.6,1.2-1,1.6c-0.4,0.5-0.8,0.9-1.3,1.2 c-0.5,0.4-1.1,0.7-1.8,0.9C376.1,99.6,375.4,99.7,374.5,99.7z\"></path><path class=\"st2\" d=\"M386.9,97.5c0,0.6-0.2,1-0.6,1.4c-0.4,0.4-0.9,0.6-1.4,0.6c-0.5,0-1-0.2-1.4-0.6c-0.4-0.4-0.6-0.9-0.6-1.4 c0-0.6,0.2-1,0.6-1.4c0.4-0.4,0.9-0.6,1.4-0.6c0.5,0,1,0.2,1.4,0.6C386.7,96.5,386.9,97,386.9,97.5z\"></path><path class=\"st2\" d=\"M402.7,99.7c-1.1,0-2-0.2-3-0.5c-0.9-0.4-1.7-0.9-2.4-1.5c-0.7-0.7-1.2-1.5-1.6-2.4c-0.4-1-0.6-2-0.6-3.2 c0-1.2,0.2-2.2,0.6-3.2s0.9-1.8,1.6-2.6c0.7-0.7,1.5-1.3,2.5-1.6c1-0.4,2-0.6,3.1-0.6c0.8,0,1.5,0.1,2.2,0.3 c0.7,0.2,1.2,0.4,1.7,0.7l0.6-0.6h0.9l0.1,5.4h-0.9c-0.5-1.7-1.1-2.9-1.8-3.6c-0.7-0.8-1.6-1.2-2.6-1.2c-1.3,0-2.2,0.6-2.9,1.7 c-0.7,1.2-1,2.8-1,4.9c0,1.2,0.1,2.2,0.3,3c0.2,0.8,0.5,1.5,0.9,2c0.4,0.5,0.9,0.9,1.4,1.2c0.5,0.2,1.1,0.4,1.8,0.4 c0.9,0,1.8-0.3,2.5-0.8c0.7-0.5,1.4-1.3,2-2.4l0.9,0.5c-0.3,0.6-0.6,1.2-1,1.6c-0.4,0.5-0.8,0.9-1.3,1.2 c-0.5,0.4-1.1,0.7-1.8,0.9C404.3,99.6,403.6,99.7,402.7,99.7z\"></path><path class=\"st2\" d=\"M418.3,99.3l-8,0v-0.8c0.2,0,0.5,0,0.8-0.1c0.4,0,0.6-0.1,0.7-0.1c0.2-0.1,0.4-0.2,0.5-0.4 c0.1-0.2,0.1-0.4,0.1-0.7V86.7c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.1-0.7-0.2c-0.3-0.1-0.6-0.1-0.8-0.2 v-0.8h8v0.8c-0.2,0-0.5,0.1-0.8,0.1c-0.3,0-0.6,0.1-0.8,0.2c-0.3,0.1-0.4,0.2-0.5,0.4s-0.1,0.4-0.1,0.7v10.5c0,0.3,0,0.5,0.1,0.6 c0.1,0.2,0.3,0.3,0.5,0.4c0.1,0.1,0.4,0.1,0.7,0.2c0.3,0.1,0.6,0.1,0.8,0.1V99.3z\"></path><path class=\"st2\" d=\"M435.7,85.3c-0.2,0-0.4,0.1-0.6,0.1c-0.2,0.1-0.4,0.2-0.6,0.3c-0.3,0.2-0.5,0.4-0.7,0.6 c-0.2,0.2-0.3,0.5-0.5,0.8c-0.2,0.5-0.5,1.2-0.9,2.1c-0.4,0.9-0.8,2-1.3,3.2c-0.4,1.1-0.9,2.2-1.4,3.5c-0.5,1.3-1,2.5-1.4,3.6h-2 c-0.9-2.4-1.9-4.8-2.9-7.3c-1-2.5-1.7-4.2-2.1-5.1c-0.2-0.3-0.3-0.6-0.5-0.8c-0.1-0.2-0.4-0.4-0.7-0.5c-0.2-0.1-0.4-0.2-0.6-0.3 c-0.2-0.1-0.4-0.1-0.7-0.1v-0.8h7.8v0.8c-0.7,0.1-1.2,0.2-1.5,0.3c-0.3,0.1-0.4,0.2-0.4,0.4c0,0.1,0,0.2,0,0.2s0.1,0.2,0.1,0.4 c0.2,0.6,0.6,1.6,1.2,3c0.6,1.4,1.4,3.5,2.5,6.4c0.7-1.7,1.3-3.2,1.7-4.4c0.5-1.2,0.9-2.3,1.2-3.2c0.2-0.4,0.3-0.9,0.4-1.2 s0.2-0.7,0.2-0.9c0-0.2-0.2-0.4-0.5-0.6c-0.3-0.2-0.9-0.3-1.7-0.3v-0.8h5.8V85.3z\"></path><path class=\"st2\" d=\"M441.1,97.5c0,0.6-0.2,1-0.6,1.4c-0.4,0.4-0.9,0.6-1.4,0.6c-0.5,0-1-0.2-1.4-0.6c-0.4-0.4-0.6-0.9-0.6-1.4 c0-0.6,0.2-1,0.6-1.4c0.4-0.4,0.9-0.6,1.4-0.6c0.5,0,1,0.2,1.4,0.6C440.9,96.5,441.1,97,441.1,97.5z\"></path></g><rect x=\"42.1\" y=\"103.7\" class=\"st0\" width=\"398.9\" height=\"1.3\"></rect></g></g></svg></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/views/components/mainsection.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title>Title</title></head><body></body></html>");
$templateCache.put("app/views/modals/modalarea.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid modal-family\" customheight=\"\" autoscroll=\"true\"><a class=\"close-button\" data-ng-click=\"$root.closeModal()\"><svg width=\"50px\" height=\"50px\" viewbox=\"0 0 50 50\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"close\" fill=\"#FFFFFF\"><path d=\"M22.263456,25.0918831 L6,41.3553391 L8.82842712,44.1837662 L25.0918831,27.9203102 L41.3553391,44.1837662 L44.1837662,41.3553391 L27.9203102,25.0918831 L44.1837662,8.82842712 L41.3553391,6 L25.0918831,22.263456 L8.82842712,6 L6,8.82842712 L22.263456,25.0918831 Z\" id=\"Combined-Shape\"></path></g></g></svg></a><div class=\"form-wrapper large\"><h3 class=\"form-title\">Areas de especialidad</h3><div class=\"area-wrapper\"><div class=\"area-box\" data-ng-if=\"area.webroute_id == 2\" data-ng-repeat=\"area in $root.wc.websection\"><div class=\"area\" data-ng-click=\"$root.stateGo(\'area-selected\', {lan: $root.language, id:area.id})\"><div class=\"image-background\"><div class=\"image\" data-ng-style=\"{\'background\': \'url(\' + $root.api+area.image + \')\'}\"></div></div><div class=\"legend\"><p class=\"area-legend\">{{$root.transl(area.title)}}</p></div></div></div></div></div></div></div>");
$templateCache.put("app/views/modals/modalcontact.html","<div class=\"form-cta wow slideInUp\" data-wow-delay=\"1s\" data-ng-class=\"{\'open\':$root.ctaOn}\" data-ng-init=\"$root.ctaOn = false\"><div class=\"cta-header\"><a class=\"cta-title\" data-ng-click=\"$root.ctaOn = !$root.ctaOn; $root.ctaTab = 1\">{{$root.transl($root.uiText.contact.title)}}</a> <a data-ng-click=\"$root.ctaNav(\'prev\')\" data-ng-if=\"$root.ctaOn && $root.ctaTab > 1 && $root.ctaTab < 4\" class=\"cta-prev\"><i class=\"fas fa-chevron-left\"></i></a> <a data-ng-click=\"$root.ctaOn = !$root.ctaOn\" data-ng-if=\"($root.ctaOn && $root.ctaTab == 1) || ($root.ctaOn && $root.ctaTab == 4)\" class=\"cta-prev\"><i class=\"fas fa-times\"></i></a> <a data-ng-hide=\"!$root.ctaOn\" class=\"cta-step\">{{$root.ctaTab}}/4</a></div><form class=\"cta-form input-group\" data-ng-if=\"$root.ctaOn && $root.ctaTab ==1\"><input type=\"text\" class=\"form-control\" data-ng-model=\"$root.formData.name\" id=\"exampleInputAmount\" placeholder=\"{{$root.transl($root.uiText.contact.placeholder1)}}\"><div class=\"input-group-addon\" data-ng-click=\"$root.ctaNav(\'next\')\"><i class=\"fas fa-chevron-right\"></i></div></form><form class=\"cta-form input-group\" data-ng-if=\"$root.ctaOn && $root.ctaTab ==2\"><input type=\"email\" class=\"form-control\" data-ng-model=\"$root.formData.email\" id=\"exampleInputAmount\" placeholder=\"{{$root.transl($root.uiText.contact.placeholder2)}}\"><div class=\"input-group-addon\" data-ng-click=\"$root.ctaNav(\'next\')\"><i class=\"fas fa-chevron-right\"></i></div></form><form class=\"cta-form input-group\" data-ng-if=\"$root.ctaOn && $root.ctaTab ==3\"><textarea name=\"\" class=\"form-control\" data-ng-model=\"$root.formData.message\" id=\"exampleInputAmount\" placeholder=\"{{$root.transl($root.uiText.contact.placeholder3)}}\"></textarea><div class=\"input-group-addon\" data-ng-click=\"$root.ctaNav(\'next\');$root.sendForm(3, $root.formData, true)\"><i class=\"fas fa-chevron-right\"></i></div></form><form class=\"cta-form\" data-ng-if=\"$root.ctaOn && $root.ctaTab ==4\"><p class=\"cta-message\">{{$root.transl($root.uiText.contact.messageSuccess)}}</p></form></div>");
$templateCache.put("app/views/modals/modalmenu.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid modal-family\" customheight=\"\" autoscroll=\"true\"><a class=\"close-button wow fadeIn\" data-ng-if=\"$root.modals.currentModal!=\'\'\" data-ng-click=\"$root.closeModal()\"><svg width=\"50px\" height=\"50px\" viewbox=\"0 0 50 50\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"close\" fill=\"#FFFFFF\"><path d=\"M22.263456,25.0918831 L6,41.3553391 L8.82842712,44.1837662 L25.0918831,27.9203102 L41.3553391,44.1837662 L44.1837662,41.3553391 L27.9203102,25.0918831 L44.1837662,8.82842712 L41.3553391,6 L25.0918831,22.263456 L8.82842712,6 L6,8.82842712 L22.263456,25.0918831 Z\" id=\"Combined-Shape\"></path></g></g></svg></a><div class=\"menu-wrapper\" customheight=\"\"><h3 class=\"form-title {{$root.gustuTheme}}\">Menú</h3><div class=\"btn-group btn-group-lan mobile {{$root.language}}\" dropdown=\"\" is-open=\"$root.isopen2\"><button id=\"single-button\" type=\"button\" class=\"btn btn-primary\" dropdown-toggle=\"\"><span class=\"caret\"></span></button><ul class=\"dropdown-menu\" dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\" data-ng-repeat=\"a in $root.wc.webconfig\" data-ng-if=\"a.config != $root.language && a.value == \'1\'\"><a href=\"#\" class=\"{{a.config}}\" data-ng-click=\"$root.changeLanguage(a.config,$root.currentState)\"></a></li></ul></div><ul class=\"social-link mobile\"><li data-ng-if=\"$root.wc.websocial[0].url!=\'\'\"><a target=\"_blank\" href=\"https://api.whatsapp.com/send?phone=591{{$root.wc.websocial[0].url}}\" class=\"social-icon\"><i class=\"fab fa-whatsapp\"></i></a></li><li data-ng-if=\"$root.wc.websocial[1].url!=\'\'\"><a href=\"{{$root.wc.websocial[1].url}}\" target=\"_blank\" class=\"social-icon\"><i class=\"fab fa-facebook-f\"></i></a></li><li data-ng-if=\"$root.wc.websocial[2].url!=\'\'\"><a href=\"{{$root.wc.websocial[2].url}}\" target=\"_blank\" class=\"social-icon\"><i class=\"fab fa-twitter\"></i></a></li><li data-ng-if=\"$root.wc.websocial[3].url!=\'\'\"><a href=\"{{$root.wc.websocial[3].url}}\" target=\"_blank\" class=\"social-icon\"><i class=\"fab fa-linkedin-in\"></i></a></li></ul><div class=\"menu-w\"><div class=\"menu-box left\"><div class=\"menu-image-box wow fadeIn\"><div class=\"image-background\"><div class=\"image\" data-ng-style=\"{\'background\': \'url(\' + $root.api + $root.menuBack + \')\'}\"></div></div></div></div><div class=\"menu-box right\"><div class=\"menu-sep wow fadeIn\"></div><ul class=\"menu-options\"><li class=\"wow fadeIn\" data-wow-delay=\"{{0+(($index+1)*0.2)}}s\" data-ng-repeat=\"state in $root.wc.webroute\" data-ng-if=\"state.type==1\"><a data-ng-click=\"$root.stateGo(state.state)\" data-ng-mouseover=\"$root.menuImage(state)\" data-ng-class=\"{\'active\':$root.currentState==state.state}\">{{$root.transl(state.url)}}</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/views/modals/modalsearch.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid modal-family\" customheight=\"\" autoscroll=\"true\"><a class=\"close-button\" data-ng-click=\"$root.closeModal()\"><svg width=\"50px\" height=\"50px\" viewbox=\"0 0 50 50\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"close\" fill=\"#FFFFFF\"><path d=\"M22.263456,25.0918831 L6,41.3553391 L8.82842712,44.1837662 L25.0918831,27.9203102 L41.3553391,44.1837662 L44.1837662,41.3553391 L27.9203102,25.0918831 L44.1837662,8.82842712 L41.3553391,6 L25.0918831,22.263456 L8.82842712,6 L6,8.82842712 L22.263456,25.0918831 Z\" id=\"Combined-Shape\"></path></g></g></svg></a><div class=\"form-wrapper large\"><form ng-submit=\"$root.searchContent($root.formData)\"><h3 class=\"form-title\">{{$root.sT(\'Buscar\',\'Search\')}}</h3><div class=\"input-row\"><div class=\"btn-group btn-group-search\"><input type=\"text\" data-ng-model=\"$root.formData.search\" placeholder=\"{{$root.sT(\'Buscar por\',\'Search for\')}}\" class=\"form-control\"> <button type=\"button\" class=\"btn btn-primary\"><i class=\"fas fa-search\"></i></button></div></div><div class=\"input-row\"><button style=\"margin-top: 20px; margin: 20px auto; display: block; float: none;\" type=\"submit\" class=\"button button--antiman button--round-l button--text-medium\">{{$root.sT(\'Buscar\',\'Search\')}}</button></div></form><div class=\"area-wrapper fullpage\" style=\"padding-top: 0\"><div class=\"area-box\" style=\"transform: scale(0.9)\" data-ng-repeat=\"area in $root.searched\"><div class=\"area\" data-ng-click=\"$root.stateGo($root.childRoute(area), {lan: $root.language, id:area.id})\"><div class=\"image-background\"><div class=\"image\" data-ng-style=\"{\'background\': \'url(\' + $root.api+((area.image)?area.image:area.image2)+ \')\'}\"></div></div><div class=\"legend\" style=\"bottom: 25px;\"><p class=\"area-legend\">{{$root.transl(area.title)}}</p></div></div></div></div></div></div></div>");
$templateCache.put("app/views/pages/aboutus.html","<div class=\"row\" customheight=\"\"><ng-include data-src=\"\'app/views/header.html\'\"></ng-include><ng-include data-src=\"\'app/views/modals/modalcontact.html\'\"></ng-include><div class=\"sm-wrapper\"><div class=\"wrapper left\"><div class=\"wrapper-body\" wleft=\"\" sec=\"$root.wc\"></div></div><div class=\"wrapper right\"><div class=\"wrapper-body\" wright=\"\" sec=\"$root.wc\"></div></div></div></div>");
$templateCache.put("app/views/pages/area-selected.html","<div class=\"row\" customheight=\"\"><ng-include data-src=\"\'app/views/header.html\'\"></ng-include><ng-include data-src=\"\'app/views/modals/modalcontact.html\'\"></ng-include><div class=\"sm-wrapper\"><div class=\"wrapper left\"><div class=\"wrapper-body\" wleft=\"\" sec=\"$root.wc\"></div></div><div class=\"wrapper right\"><div class=\"wrapper-body extra-padding\" wright=\"\" sec=\"$root.wc\"></div></div></div></div>");
$templateCache.put("app/views/pages/areas.html","<div class=\"row\" customheight=\"\" data-ng-if=\"$root.wc\"><ng-include data-src=\"\'app/views/header.html\'\"></ng-include><ng-include data-src=\"\'app/views/modals/modalcontact.html\'\"></ng-include><div class=\"area-wrapper fullpage\"><div class=\"page-title-box\"><h1 class=\"page-title active\">{{$root.transl($root.wc.webroute[1].url)}}</h1></div><div class=\"area-box\" data-ng-if=\"area.webroute_id == 2\" data-ng-repeat=\"area in $root.wc.websection\"><div class=\"area\" data-ng-click=\"$root.temporalElement(area.name.es, area.image);$root.stateGo(\'area-selected\', {lan: $root.language, id:area.id})\"><div class=\"image-background\"><div class=\"image\" data-ng-style=\"{\'background\': \'url(\' + $root.api+area.image + \')\'}\"></div></div><div class=\"legend wow fadeIn\" data-wow-delay=\".2s\"><p class=\"area-legend\">{{$root.transl(area.title)}}</p></div></div></div></div></div>");
$templateCache.put("app/views/pages/contact-backup.html","<div class=\"row section s3 contact-wrapper\" customheight=\"\"><ng-include data-src=\"\'app/views/header.html\'\"></ng-include><ng-include data-src=\"\'app/views/modals/modalcontact.html\'\"></ng-include><div class=\"wrapper left\" style=\"padding: 0\"><div class=\"wrapper-body left-box contact\"><div class=\"article\"><div class=\"content\"><h4>{{$root.transl($root.wc.webroute[8].url)}}</h4><div class=\"btn-group btn-group-filter contact\" dropdown=\"\" is-open=\"$root.isopen3\"><button id=\"single-button\" type=\"button\" class=\"btn btn-primary\" dropdown-toggle=\"\">La Paz <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\" data-ng-repeat=\"city in $root.wct.webcities\"><a href=\"#\">{{city.name}}</a></li></ul></div><a data-ng-click=\"$root.sendMail( \'info@sanmiguelabogados.com.bo\' ,\'Contactar San Miguel Abogados\',\'\')\">info@sanmiguelabogados.com.bo</a> <a class=\"phone\" href=\"tel:(+591)22150248\">(+591) 22150248</a> <a class=\"phone\" href=\"tel:(+591)22150281\">22150281</a> <a class=\"phone\" href=\"tel:(+591)22150319\">22150319</a></div></div></div></div><div class=\"wrapper right\"><div class=\"wrapper-body right-box contact\"><ng-map customheight=\"\" minus=\"373\" center=\"{{$root.getGPS($root.mapConf.center.lat, $root.mapConf.center.lon)}}\" zoom=\"{{$root.mapConf.zoom}}\" styles=\"{{$root.MapsStyle}}\"><marker position=\"{{$root.getGPS(marker.coordinates.lat, marker.coordinates.lon)}}\" icon=\"{ url:\'../assets/images/ubicacion.svg\', scaledSize:[50,50], origin: [0,0], anchor: [16,40] }\" data-ng-repeat=\"marker in $root.wct.webcities\"></marker></ng-map></div></div></div>");
$templateCache.put("app/views/pages/contact-selected.html","<div class=\"row section s3 contact-wrapper\" customheight=\"\"><ng-include data-src=\"\'app/views/header.html\'\"></ng-include><ng-include data-src=\"\'app/views/modals/modalcontact.html\'\"></ng-include><div class=\"wrapper left\" style=\"padding: 0\"><div class=\"wrapper-body left-box contact\"><div class=\"article\"><div class=\"content\"><h4 style=\"margin-bottom: 30px\">{{$root.pickedCity.name}}</h4></div><div class=\"content\"><p class=\"phone\"><i class=\"far fa-envelope\"></i> <a data-ng-click=\"$root.sendMail( \'info@sanmiguelabogados.com.bo\' ,\'Contactar San Miguel Abogados\',\'\')\">{{$root.pickedCity.email}}</a></p><p class=\"phone\"><i class=\"fa fa-phone\"></i> <a href=\"\">{{$root.pickedCity.phone}}</a></p><p class=\"phone\"><i class=\"fas fa-map-marker-alt\"></i> <a href=\"\">{{$root.transl($root.pickedCity.address)}}</a></p><p class=\"phone\"><a style=\"cursor: pointer;\" class=\"wow fadeIn button button--antiman\" data-ng-click=\"$root.openInMaps($root.pickedCity.city.lat, $root.pickedCity.city.lon)\">{{$root.transl($root.uiText.cities.mapsButton)}}</a></p></div></div></div></div><div class=\"wrapper right\" data-ng-if=\"$root.pickedCity\"><div class=\"wrapper-body right-box contact\"><ng-map customheight=\"\" minus=\"373\" center=\"{{$root.getGPS($root.pickedCity.city.lat, $root.pickedCity.city.lon)}}\" zoom=\"17\" styles=\"{{$root.MapsStyle}}\"><marker position=\"{{$root.getGPS($root.pickedCity.city.lat, $root.pickedCity.city.lon)}}\" icon=\"{ url:\'../assets/images/ubicacion.svg\', scaledSize:[50,50], origin: [0,0], anchor: [25,25] }\"></marker></ng-map></div></div></div>");
$templateCache.put("app/views/pages/contact.html","<div class=\"row\" customheight=\"\" data-ng-if=\"$root.wc\"><ng-include data-src=\"\'app/views/header.html\'\"></ng-include><ng-include data-src=\"\'app/views/modals/modalcontact.html\'\"></ng-include><div class=\"area-wrapper fullpage\"><div class=\"page-title-box\"><h1 class=\"page-title active\">{{$root.transl($root.wc.webroute[8].url)}}</h1></div><div class=\"area-box\" data-ng-repeat=\"area in $root.wc.location\"><div class=\"area\" data-ng-click=\"$root.temporalElement(area.name.es, area.image);$root.stateGo(\'contact-selected\', {lan: $root.language, id:area.id})\"><div class=\"image-background\"><div class=\"image\" data-ng-style=\"{\'background\': \'url(\' + $root.api+area.image + \')\'}\"></div></div><div class=\"legend wow fadeIn\" data-wow-delay=\".2s\"><p class=\"area-legend\">{{area.name}}</p></div></div></div></div></div>");
$templateCache.put("app/views/pages/main.html","<div class=\"row\" customheight=\"\" data-ng-if=\"$root.wc\"><ng-include data-src=\"\'app/views/header.html\'\"></ng-include><ng-include data-src=\"\'app/views/modals/modalcontact.html\'\"></ng-include><div class=\"home-wrapper\" customheight=\"\"><ng-owl-carousel class=\"owl-theme home-slide\" owl-items=\"$root.wc.webhomecarousel\" owl-properties=\"$root.homeOwlConf\" owl-ready=\"$root.ready($api)\"><div class=\"image\" customheight=\"\" data-ng-style=\"{\'background\': \'url(\' + $root.api + item.image + \')\'}\" data-ng-repeat=\"item in $root.wc.webhomecarousel\"><div class=\"home-box\" customheight=\"\" minus=\"200\"><h1 data-wow-delay=\".4s\" class=\"wow fadeIn\">{{$root.transl(item.title)}}</h1><a data-ng-click=\"$root.showModal(\'modalarea\')\" data-wow-delay=\".4s\" class=\"wow fadeIn button button--antiman\">{{$root.transl($root.uiText.home.cta)}}</a></div></div></ng-owl-carousel><ul class=\"home-city-info\"><li data-ng-repeat=\"city in $root.wc.location\" data-ng-click=\"$root.stateGo(\'contact-selected\', {lan: $root.language, id:city.id})\">{{city.name}}</li></ul></div></div>");
$templateCache.put("app/views/pages/news-selected.html","<div class=\"row\" customheight=\"\"><ng-include data-src=\"\'app/views/header.html\'\"></ng-include><ng-include data-src=\"\'app/views/modals/modalcontact.html\'\"></ng-include><div class=\"sm-wrapper\"><div class=\"wrapper left\"><div class=\"wrapper-body\" wleft=\"\" sec=\"$root.wc\"></div></div><div class=\"wrapper right\"><div class=\"wrapper-body\" wright=\"\" sec=\"$root.wc\"></div></div></div></div>");
$templateCache.put("app/views/pages/news.html","<div class=\"row\" customheight=\"\" data-ng-if=\"$root.wc\"><ng-include data-src=\"\'app/views/header.html\'\"></ng-include><ng-include data-src=\"\'app/views/modals/modalcontact.html\'\"></ng-include><div class=\"area-wrapper fullpage\"><div class=\"col-xs-12\"><h1 class=\"page-title active short\">{{$root.transl($root.wc.webroute[5].url)}}</h1><div class=\"btn-group btn-group-filter\" dropdown=\"\" is-open=\"$root.isopen3\"><button id=\"single-button\" type=\"button\" class=\"btn btn-primary\" dropdown-toggle=\"\">{{ ($root.cf.title!=\'\')?$root.transl(cf.title):$root.transl($root.uiText.news.cat) }} <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\" data-ng-repeat=\"context in $root.wc.webcontext\"><a href=\"#\" data-ng-click=\"$root.setCf(context)\">{{$root.transl(context.title)}}</a></li></ul></div></div><div class=\"area-box\" data-ng-if=\"(!$root.cf.id || $root.cf.id && area.webcontext_id == $root.cf.id ) && area.webroute_id == 6\" data-ng-repeat=\"area in $root.wc.websection\"><div class=\"area\" data-ng-click=\"$root.temporalElement(area.name.es, area.image);$root.stateGo(\'news-selected\', {lan: $root.language, id:area.id})\"><div class=\"image-background\"><div class=\"image\" data-ng-style=\"{\'background\': \'url(\' + $root.api+area.image + \')\'}\"></div></div><div class=\"legend news wow fadeIn\" data-wow-delay=\".2s\"><p class=\"area-legend\">{{$root.transl(area.title)}}</p><p class=\"area-occupation\">{{area.published_at}}</p><p class=\"area-city\">{{$root.transl(area.webcontext.title)}}</p></div></div></div></div></div>");
$templateCache.put("app/views/pages/professionals.html","<div class=\"row\" customheight=\"\" data-ng-if=\"$root.wc\"><ng-include data-src=\"\'app/views/header.html\'\"></ng-include><ng-include data-src=\"\'app/views/modals/modalcontact.html\'\"></ng-include><div class=\"area-wrapper fullpage\"><div class=\"page-title-box\"><h1 class=\"page-title active short\">{{$root.transl($root.wc.webroute[3].url)}}</h1><div class=\"btn-group btn-group-filter\" dropdown=\"\" is-open=\"$root.isopen3\"><button id=\"single-button\" type=\"button\" class=\"btn btn-primary\" dropdown-toggle=\"\">{{ ($root.cf.title!=\'\')?$root.transl(cf.title):$root.transl($root.uiText.proffesional.cat) }} <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\" data-ng-repeat=\"context in $root.wc.webcontext\"><a href=\"#\" data-ng-click=\"$root.setCf(context)\">{{$root.transl(context.title)}}</a></li></ul></div></div><div class=\"area-box\" data-ng-if=\"(!$root.cf.id || $root.cf.id && area.webcontext_id == $root.cf.id) && area.webroute_id == 4\" data-ng-repeat=\"area in $root.wc.websection\"><div class=\"area\" data-ng-click=\"$root.temporalElement(area.name.es, area.image2, \'Socio\', \'La Paz\');$root.stateGo(\'profile-selected\', {lan: $root.language, id:area.id})\"><div class=\"image-background\"><div class=\"image\" data-ng-style=\"{\'background\': \'url(\' + $root.api+area.image + \')\'}\"></div></div><div class=\"legend\"><p class=\"area-legend\">{{$root.transl(area.title)}}</p><p class=\"area-occupation\">{{$root.transl(area.tag)}}</p><p class=\"area-city\">{{$root.transl(area.webcontext.title)}}</p></div></div></div></div></div>");
$templateCache.put("app/views/pages/profile-selected.html","<div class=\"row\" customheight=\"\"><ng-include data-src=\"\'app/views/header.html\'\"></ng-include><ng-include data-src=\"\'app/views/modals/modalcontact.html\'\"></ng-include><div class=\"sm-wrapper\"><div class=\"wrapper left\"><div class=\"wrapper-body\" wleft=\"\" sec=\"$root.wc\"></div></div><div class=\"wrapper right\"><div class=\"wrapper-body\" wright=\"\" sec=\"$root.wc\"></div></div></div></div>");
$templateCache.put("app/scripts/directives/wleft/wleft.html","<div class=\"left-box {{sec.class}}\"><div class=\"image-box\" data-ng-if=\"$root.secPicked\"><img data-ng-src=\"{{$root.api+$root.secPicked.image2}}\" alt=\"\"></div></div>");
$templateCache.put("app/scripts/directives/wright/wright.html","<div windowheight2=\"\" class=\"right-box {{sec.class}}\" data-ng-if=\"$root.secPicked\"><div class=\"article\"><div class=\"content\"><h1 class=\"sec-title\">{{$root.transl($root.secPicked.title) }}</h1><p class=\"sec-tags\">{{$root.transl($root.secPicked.tag)}}</p><p class=\"sec-tags\" data-ng-if=\"$root.secPicked.published_at != \'0000-00-00\'\">{{$root.secPicked.published_at}}</p><p class=\"sec-legend\">{{$root.transl($root.secPicked.webcontext.title)}}</p></div></div><div class=\"article\" data-ng-repeat=\"sub in $root.secPicked.websectiondata\"><div class=\"content\" data-ng-if=\"sub.type==0\"><div data-ng-bind-html=\"$root.transl(sub.content)\"></div></div><div class=\"row\" data-ng-if=\"sub.type==1\"><div class=\"col-xs-12\"><img style=\"display: block;max-width: 100%;margin: auto\" ng-src=\"{{ $root.api+sub.image }}\" alt=\"\"></div></div><div class=\"video\" data-ng-if=\"sub.type==2\" style=\"margin-bottom: 20px\"><div class=\"video\" my-youtube=\"\" code=\"sub.link\"></div></div><div class=\"slider\" data-ng-if=\"sub.type==3\"><ng-owl-carousel class=\"owl-theme gallery-wrapper\" owl-items=\"sub.websectiondataitem\" owl-properties=\"$root.defaultOwlConf\" owl-ready=\"$root.ready($api)\"><div class=\"gallery-item\" data-ng-repeat=\"item in sub.websectiondataitem\"><img ng-src=\"{{ $root.api+item.image }}\" alt=\"\"></div></ng-owl-carousel></div><div class=\"row\" data-ng-if=\"sub.type==4\"><div class=\"col-xs-12\" style=\"margin-bottom: 60px\"><accordion close-others=\"false\"><div accordion-group=\"\" data-ng-repeat=\"subitem2 in sub.websectiondataitem\" class=\"panel-default panel-profile\" is-open=\"faq.status[$index].open\"><accordion-heading>{{$root.transl(subitem2.title)}} <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': faq.status[$index].open, \'glyphicon-chevron-right\': !faq.status[$index].open}\"></i></accordion-heading><p data-ng-bind-html=\"$root.transl(subitem2.content)\"></p></div></accordion></div></div></div></div>");}]);